<script>
import axios from "axios";
import CustomDialogHeader from "@/components/CustomDialogHeader.vue";
import ActivityPlayerItem from "@/components/ActivityPlayerItem/index.vue";
// 定义常量提高代码可读性
const FREQUENCY_TYPE = {
  DAILY: [3, 4, 5, 7], // 日维度类型
  WEEKLY: [2, 6], // 周维度类型
  MONTHLY: 1, // 月维度类型
};

const TIME_RANGE_INDEX = {
  TODAY: 0,
  YESTERDAY: 1,
  CUSTOM: 2,
};

const d = new Date();
const year = d.getFullYear();
let month = d.getMonth() + 1;
month = month < 10 ? `0${month}` : month;
const date = d.getDate();

// import '@/assets/jlFonts/iconfont.css';

import infiniteScroll from "vue-infinite-scroll";
import appConfig from "@/app.config";
import DatePicker from "@/components/DatePicker.vue";
// import CustomCalendar from '@/components/CustomCalendar.vue';
// CustomCalendar
import {
  activityDetail,
  addBrowseHistory,
  clockNameListByName,
  delActivity,
  delSignListComment,
  delSignOrder,
  delthumbsUp,
  earlyTermination,
  getActivityCode,
  getNewVideoPathUrl,
  getProjectManageAdmin,
  getShareLink,
  getSignListComment,
  getSignListMore,
  restartActivity,
  SignListComment,
  signDel,
  sleDetails,
  startImmediately,
  thumbsUp,
  updatecommentlanguage,
  updateScore,
  updateSignInfo,
  handleUnreadOrderCount,
} from "@/utils/api/activity";
import { imageUrl } from "@/utils/config/commonUrl.js";
import copyrightConfig from "@/utils/config/changeCopyright.js";
import serverConfig from "@/utils/config/index.js";
import Layout from "../../layouts/main";

export default {
  directives: { infiniteScroll },
  page() {
    // 动态生成标题
    const title =
      this.activityDetail && this.activityDetail.name
        ? `${this.activityDetail.name} - 接龙详情`
        : `接龙详情`;

    return {
      title: title,
      meta: [{ name: "description", content: appConfig.description }],
    };
  },
  components: { Layout, DatePicker, CustomDialogHeader, ActivityPlayerItem },
  data() {
    return {
      copyrightConfig, // Add copyrightConfig to make it reactive
      videoUrlCache: new Map(), // 视频地址缓存
      showMask: false, // 控制遮罩层的显示状态
      isDatePickerVisible: false,
      selectedDate: null,
      datePickerType: "",
      datePickerMinDate: "",
      datePickerMaxDate: "",
      allowLoadMore: false, // 添加标志位
      manageDialogVisible: false,
      manageTip: "",
      manageTitle: "",
      codeUrl: "",
      customerServiceDialogVisible: false,
      customerServiceQrcodeSrc:
        copyrightConfig.AppID === "wx1e899bddb256a5ca"
          ? "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/jljj_kf_new.png"
          : "https://ossfastmake.mustke.com//12jielong/bdJL/bmkfblue.png",
      calendarShow: false, // 控制日历显示的状态
      shareTypeNew: false,
      morePop: false,
      isDel: false,
      setBoxShow: false,
      setInfo: {},
      activityDetail: {},
      thumbsUpId: 0,
      thumbsUpNumber: 0,
      scoreTypelist: [
        {
          name: "ABC打分",
        },
        {
          name: "分数打分",
        },
        {
          name: "优良打分",
        },
        {
          name: "自定义打分",
        },
      ],

      scoreBoxShow: false,
      scoreType: 0,
      score: null,
      ABCScore: ["A+", "A", "B", "C", "D", "D-"],
      excellentScore: ["优+", "优", "良", "中", "差", "很差"],
      addcomment: "",
      comment: "",
      commentBoxShow: false,
      remarkBoxShow: false,
      sortArr: [
        {
          choose: 1,
          name: "允许他人查看",
        },
        {
          choose: 2,
          name: "不允许他人查看",
        },
        {
          choose: 3,
          name: "已评分",
        },
        {
          choose: 4,
          name: "未评分",
        },
      ],
      classArr: [
        {
          sortType: 1,
          name: "时间倒序",
        },
        {
          sortType: 2,
          name: "时间正序",
        },
        {
          sortType: 3,
          name: "姓名排序",
        },
      ],
      bannIndex: 0,

      index: 0,
      joinUserNum: 1, //参加报名人数
      // fmSignListId:'',
      leavemessage: "",

      signId: "",
      name: "",
      mSelect: [],
      isOtherPeople: 3, // 1=创建者、2=管理员、3=普通用户

      orderId: "",
      placeholderText1: "",
      placeholderText2: "",
      placeholderText3: "",
      videoPlay: false, //视频播放
      // 滚动容器高度
      scrollHeight: "",

      defaultDateMultiple: [`${year}-${month}-${date}`],
      minDateMultiple: `${year}-${month}-${date - 30}`,
      maxDate: `${year}-${month}-${date - 30}`,
      monthNum: 3,
      zhanKai: true,
      isShowLoading: false,
      isTemplate: "", //是否通过模板进来
      templatePage: "", //1通过模板进来 2或者空不是从模板进入的
      isType: "", //活动类型
      isStop: "",
      clockLocationStatus: false, //是否在打卡范围内
      cardReplacementsNumber: "", //剩余打卡次数
      cardReplacementsNumberFlag: "",
      clockInfo: {
        clockLocationInfo: {},
      }, //打卡信息
      clockNameList: [], //接龙名单
      projectVos: [], //活动项目集合
      isClick: true,
      locationObj: {}, //获取当前位置信息
      imageUrl2: "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/",
      anonymousHeadUrl:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-niming.png",
      activityId: "",
      dateValue: "",
      selectType: "",
      modular: [],
      signField: [],
      signList: [],
      signNum: 0,
      commentList: [],
      pageNum: 0,
      pageSize: 10,
      memberId: 0,
      authInformation: {},
      mySignInfo: {
        id: "",
      },
      // 留言弹窗
      isShowMess: false,
      //留言内容
      commentContent: "",
      commentId: "",
      innerAudioContext: "",
      video: null,
      iconFiexd: false,
      DisappearShow: false,
      title: 1,
      msgText: "",
      shareShow: false,
      menuButtonInfo: "", //导航胶囊位置信息
      posterPath: "",

      signInfo: [],
      shareType: false, //分享弹窗
      sharePYQ: false, //分享朋友圈提示图片
      isShowT0: false,
      ShowBill: false,
      redBaob: 1,
      bdNewwode: this.imageUrl + "/static/newTwo/redbaoB.png",
      redShowdiv: 1, //控制弹窗红包是否显示

      billUrl: "",
      posterUrl: "", //返回时的弹窗分享图
      posternormal: "", //其他分享图
      onlyshareimg: "", //上一页报名返回的分享图
      base64Head: "data:image/png;base64,",

      ewmImg: "", //活动二维码
      fmSignListId: "", //页面传递回来的分组id、
      copyUrl: "",
      optionsscene: "", //小程序场景值
      shareImgClone: "/static/share/admin_pic16696994024988.jpg",
      detailNumber: 1,
      coverImgH: "",
      sharefriendpic: "",
      mySignInfoId: "",
      covers: [],
      logoImg: "static/newImg/jieLong.png",
      pageType: "",
      address_is_allowed: true,
      cancelSignInfo: "活动终止前",
      signlength: 0,
      msgSeeMoreShow: false,
      memberPopShow: false,
      memberPopTitle: "提示",
      memberPopContent: "邀请您成为管理员",
      invite: "", // 1 展示邀请弹框
      projectAdminList: [], // 管理员列表
      managePopShow: false,
      delactPopShow: false,
      delactPopTitle: "提示",
      delactPopContent: "确定删除？",
      earlyPopShow: false,
      earlyPopTitle: "提示",
      earlyPopContent: "是否提前结束？",
      is_draft: "3",
      tosignClick: false,
      zkgd: true,
      zkgdState: true,
      zkxqIsShow: false,
      isHidden: false,
      hiddenBtn: "",
      isReady: true, //骨架屏
      crPopShow: false,
      crPopTitle: "提示",
      crPopContent: "是否提前取消？",
      commActiveState: "",

      resetPopShow: false,
      resetPopTitle: "提示",
      resetPopContent: "是否立即重启？",

      quicklyStartPopShow: false,
      quicklyStartPopTitle: "提示",
      quicklyStartPopContent: "是否立即重启？",

      saveVideoPopShow: false,
      saveVideoPopTitle: "提示",
      saveVideoPopContent: "是否保存视频到相册",
      touchStartTime: 0,
      longPressThreshold: 500, // 长按的阈值，单位是毫秒
      saveVideoUrl: "",
      active_state: "2",
      clockFrequencyType: "99",
      weekChineseNumbers: ["一", "二", "三", "四", "五", "六", "日"],

      saveAudioUrl: "",
      saveAudioPopShow: false,
      saveAudioPopTitle: "提示",
      saveAudioPopContent: "是否保存音频到手机",
      // touchStartTime: 0,
      // longPressThreshold: 500 ,// 长按的阈值，单位是毫秒
      is_template: "",
      shown: false,
      isAd: true,
      unitId: "",
      plugScreenUnitId: "",
      addVideoUnitid: "",
      bannerUnitId: "",
      totalRow: "",
      registraList: [],
      pllist: [],
      choose: "",

      // 视图模式：1 列表模式，2 头像模式
      dataSchema: 1,
      viewModePageSize: 20, // 头像模式每页加载 20 条
      listModePageSize: 10, // 列表模式每页加载 10 条
      orderUnreadSum: 0, // 订单未读数量
      sortType: 1,

      // 抽屉弹窗相关
      playerDrawerOpen: false, // 抽屉打开状态
      playerDrawerData: null, // 抽屉中显示的参与者数据
      updateName: "", //取消报名时用的
      getSignListByActivityData: "",
      timeSort: 3,
      timePickerArr: [["今天", "昨天", "自定义选择日期"]],
      timePickerShow: false,
      notregistered: [], //未报名人员列表
      registerednum: 0, //已报名人数
      solitairenName: "", // 名单搜索参数
      chargeItemList: [], // 收费项列表
      signupCalendarShow: false,
      dksignupCalendarShow: false,
      calendar: {
        minDate: "",
        maxDate: "",
        defaultDate: "",
        monthNum: 100,
      },
      dktimePickerShow: false,

      dktimePickerArr: [
        {
          name: "今天",
          index: 0,
        },
        {
          name: " 昨天",
          index: 1,
        },
        {
          name: "自定义选择日期",
          index: 2,
        },
      ],

      dktimeChangeIndex: 0,
      timeChangeIndex: 0,
      cloneClocknameLength: 0,
      cloneregistralength: 0,
      isDelOrder: "", // 修改填表项的话传1，不修改不传
      clockNameListTemp: [
        {
          clockNameStatus: 0,
          clockName: "李娜",
        },
        {
          clockNameStatus: 0,
          clockName: "张伟豪",
        },
        {
          clockNameStatus: 0,
          clockName: "王芳怡",
        },
        {
          clockNameStatus: 0,
          clockName: "赵雷宇",
        },
        {
          clockNameStatus: 0,
          clockName: "刘洋然",
        },
        {
          clockNameStatus: 0,
          clockName: "陈静轩",
        },
        {
          clockNameStatus: 0,
          clockName: "杨阳彤",
        },
        {
          clockNameStatus: 0,
          clockName: "杨阳彤",
        },
        {
          clockNameStatus: 0,
          clockName: "吴昊轩",
        },
        {
          clockNameStatus: 0,
          clockName: "徐婷萱",
        },
        {
          clockNameStatus: 0,
          clockName: "郑洁思",
        },
        {
          clockNameStatus: 0,
          clockName: "孙浩宇轩",
        },
        {
          clockNameStatus: 0,
          clockName: "黄磊明",
        },
        {
          clockNameStatus: 0,
          clockName: "高婷怡",
        },
        {
          clockNameStatus: 0,
          clockName: "郭阳文",
        },
        {
          clockNameStatus: 0,
          clockName: "曹颖欣",
        },
        {
          clockNameStatus: 0,
          clockName: "高婷怡",
        },
        {
          clockNameStatus: 0,
          clockName: "谢飞杰",
        },
        {
          clockNameStatus: 0,
          clockName: "韩雪琪",
        },
        {
          clockNameStatus: 0,
          clockName: "唐宁远",
        },
        {
          clockNameStatus: 0,
          clockName: "马超然",
        },
        {
          clockNameStatus: 0,
          clockName: "朱晓萱",
        },
        {
          clockNameStatus: 0,
          clockName: "胡志豪",
        },
        {
          clockNameStatus: 0,
          clockName: "林嘉怡",
        },
        {
          clockNameStatus: 0,
          clockName: "罗思远",
        },
        {
          clockNameStatus: 0,
          clockName: "梁伟杰",
        },
        {
          clockNameStatus: 0,
          clockName: "许静彤",
        },
        {
          clockNameStatus: 0,
          clockName: "邓浩宇",
        },
        {
          clockNameStatus: 0,
          clockName: "冯文轩",
        },
        {
          clockNameStatus: 0,
          clockName: "程梓萱",
        },
      ],
      showModal: false,
      disjunctor: true, // 防止连点
      groupId: "",
      selectedMonth: {
        year: new Date().getFullYear(),
        month: new Date().toLocaleString("default", {
          month: "long",
        }),
      },
      // selectedDate: "2024-03-18", // 默认选中日期
      weekMaxDate: "2050-12-31",
      defaultWeekDate: `${year}-${month}-${date}`,
      monthShow: false,
      weekPicker: false,
      pages: 1,
      registraListTotal: "",
      registraPageNum: 1,
      registrapages: 1,
      hasMore: true,
      loading: false, // infinite-scroll 加载状态
      isLoading: false, // 加载状态
      windowHeight: 0, // 页面可视高度
      downOption: {
        auto: false, //是否在初始化后,自动执行downCallback; 默认true
      },
      upOption: {
        auto: false,
      },
      mescroll: "",
      is_scroll_div: false,
      loadingFlag: false,
      loadingFinished: false,
      filterType: 1, //1名单2报名列表
      nodataFinished: false,
      showResetButton: false,
      locateIt: false, // 是否去定位
      is_destination: 0, // 是否开启指定位置 1开 0关
      isSearch: false,
      isButtonClicked: false, // 防止连点
      filterArrShow: false,
      filterClockNameList: [],
      phbImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/paihangbang1.png",

      shareImg1:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-pyq.svg",
      shareImg2:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-erweima.svg",
      shareImg3:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-gzh.svg",
      shareImg4:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-fxhb.svg",
      shareImg5:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-wx.svg",
      shareImg6:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-sclj.svg",
      shareImg7:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-zdyfx.svg",
      showCommentCount: 2, // 默认显示的评论数量
      commentStep: 5, // 每次加载的评论数量
      isLastPage: false, // 是否已经加载到最后一页
      plpageNum: 1,
      commentPageNums: {}, // 存储每个对象的当前页码
      commentPageNumbers: {}, // 存储每个报名对象的评论页码
      commentStates: {
        totalRow: "",
      },
      nameAddType: "", // 判断是姓名还是分组
      packetData: [], // 展示再页面的分组数据
      pickerName: "全部",
      pickerNameSelectShow: false,
      pickerNameSelectArr: [], // 中间值
      nameListLength: 0, // 名单人数
      filteredArr: [],

      manageImgSrc1:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-bianji.svg",
      manageImgSrc2:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-guanliyuan.svg",
      manageImgSrc3:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-tiqianjieshu.svg",
      manageImgSrc4:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-tiqianjieshu.svg",
      manageImgSrc5:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-tiqianjieshu.svg",
      manageImgSrc6:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/manage-buka.svg",
      manageImgSrc7:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-fuzhi.svg",
      manageImgSrc8:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/m-share1.svg",
      manageImgSrc9:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/25_trash.svg",
      manageImgSrc10:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/manage-buka.svg",
      manageImgSrc11:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-daochu.svg",
      manageImgSrc12:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/25_shujutongji.svg",
      manageImgSrc13:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/25_zhuanrang.svg",
      manageImgSrc14:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-copyBtn.svg",
      manageImgSrc15:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/sct-shareBtn.svg",
      qunliaoImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/qunliao.png",
      firstDontGo: true,
      chatNumTimer: null, //获取群聊消息数量定时器
      fromBatchDraw: false, // 是否从批图页面返回
      batchDrawOrderId: null, // 批图页面返回的填表项ID
      isInFolder: 1, // 是否在文件夹内 默认 1 否 2 是
      folderId: "", // 文件夹ID
      dontGo: false,
      turnShareTitle: "您的好友转让了一条接龙给您，点击成为发布人",
      turnShareImg:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/becameBuilder.png",
      turnSharePath:
        "/pages/solataireGroupDetails/solataireGroupDetails?id=" +
        this.activityId +
        "&selectType=see" +
        "&isType=" +
        this.isType +
        "&masterID=" +
        this.memberId,
      isTurnTo: 2, // 2 不是转让 1 转让
      masterID: "",
      selectOptionShow: false,
      selectOptionList: [
        {
          name: "下载到微信",
        },
      ],
      commonFileUrl: "",
      commonLastName: "",
      commonFileName: "",
      selectedPickerName: "",
      activeTab: 0,
      isPageLoaded: false,
      clockListNumber: 5, // 一行展示多少个参与名单 2一排两个 1一排三个，以此类推

      isBoFang: false,
      checkInStatusSwitch: 1, // 1创建者管理员可见2所有人可见
      isShowSignStatus: 99, // 1-显示 2-隐藏
      clockSwitch: 1, // 默认1关闭2开启.
      activityKey: "",

      // 分享相关属性
      dialogVisible: false,
      shareTitle: "",
      JumpUrl: "",
      faceUrl: "",
      shareChange: "下载接龙二维码",
      appid: "wx1234567890abcdef", // 小程序ID
      isAcive: "嵌入到公众号",
      imageUrl: imageUrl,
      vid: "",
      playUrl: "",
      playCoverImage: "",
      subCoverImages: [],
      isVideo: 2,
      isCoverEnabled: 1,
      testHeight: "568rpx", //轮播图初始高度  452
      swiperH: [], //轮播图片高度数据
      swiperIndex: 0, //轮播当前所选序列
      turnPictures: [], // 轮播图
      indicatorDots: true,
      autoplay: true,
      duration: 500,
      activityModeUrl: "",
      contactType: 1, // 1-手机号 2-微信号 3-手机号和微信同号
      connectBoxShow: false,
      contactTypeText: "手机号",
      signDataScreenBoxShow: false,
      DataScreenUrl: "",
      key: "", //数据大屏访问密码
      browserList: [],
      photoShow: false,
      photoUrl: "",
      // 二维码 Logo 自定义相关
      logoText: "",
      logoTextDisplay: "",
      selectedColorIndex: -1, // 默认不选中任何颜色
      defaultLogoColor: "#133BBE", // 默认模式的背景颜色
      agreementChecked: false,
      logoColors: [
        "#C72827",
        "#EF6C00",
        "#F9A824",
        "#00695C",
        "#568C2E",
        "#1465C0",
        "#4626A1",
      ],
      showCustomInput: false, // 是否显示自定义输入框
      canvasCodeUrl: "", // Canvas 使用的二维码 URL
      logoButtons: [], // 动态按钮列表
      defaultLogoText: "", // 默认 Logo 文字
      isDefaultMode: true, // 是否是默认模式（不显示中心圆形 Logo）
    };
  },
  async mounted() {
    await this._getActivityInfo();
    //  this._currentUsage()
    this.allowLoadMore = true;
    this.isPageLoaded = true;
    // 添加滚动监听
    window.addEventListener("scroll", this.handleScroll);
    // 如果活动类型是 101，获取订单数量
    if (this.isType == "101") {
      this.getOrderCount();
    }
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  // watch: {
  //     '$route.query.activityId': function(newVal, oldVal) {
  //         if (newVal !== oldVal) {
  //             this._getActivityInfo();
  //             this.registraList = [];
  //             this.pllist = [];
  //             this.registraPageNum = 1;
  //             this.plpageNum = 1;
  //             this.allowLoadMore = true;
  //         }
  //     }
  // },
  computed: {
    setMb() {
      return (size, fileType) => {
        if (size == "") {
          return "";
        } else {
          const infoSize = size / 1048576;
          if (
            fileType == "mp3" ||
            fileType == "MP3" ||
            fileType == "Mp3" ||
            fileType == "mP3"
          ) {
            return "音频大小：" + Math.floor(infoSize) + "MB";
          } else if (
            fileType == "mp4" ||
            fileType == "MP4" ||
            fileType == "Mp4" ||
            fileType == "mP4"
          ) {
            return "视频大小：" + Math.floor(infoSize) + "MB";
          } else {
            return "大小：" + Math.floor(infoSize) + "MB";
          }
        }
      };
    },
    setKb() {
      return (size, fileType) => {
        if (size == "") {
          return "";
        } else if (size == 0) {
          return "大小：" + 0 + "KB";
        } else {
          const infoSize = size / 1024;
          if (
            fileType == "mp3" ||
            fileType == "MP3" ||
            fileType == "Mp3" ||
            fileType == "mP3"
          ) {
            return "音频大小：" + Math.floor(infoSize) + "KB";
          } else if (
            fileType == "mp4" ||
            fileType == "MP4" ||
            fileType == "Mp4" ||
            fileType == "mP4"
          ) {
            return "视频大小：" + Math.floor(infoSize) + "KB";
          } else {
            return "大小：" + Math.floor(infoSize) + "KB";
          }
        }
      };
    },
    setB() {
      return (size, fileType) => {
        if (size == "") {
          return "";
        } else if (size == 0) {
          return "大小：" + 0 + "B";
        } else {
          const infoSize = size;
          if (
            fileType == "mp3" ||
            fileType == "MP3" ||
            fileType == "Mp3" ||
            fileType == "mP3"
          ) {
            return "音频大小：" + Math.floor(infoSize) + "B";
          } else if (
            fileType == "mp4" ||
            fileType == "MP4" ||
            fileType == "Mp4" ||
            fileType == "mP4"
          ) {
            return "视频大小：" + Math.floor(infoSize) + "B";
          } else {
            return "大小：" + Math.floor(infoSize) + "B";
          }
        }
      };
    },
    seconde() {
      return (time) => {
        const s = parseInt(Number(time) / 1000);
        const ss = parseInt((Number(time) - s * 1000) / 100);
        return s + "." + ss + "s";
      };
    },
    //过滤星期
    // formattedDays() {
    //     if(this.clockInfo.clockFrequency){
    //         const daysMap = ['周一', '周二', '周三', '周四', '周五', '周六','周日'];
    //         // 分割字符串并转换为数字，过滤无效值
    //         const days = this.clockInfo.clockFrequency.split(',')
    //             .map(num => Number(num.trim()))
    //             .filter(num => num >= 0 && num <= 6);
    //         // 转换为星期并拼接成字符串
    //         return days.map(num => daysMap[num]).join(', ');
    //     }

    // },
    // 按拼音排序后的名单（用于显示）
    sortedClockNameList() {
      if (!this.activityDetail.nameSortSwitch) {
        return this.clockNameList;
      }
      return [...this.clockNameList].sort((a, b) =>
        (a.clockName || "").localeCompare(
          b.clockName || "",
          "zh-Hans-CN-pinyin",
          { numeric: true },
        ),
      );
    },
    // 按拼音排序后的搜索名单（用于显示）
    sortedFilterClockNameList() {
      if (!this.activityDetail.nameSortSwitch) {
        return this.filterClockNameList;
      }
      return [...this.filterClockNameList].sort((a, b) =>
        (a.clockName || "").localeCompare(
          b.clockName || "",
          "zh-Hans-CN-pinyin",
          { numeric: true },
        ),
      );
    },
    // 二维码下载是否可用
    canDownload() {
      // 默认模式不需要勾选协议，其他模式需要勾选
      if (this.isDefaultMode) {
        return true;
      }
      return this.agreementChecked;
    },
  },
  methods: {
    // 打开参与者详情抽屉
    openPlayerDrawer(item) {
      this.playerDrawerData = item;
      this.playerDrawerOpen = true;
    },
    // 关闭参与者详情抽屉
    closePlayerDrawer() {
      this.playerDrawerOpen = false;
      this.playerDrawerData = null;
    },
    seeBigImg(val) {
      if (!val) {
        return;
      }
      this.photoUrl = val;

      this.photoShow = true;
      console.log(this.photoUrl, " this.photoUrl this.photoUrl");
    },

    async _currentUsage(activityKey) {
      try {
        const result = await axios({
          url: `${serverConfig.baseURL}/screen/getUserUrl`,
          method: "GET",
          // 核心：仅本次请求添加 alias 头
          headers: {
            "Content-Type": "application/json",
            appId: copyrightConfig.AppID,
            alias: activityKey,
            "Access-Token": localStorage.getItem("token") || "",
          },
        });

        // 业务逻辑处理
        if (result.data.status == 1) {
          this.browserList = [
            {
              ip: result.data.data.ip,
              browserName: result.data.data.browserName,
            },
          ];
        } else {
          console.log(result.data, "fjeojfosejfo");
        }
      } catch (error) {
        console.error("获取用户信息失败:", error);
      }
    },
    // 下线
    offline(i) {
      this.commIndex = i;
      this.$confirm("确定下线？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this._offlineUsers();
        })
        .catch(() => {});
    },
    // 下线用户
    async _offlineUsers() {
      try {
        const result = await axios({
          url: `${serverConfig.baseURL}/screen/offlineUsers`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            appId: this.appid,
            alias: this.activityDetail.activityKey,
            "Access-Token": localStorage.getItem("token") || "",
          },
        });
        if (result.data.status == 1) {
          this.$message.success("下线成功");
          this.browserList = [];
          this._currentUsage();
        }
      } catch (error) {
        console.error("下线失败：", error);
      }
    },
    async _getAccessKey(alias) {
      console.log("看看执行没_getAccessKey");
      try {
        const result = await axios({
          url: `${serverConfig.baseURL}/screen/getAccessKey`,
          method: "POST",
          data: {
            url: this.codeUrl,
            name: this.activityDetail.name,
            appId: copyrightConfig.AppID,
          },
          // 核心：仅本次请求添加 alias 头
          headers: {
            "Content-Type": "application/json",
            appId: copyrightConfig.AppID,
            alias: alias,
            "Access-Token": localStorage.getItem("token") || "",
          },
        });
        console.log(result, "result");
        // 业务逻辑处理
        if (result.data.status == 1) {
          console.log(result, "访问秘钥");
          this.key = result.data.msg;
          this.signDataScreenBoxShow = true;
        }
      } catch (error) {
        console.error("获取AccessKey失败：", error);
      }
    },

    // 自动加载所有视频字段的视频地址
    async autoLoadVideos() {
      // 收集所有需要加载的视频字段
      const videoFields = [];
      this.registraList.forEach((item) => {
        if (item.sign_info && Array.isArray(item.sign_info)) {
          item.sign_info.forEach((fieldItem) => {
            // 检查是否为视频字段且没有视频地址
            if (
              fieldItem.type == 6 &&
              fieldItem.vid &&
              fieldItem.value &&
              (!fieldItem.videoUrl || fieldItem.videoUrl === "") &&
              !fieldItem.videoLoading
            ) {
              videoFields.push(fieldItem);
            }
          });
        }
      });

      if (videoFields.length > 0) {
        const batchSize = 3; // 每批最多3个
        for (let i = 0; i < videoFields.length; i += batchSize) {
          const batch = videoFields.slice(i, i + batchSize);
          await Promise.allSettled(
            batch.map((fieldItem) => this._getVideoUrlForField(fieldItem)),
          );
          if (i + batchSize < videoFields.length) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        }
      }
    },

    // 为字段项获取视频地址
    async _getVideoUrlForField(fieldItem) {
      console.log(fieldItem, "fieldItem");

      if (!fieldItem.vid || !fieldItem.value) {
        this.$set(fieldItem, "videoLoading", false);
        return "";
      }

      try {
        const videoUrl = await this._getNewVideoPathUrl(
          fieldItem.vid,
          fieldItem.value,
        );
        // 更新字段项的 videoUrl 属性
        this.$set(fieldItem, "videoUrl", videoUrl);
        this.$set(fieldItem, "videoLoading", false);
        return videoUrl;
      } catch (error) {
        console.error("获取视频地址失败:", error);
        this.$set(fieldItem, "videoLoading", false);
        throw error; // 重新抛出错误，让调用方处理
      }
    },
    async _getNewVideoPathUrl(vid, value) {
      // 检查缓存
      const cacheKey = `${vid}_${value}`;
      if (this.videoUrlCache.has(cacheKey)) {
        return this.videoUrlCache.get(cacheKey);
      }

      try {
        const result = await getNewVideoPathUrl({
          vid: vid,
          address: value,
        });
        if (result.status === 1 && result.msg) {
          // 缓存结果
          this.videoUrlCache.set(cacheKey, result.msg);
          return result.msg;
        } else {
          console.error("获取视频地址失败:", result);
          return "";
        }
      } catch (error) {
        console.error("获取视频地址异常:", error);
        return "";
      }
    },
    //添加浏览
    handleAddBrowseHistory() {
      addBrowseHistory({
        activityId: this.activityId, //活动id
        activityName: this.activityDetail.name,
        activityType: this.activityDetail.activityType,
      });
    },
    // 复制填表项
    copyFiled(sign_index, item) {
      // 定义目标类型集合
      const targetTypes = new Set([
        1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 13, 15, 19, 21, 22, 23, 24, 25, 26, 27,
        28, 29, 31, 32,
      ]);
      // 定义类型
      const fileType = 32; // 文件类型
      const audioType = 7; // 音频类型
      const videoType = 6; //视频类型
      const imageType = 5; // 图片类型
      const signatureType = 29; // 签名类型

      // 筛选并格式化数据
      const formattedItems = item
        .filter((item) => targetTypes.has(Number(item.type))) // 类型匹配
        .map((item) => {
          const type = Number(item.type);
          let fieldValue = item.value ? item.value : "无";
          // 处理文件类型（数组）：提取所有文件名，用逗号分隔
          if (type === fileType && Array.isArray(fieldValue)) {
            // 假设文件名存在于每个数组项的name字段
            const fileNames = fieldValue.map((file) => file.name || "未知文件");
            fieldValue = fileNames.join("，"); // 用中文逗号分隔多个文件
          }
          // 处理音频类型（对象）：提取音频名称
          if (
            type === audioType &&
            typeof fieldValue === "object" &&
            fieldValue !== null
          ) {
            fieldValue = fieldValue.name || "未知音频";
          }
          // 图片、签名、视频仅保留fieldName，不包含value
          if ([imageType, signatureType, videoType].includes(type)) {
            return `${item.fieldName}`;
          }
          return `${item.fieldName}:${fieldValue}`;
        });
      // .join("\n");
      const result = [`#${sign_index}`, ...formattedItems].join("\n");
      this.copyContent(result);
    },
    connectFn() {
      this.connectBoxShow = true;
    },
    // 删除
    dropdownDel(row) {
      if (row.active_state == 2) {
        this.$confirm("确定删除该活动吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delActivity({
              activityId: row.id,
            }).then((res) => {
              // console.log(res, "删除接口");
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              // 删除成功后跳转回记录页面
              this.$router.go(-1);
            });
          })
          .catch(() => {});
      } else {
        this.$confirm("是否立即结束当前活动，并删除活动？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            earlyTermination({
              id: row.id,
              is_it_over: 2,
              userId: localStorage.getItem("userID"),
            }).then((res) => {
              delActivity({
                activityId: row.id,
              }).then((res) => {
                // console.log(res, "删除接口9999");
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                // 删除成功后跳转回记录页面
                this.$router.go(-1);
              });
            });
          })
          .catch(() => {});
      }
    },
    // 复制
    dropdownCopy(row) {
      // console.log(row, "row");
      // 根据活动类型跳转到不同页面
      if (row.activity_big_type == 2) {
        // 通知公告类型
        const routeData = this.$router.resolve({
          path: "/groupNotification",
          query: {
            alias: row.activityKey,
            selectType: "add",
            isType: row.activity_type,
            copy: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (row.activity_type == 303) {
        // 特殊类型303，需要扫码编辑
        this.fetchActivityCode(row);
        this.manageDialogVisible = true;
        this.manageTitle = "复制";
        this.manageTip = "请扫码进入小程序复制活动";
      } else {
        // 通用接龙类型
        const routeData = this.$router.resolve({
          path: "/solitaire",
          query: {
            alias: row.activityKey,
            selectType: "add",
            isType: row.activity_type,
            copy: true,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },

    // 清空数据
    dropdownResetData(row) {
      // console.log(row, "row");
      this.$confirm(
        "确认清空全部参与记录吗？确认后将无法恢复，请谨慎操作。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        delSignOrder({
          activityId: row.id,
        })
          .then((res) => {
            // console.log(res, "清空接口");
            this.$message({
              type: "success",
              message: "成功!",
            });
            this.getSignListMore();
          })
          .catch(() => {});
      });
    },
    getFullImageUrl(path) {
      if (!path) return "";
      if (/^https?:\/\//.test(path)) {
        return path;
      }
      return this.imageUrl2 + path;
    },
    cancelSearch() {
      this.showMask = false; // 点击遮罩层时隐藏遮罩层
      this.dktimeChangeIndex = 0;
      this.timeChangeIndex = 0;
      this.isSearch = false;
      this.solitairenName = "";
      this.filterArrShow = false;
    },
    //签到码
    handleSignCode(row) {
      this.codeUrl = this.imageUrl + row.signInUrl;
      this.manageDialogVisible = true;
      this.manageTitle = "签到";
      this.manageTip = "请扫码进入小程序签到";
    },
    //签到数据大屏
    handleSignDataScreen(row) {
      this.fetchActivityCode(row, true); // 传递第二个参数标识是签到大屏
      this._currentUsage(row.activityKey);
      // this.signDataScreenBoxShow=true
      console.log(row);
    },

    handleVerify(row) {
      // 获取二维码
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "核销";
      this.manageTip = "请扫码进入小程序核销";
    },
    toPageStatistics(row) {
      const routeData = this.$router.resolve({
        path: "/dataStatistics?alias=" + row.activityKey,
      });
      window.open(routeData.href, "_blank");
    },
    setAdmin(row) {
      // 获取二维码
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "设置管理员";
      this.manageTip = "请扫码进入小程序邀请管理员";
    },
    openCustomerServiceDialog() {
      this.customerServiceDialogVisible = true;
    },
    closeCustomerServiceDialog() {
      this.customerServiceDialogVisible = false;
    },
    exportData(row) {
      const routeData = this.$router.resolve({
        path: "/exportDataPage?alias=" + row.activityKey,
      });
      window.open(routeData.href, "_blank");
    },
    handleOrderManagement(row) {
      console.log(row);
      const routeData = this.$router.resolve({
        path: `/orderManagementList?activityId=${this.activityId}&activityName=${this.activityDetail.name}`,
      });
      window.open(routeData.href, "_blank");
    },
    //补卡
    goSupplementCard(row) {
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = "补卡";
      this.manageTip = "请扫码进入小程序补卡";
    },
    // 编辑修改
    dropdownSet(row) {
      // console.log(row, "去编辑--内容");
      // console.log(row.createId != row.user_id);
      // console.log(row.is_admin == 2);

      if ((row.createId && row.createId != row.user_id) || row.is_admin == 2) {
        this.$message.error("没有权限修改");
        return false;
      }

      if (row.activity_big_type == 2) {
        const routeData = this.$router.resolve({
          path: "/groupNotification",
          query: {
            alias: row.activityKey,
            selectType: "update",
            isType: row.activity_type,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        if (row.activity_type == 303) {
          this.fetchActivityCode(row);
          this.manageDialogVisible = true;
          this.manageTitle = "编辑";
          this.manageTip = "请扫码进入小程序活动详情进行修改";
        } else {
          const routeData = this.$router.resolve({
            path: "/solitaire",
            query: {
              alias: row.activityKey,
              selectType: "update",
              isType: row.activity_type,
            },
          });
          window.open(routeData.href, "_blank");
        }
      }
    },

    // 提前结束
    dropdownEnd(row) {
      var toastMessage = "";

      if (row.active_state == 1) {
        // 活动未开始
        toastMessage = "是否立即开始该活动";
      } else if (row.active_state == 2) {
        // 活动已结束
        toastMessage = "是否立即重启该活动";
      } else if (row.active_state == 3) {
        // 活动进行中
        toastMessage = "是否提前结束该活动";
      }

      this.$confirm(toastMessage, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (row.active_state == 1) {
            // 活动未开始
            startImmediately({
              id: row.id,
            }).then((res) => {
              console.log(res, "立即开始接口");
              this.$message({
                type: "success",
                message: "成功!",
              });
              this._getActivityInfo();
            });
            // earlyTermination,restartActivity,startImmediately
          } else if (row.active_state == 2) {
            // 活动已结束
            restartActivity({
              id: row.id,
            }).then((res) => {
              console.log(res, "重启活动接口");
              this.$message({
                type: "success",
                message: "成功!",
              });
              this._getActivityInfo();
            });
          } else if (row.active_state == 3) {
            // 活动进行中
            console.log("提前结束接口");
            earlyTermination({
              id: row.id,
              is_it_over: 2,
              userId: localStorage.getItem("userID"),
            }).then((res) => {
              console.log(res, "提前结束接口");
              this.$message({
                type: "success",
                message: "成功!",
              });
              this._getActivityInfo();
            });
          }
        })
        .catch(() => {});
    },

    async editAllowView(item, allow_viewing) {
      this.$confirm(
        allow_viewing == 1 ? "允许他人查看？" : "不允许他人查看？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(async () => {
          const { data, msg, status } = await updateSignInfo({
            activityId: this.activityId,
            signInfo: JSON.stringify(item.sign_info),
            joinNum: this.joinUserNum,
            fmSignListId:
              item.fm_sign_list_id != 0 ? item.fm_sign_list_id : null,
            leaveMessage: this.leavemessage,
            name: item.sign_info[0].value,
            id: item.id,
            projectVos: [],
            allow_viewing: allow_viewing,
            isItOneself: this.isOtherPeople == 3 ? 1 : 2,
            updateName: item.sign_info[0].value,
            addTime: item.add_time.split(" ")[0],
          });
          if (status == 1) {
            if (this.isButtonClicked) return;
            this.isButtonClicked = true;
            this.setBoxShow = false;
            this.getSignListMore();
            this.$message.success("修改成功");
          }
        })

        .catch(() => {});
    },
    //删除评论
    async delComment(comment, item) {
      delSignListComment({
        activityId: this.activityId,
        id: comment.id,
      }).then((res) => {
        if (res.status == 1) {
          this.commentStates = {
            ...this.commentStates,
            [item.id]: {
              ...this.commentStates[item.id],
              pageNum: 1,
            },
          };
          //  this.registraList = []
          this._getSignListComment(item.id);
          this.$message.success("删除成功");
        } else {
          this.$message.error(res.msg);
        }

        console.log(res);
      });
    },
    handleDateConfirm(date) {
      console.log(date, "handleDateConfirm");
      const formattedDate = this.$dayjs(date).format("YYYY-MM-DD");
      // 更新日期和时间相关的变量
      this.dateValue = formattedDate;
      this.startQueryTime = formattedDate;
      this.endQueryTime = formattedDate;

      // 根据不同的场景更新特定的变量
      // const lastIndex = this.dktimePickerArr.length - 1;
      this.dktimePickerArr[this.dktimePickerArr.length - 1].name =
        this.dateValue;
      this.timePickerArr[this.timePickerArr.length - 1].name = this.dateValue;
      this.$forceUpdate();
      this.searchData();
      this.registraList = [];
      if (this.isButtonClicked) return;
      this.isButtonClicked = true;
      this.allowLoadMore = false;
      // this.getSignListMore()
    },
    handleDateClose() {
      this.isDatePickerVisible = false;
      console.log("DatePicker closed");
    },
    // 去排行榜页
    toRankPage() {
      if (this.registraList.length > 0) {
        this.$router.push({
          path: "/rankingList",
          query: {
            activityId: this.activityId,
            actName: this.activityDetail.name,
          },
        });
      } else {
        this.$message.warning("暂无参与记录");
        return;
      }
    },
    // 切换视图模式
    switchViewMode(mode) {
      if (this.dataSchema === mode) return;
      this.dataSchema = mode;
      this.pageNum = 1;
      this.registraList = [];
      this._getSignListMore();
    },

    // 获取订单数量
    async getOrderCount() {
      console.log("订单数量", this.selectType, this.isType);
      if (this.isType == "101") {
        console.log("订单数量111");
        // 获取活动唯一标识
        const activityIdentifier = this.activityId || this.activityKey;
        if (!activityIdentifier) return;

        let params = {};
        if (this.activityId) {
          params.activityId = this.activityId;
        } else if (this.activityKey) {
          params.activityKey = this.activityKey;
        }
        let res = await handleUnreadOrderCount(params);
        if (res.status == 1) {
          this.orderUnreadSum = res.data;
          console.log(this.orderUnreadSum, "this.orderUnreadSum");
        }
      }
    },
    toBuild() {},
    useThisTemplate() {},
    // getActivityDetail(){
    //     activityDetail({
    //         activityId: this.activityId,
    //         selectType:'see',
    //         is_template:''
    //     }).then(res=>{
    //        this.activityDetailInfo = res.data.activityDetail;
    //         console.log(res);
    //     })
    // }
    // 跳转详情页关联接龙
    todetail(item) {
      console.log(item, "item呢");
      if (item.activity_big_type == 1) {
        this.$router.push({
          path: "/activityDetails",
          query: { alias: item.activityKey },
        });
      } else if (item.activity_big_type == 2) {
        this.$router.push({
          path: "/activityDetailsTz",
          query: { alias: item.activityKey },
        });
      }
    },
    updateCurrentPageData() {
      this._getActivityInfo();
    },
    //点赞
    async thumbsUp(item, isDz, id) {
      this.thumbsUpId = id;
      if (!this.isClick) {
        return false;
      }
      this.isClick = false;
      if (item.isDz == "false") {
        const { data } = await thumbsUp({
          id: id,
          activityId: this.activityId,
        });
        if (data.status == 1) {
          item.isDz = "true";
          this.isClick = true;
          item.thumbs_up_number = (parseInt(item.thumbs_up_number) || 0) + 1;
          this.updateThumbsUpNumber(item, isDz, id);
          // if (this.isButtonClicked) return;
          // this.isButtonClicked = true;
          // this.mescroll.resetUpScroll();
        }
      } else if (item.isDz == "true") {
        const { data } = await delthumbsUp({
          id: id,
          activityId: this.activityId,
        });
        if (data.status == 1) {
          console.log(data, "看看执行了吗");
          this.isClick = true;
          item.isDz = "false";
          item.thumbs_up_number = (parseInt(item.thumbs_up_number) || 0) - 1;
          // if (this.isButtonClicked) return;
          // this.isButtonClicked = true;
          console.log(this.isClick, "看看执行了吗");
          // this.mescroll.resetUpScroll();
        }
      }
    },
    // 更新点赞数量
    async updateThumbsUpNumber(item, isDz, id) {
      console.log("isDz", item, isDz, id);
      await sleDetails({
        id: this.thumbsUpId,
        activityId: this.activityId,
      });
      // if (data.status == 1) {
      //     item.thumbs_up = item.thumbs_up+1
      //     item.isDz = item.isDz=='true'?'false':'true'
      // }
    },
    toSign(row) {
      this.fetchActivityCode(row);
      this.manageDialogVisible = true;
      this.manageTitle = this.activityDetail.name;
      this.manageTip = "扫码参与";
    },
    toWebdiv(type) {
      if (type == "gzh") {
        this.manageTitle = "公众号";
        this.manageTip = "请扫码进入小程序查看";
      }
      if (type == "xcx") {
        this.manageTitle = "小程序";
        this.manageTip = "请扫码进入小程序查看";
      }
      if (type == "sph") {
        this.manageTitle = "视频号";
        this.manageTip = "请扫码进入小程序查看";
      }
      this.fetchActivityCode(this.activityDetail);
      this.manageDialogVisible = true;
    },
    async delSign(item) {
      let updateName = "";
      var sitem = item;
      if (this.activityDetail.groupId) {
        var newArr = this.registraList.filter(
          (item) => this.memberId == item.user_id,
        );
        updateName = newArr[0].nickname;
      } else {
        updateName = this.mySignInfo.name;
      }
      if (!this.isClick) {
        return;
      }
      this.isClick = false;

      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { status } = await signDel({
            activityId: this.activityId,
            id: sitem.id,
            userId: sitem.user_id,
            updateName: updateName,
          });
          if (status == 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.signList = [];
            // this._getActivityInfo()
            if (this.isButtonClicked) return;
            this.isButtonClicked = true;
            if (this.mySignInfo.user_id == this.memberId) {
              this.mySignInfo = {};
            }
          }
          this.isClick = true;
          this.setBoxShow = false;
          this.getSignListMore();
        })
        .catch(() => {
          this.isClick = true;
          this.$message({
            message: "取消删除",
          });
        });
    },
    editPlayer() {
      this.fetchActivityCode(this.activityDetail);
      this.manageDialogVisible = true;
      this.manageTitle = this.activityDetail.name;
      this.manageTip = "扫码进入活动详情修改信息";
    },
    batchdrawing() {
      this.fetchActivityCode(this.activityDetail);
      this.manageDialogVisible = true;
      this.manageTitle = this.activityDetail.name;
      this.manageTip = "扫码进入活动详情使用批图功能";
    },

    // 获取二维码

    fetchActivityCode(row, isSignDataScreen = false, needCanvas = false) {
      console.log(row, "信息呢-activity_type");

      const scene = "id=" + row.id + "&st=see&ity=" + row.activity_type;
      getActivityCode({
        activityId: row.id,
        page: "pages/solataireGroupDetails/solataireGroupDetails",
        scene: scene,
      }).then((res) => {
        if (res.status == 1) {
          this.codeUrl = this.imageUrl + res.data.smallCode;
          // 只有分享弹窗需要 Canvas
          if (needCanvas) {
            this.canvasCodeUrl = this.codeUrl;
            this.initLogoButtons();
            this.$nextTick(() => {
              this.renderCanvas();
            });
          }
          // 只有点击签到大屏时才调用_getAccessKey
          if (isSignDataScreen && this.activityDetail.signInSwitch == 2) {
            console.log(this.activityDetail.signInSwitch, "hhhhh");
            this._getAccessKey(row.activityKey);
          }
        }
      });

      getShareLink({ activityId: row.id }).then((res) => {
        if (res.status == 1) {
          this.JumpUrl = res.data.shareLink;
        }
      });
    },

    downLoadCodePic(url) {
      this.downloadIamge(url, new Date().valueOf());
    },

    // 初始化 Logo 按钮
    initLogoButtons() {
      const isBaomingGuanjia = copyrightConfig.AppID === "wx7d8daf6d777947a2";

      // 根据 AppID 设置默认文字和颜色
      if (isBaomingGuanjia) {
        // 报名管家
        this.defaultLogoText = "报名";
        this.defaultLogoColor = "#2577e4";
        this.logoButtons = [{ text: "接龙" }];
      } else {
        // 接龙加加
        this.defaultLogoText = "接龙";
        this.defaultLogoColor = "#133BBE";
        this.logoButtons = [];
      }

      // 添加固定按钮
      const commonButtons = [
        { text: "签到" },
        { text: "打卡" },
        { text: "通知" },
        { text: "学校" },
        { text: "信息收集" },
        { text: "登记" },
      ];
      this.logoButtons = [...this.logoButtons, ...commonButtons];

      // 设置初始 logoText 为默认文字
      this.logoText = this.defaultLogoText;
    },

    // 格式化按钮文字显示
    formatButtonText(text) {
      if (text.length <= 2) {
        return text;
      }
      const firstRow = text.slice(0, 2);
      const secondRow = text.slice(2, 4);
      return firstRow + "\n" + secondRow;
    },

    // 启用自定义输入
    enableCustomInput() {
      this.showCustomInput = true;
      this.logoText = "";
      this.isDefaultMode = false;
      this.agreementChecked = false;
      this.$nextTick(() => {
        this.renderCanvas();
      });
    },

    // 设置 Logo 文字
    setLogoText(text) {
      this.logoText = text;
      this.showCustomInput = false;
      // 如果文字等于默认文字，则是默认模式
      this.isDefaultMode = text === this.defaultLogoText;
      // 切换到默认模式时重置颜色索引和协议勾选状态
      if (this.isDefaultMode) {
        this.selectedColorIndex = -1;
      }
      this.agreementChecked = false;
      this.$nextTick(() => {
        this.renderCanvas();
      });
    },

    // Logo 文字变化处理
    handleLogoTextChange() {
      this.$nextTick(() => {
        this.renderCanvas();
      });
    },

    // 选择颜色
    selectColor(index) {
      this.selectedColorIndex = index;
      // 选择颜色后退出默认模式，需要勾选协议
      this.isDefaultMode = false;
      // 如果当前没有文字，设置为默认文字
      if (!this.logoText) {
        this.logoText = this.defaultLogoText;
      }
      this.agreementChecked = false;
      this.$nextTick(() => {
        this.renderCanvas();
      });
    },

    // 使用 Canvas 渲染带 Logo 的二维码（预览 + 下载）
    renderCanvas() {
      const canvas = this.$refs.logoCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      const size = 300; // 画布大小
      canvas.width = size;
      canvas.height = size;

      // 如果没有二维码 URL，不渲染
      if (!this.canvasCodeUrl) return;

      // 创建二维码图像
      const qrImg = new Image();
      qrImg.crossOrigin = "Anonymous";
      qrImg.src = this.canvasCodeUrl;

      qrImg.onload = () => {
        try {
          // 绘制白色背景
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, size, size);

          // 绘制二维码
          ctx.drawImage(qrImg, 0, 0, size, size);

          // 绘制中心圆形 Logo 区域
          // 条件：有文字（包括默认模式）
          if (this.logoText) {
            // 绘制中心圆形 Logo 区域
            const centerX = size / 2;
            const centerY = size / 2;
            const logoRadius = 68; // Logo 半径

            // 创建圆形裁剪区域
            ctx.save();
            ctx.beginPath();
            ctx.arc(centerX, centerY, logoRadius, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.clip();

            // 绘制彩色圆形背景（完全覆盖中心区域）
            const bgColor =
              this.selectedColorIndex >= 0
                ? this.logoColors[this.selectedColorIndex]
                : this.defaultLogoColor;
            ctx.fillStyle = bgColor;
            ctx.beginPath();
            ctx.arc(centerX, centerY, logoRadius, 0, Math.PI * 2, true);
            ctx.fill();

            // 只有在有文字时才绘制文字
            if (this.logoText) {
              // 绘制自定义文字
              ctx.fillStyle = "#FFFFFF"; // 文字颜色固定为白色
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";

              const len = this.logoText.length;
              if (len <= 2) {
                // 1-2 个字，单排
                ctx.font = 'bold 50px "庞门正道标题体", Arial';
                ctx.fillText(this.logoText, centerX, centerY + 5);
              } else if (len == 3) {
                ctx.font = 'bold 40px "庞门正道标题体", Arial';
                ctx.fillText(this.logoText, centerX, centerY + 5);
              } else {
                // 超过 2 个字，两排，每排 2 个
                ctx.font = 'bold 36px "庞门正道标题体", Arial';
                const lineHeight = 40;
                const firstRow = this.logoText.slice(0, 2);
                const secondRow = this.logoText.slice(2, 4);
                ctx.fillText(firstRow, centerX, centerY - lineHeight / 2 + 5);
                ctx.fillText(secondRow, centerX, centerY + lineHeight / 2 + 5);
              }
            }

            ctx.restore();
          }
        } catch (error) {
          // 静默处理错误
        }
      };

      qrImg.onerror = () => {
        // 静默处理错误
      };
    },

    // 下载 Canvas 图片
    downloadCanvasImage() {
      const canvas = this.$refs.logoCanvas;
      if (!canvas) {
        this.$message.error("Canvas 未准备好");
        return;
      }

      try {
        // 导出高分辨率图片
        const tempCanvas = document.createElement("canvas");
        const tempCtx = tempCanvas.getContext("2d");
        const highResSize = 600; // 高分辨率
        tempCanvas.width = highResSize;
        tempCanvas.height = highResSize;

        // 重新绘制高分辨率版本
        const qrImg = new Image();
        qrImg.crossOrigin = "Anonymous";
        qrImg.src = this.canvasCodeUrl;

        qrImg.onload = () => {
          // 绘制白色背景
          tempCtx.fillStyle = "#FFFFFF";
          tempCtx.fillRect(0, 0, highResSize, highResSize);

          // 绘制二维码
          tempCtx.drawImage(qrImg, 0, 0, highResSize, highResSize);

          // 只有在有自定义文字时才绘制中心圆形 Logo
          if (this.logoText) {
            const centerX = highResSize / 2;
            const centerY = highResSize / 2;
            const logoRadius = 136;

            // 创建圆形裁剪区域
            tempCtx.save();
            tempCtx.beginPath();
            tempCtx.arc(centerX, centerY, logoRadius, 0, Math.PI * 2, true);
            tempCtx.closePath();
            tempCtx.clip();

            // 绘制彩色圆形背景（完全覆盖中心区域）
            const bgColor =
              this.selectedColorIndex >= 0
                ? this.logoColors[this.selectedColorIndex]
                : this.defaultLogoColor;
            tempCtx.fillStyle = bgColor;
            tempCtx.beginPath();
            tempCtx.arc(centerX, centerY, logoRadius, 0, Math.PI * 2, true);
            tempCtx.fill();

            // 绘制文字
            tempCtx.fillStyle = "#FFFFFF"; // 文字颜色固定为白色
            tempCtx.textAlign = "center";
            tempCtx.textBaseline = "middle";

            const len = this.logoText.length;
            if (len <= 2) {
              tempCtx.font = 'bold 100px "庞门正道标题体", Arial';
              tempCtx.fillText(this.logoText, centerX, centerY + 10);
            } else if (len == 3) {
              tempCtx.font = 'bold 80px "庞门正道标题体", Arial';
              tempCtx.fillText(this.logoText, centerX, centerY + 10);
            } else {
              // 超过 3 个字，两排，每排 2 个
              tempCtx.font = 'bold 72px "庞门正道标题体", Arial';
              const lineHeight = 80;
              const firstRow = this.logoText.slice(0, 2);
              const secondRow = this.logoText.slice(2, 4);
              tempCtx.fillText(
                firstRow,
                centerX,
                centerY - lineHeight / 2 + 10,
              );
              tempCtx.fillText(
                secondRow,
                centerX,
                centerY + lineHeight / 2 + 10,
              );
            }

            tempCtx.restore();
          }

          // 下载
          const dataUrl = tempCanvas.toDataURL("image/png");
          this.downloadIamge(dataUrl, "接龙二维码_" + new Date().valueOf());
        };

        qrImg.onerror = () => {
          // 图片加载失败，静默处理
        };
      } catch (error) {
        this.$message.error("下载失败，请重试");
      }
    },

    //

    downloadIamge(imgsrc, name) {
      // 下载图片地址和图片名

      var image = new Image();

      // 解决跨域 Canvas 污染问题

      image.setAttribute("crossOrigin", "Anonymous");

      image.onload = () => {
        var canvas = document.createElement("canvas");

        canvas.width = image.width;

        canvas.height = image.height;

        var context = canvas.getContext("2d");

        context.fillStyle = "#FFFFFF";

        context.fillRect(0, 0, canvas.width, canvas.height);

        context.drawImage(image, 0, 0, image.width, image.height);

        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素

        var event = new MouseEvent("click"); // 创建一个单击事件

        a.download = name || "photo"; // 设置图片名称

        a.href = url; // 将生成的URL设置为a.href属性

        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    timeAndDKtimeChangeHandler(index, value, sourceType, performSearchOrReset) {
      // 根据 sourceType 记录当前操作索引和选择器值
      if (sourceType === "time") {
        this.timeChangeIndex = index;
      } else if (sourceType === "dktime") {
        this.dktimeChangeIndex = index;
        this.timeChangeIndex = index;
      }
      if (index == 0 || index == 1) {
        this.setTimePickerConfig(this.clockFrequencyType);
      }
      // 根据不同的统计频率类型处理时间范围
      if (FREQUENCY_TYPE.DAILY.includes(this.clockFrequencyType)) {
        this.handleDailyFrequency(index, performSearchOrReset);
      } else if (FREQUENCY_TYPE.WEEKLY.includes(this.clockFrequencyType)) {
        this.handleWeeklyFrequency(index, performSearchOrReset);
      } else if (this.clockFrequencyType === FREQUENCY_TYPE.MONTHLY) {
        this.handleMonthlyFrequency(index, performSearchOrReset);
      }
      for (const key in this.commentStates) {
        this.commentStates = {
          ...this.commentStates,
          [key]: {
            ...this.commentStates[key],
            pageNum: 1,
          },
        };
      }

      // this._getSignListComment(this.orderId, 1)
      // 根据 performSearchOrReset 参数执行相应的操作
      if (
        !(index == 2 && FREQUENCY_TYPE.DAILY.includes(this.clockFrequencyType))
      ) {
        if (performSearchOrReset === "search") {
          this.searchData();
          this.registraList = [];
          if (this.isButtonClicked) return;
          this.isButtonClicked = true;
          this.loadingFinished = false;
          this.pageNum = 0;
          this.getSignListMore();
        } else if (performSearchOrReset === "reset") {
          this.registraList = [];
          if (this.isButtonClicked) return;
          this.isButtonClicked = true;
          this.loadingFinished = false;
          this.pageNum = 0;
          this.getSignListMore();
        }
      }
    },
    /**
     * 计算两个日期相差的月份
     * @param {Date} minDate - 第一个日期对象
     * @param {Date} maxDate - 第二个日期对象
     * @returns {number} 相差的月份数
     */
    // 计算两个日期相差月份的方法
    getMonthDifference(minDate, maxDate) {
      const startDate = this.$dayjs(minDate);
      const endDate = this.$dayjs(maxDate);
      let months = endDate.year() * 12 + endDate.month();
      months -= startDate.year() * 12 + startDate.month();
      if (endDate.date() < startDate.date()) {
        months--;
      }
      return months;
    },

    /* 处理日维度时间范围 */
    async handleDailyFrequency(index, performSearchOrReset) {
      const today = this.$dayjs();

      switch (index) {
        case TIME_RANGE_INDEX.TODAY: {
          this.setDateRange(today, today);
          this.dateValue = today.format("YYYY-MM-DD");
          break;
        }

        case TIME_RANGE_INDEX.YESTERDAY: {
          const yesterday = today.subtract(1, "day");
          this.setDateRange(yesterday, yesterday);
          this.dateValue = yesterday.format("YYYY-MM-DD");
          break;
        }
        default: {
          let monthDifference;
          if (performSearchOrReset === "search") {
            this.minDateMultiple = this.$dayjs(
              this.activityDetail.beginTime,
            ).format("YYYY-MM-DD");
            this.maxDate = this.$dayjs(this.activityDetail.endTime).format(
              "YYYY-MM-DD",
            );
            monthDifference = this.getMonthDifference(
              this.minDateMultiple,
              this.maxDate,
            );
            this.monthNum = monthDifference + 1;
            this.datePickerMinDate = this.$dayjs(this.minDateMultiple).toDate();
            console.log(this.datePickerMinDate, "this.datePickerMinDat");
            this.datePickerMaxDate = this.$dayjs(
              this.activityDetail.endTime,
            ).toDate();
            this.datePickerType = "date";
            this.isDatePickerVisible = true;
            this.calendarShow = !this.calendarShow; // 切换日历显示状态
            this.calendarShow = true;
            this.registraList = [];
          } else if (performSearchOrReset === "reset") {
            this.minDateMultiple = this.$dayjs(
              this.activityDetail.beginTime,
            ).format("YYYY-MM-DD");
            this.maxDate = this.$dayjs(this.activityDetail.endTime).format(
              "YYYY-MM-DD",
            );
            // this.maxDate = '2025-05-31';
            console.log(this.minDateMultiple, this.maxDate);
            monthDifference = this.getMonthDifference(
              this.minDateMultiple,
              this.maxDate,
            );
            this.monthNum = monthDifference + 1;
            this.datePickerMinDate = this.$dayjs(this.minDateMultiple).toDate();
            console.log(this.datePickerMinDate, "this.datePickerMinDat");
            this.datePickerMaxDate = this.$dayjs(
              this.activityDetail.endTime,
            ).toDate();
            this.datePickerType = "date";
            this.isDatePickerVisible = true;
            this.calendarShow = !this.calendarShow; // 切换日历显示状态
            this.calendarShow = true;
            this.registraList = [];
          }
        }
      }
    },
    /* 处理周维度时间范围 */
    handleWeeklyFrequency(index, performSearchOrReset) {
      switch (index) {
        case TIME_RANGE_INDEX.TODAY: // 本周
          this.setDateRange(
            this.$dayjs().startOf("week"),
            this.$dayjs().endOf("week"),
          );
          break;
        case TIME_RANGE_INDEX.YESTERDAY: // 上周
          this.setDateRange(
            this.$dayjs().subtract(1, "week").startOf("week"),
            this.$dayjs().subtract(1, "week").endOf("week"),
          );
          break;
        default:
          if (performSearchOrReset === "search") {
            this.filterType = 1;
            this.registraList = [];
          } else if (performSearchOrReset === "reset") {
            this.filterType = 2;
            this.registraList = [];
          }
          this.datePickerType = "week";
          this.isDatePickerVisible = true;
      }
    },

    /* 处理月维度时间范围 */
    handleMonthlyFrequency(index, performSearchOrReset) {
      switch (index) {
        case TIME_RANGE_INDEX.TODAY: {
          this.setDateRange(
            this.$dayjs().startOf("month"),
            this.$dayjs().endOf("month"),
          );
          break;
        } // 本月

        case TIME_RANGE_INDEX.YESTERDAY: {
          const lastMonth = this.$dayjs().subtract(1, "month");
          this.setDateRange(
            lastMonth.startOf("month"),
            lastMonth.endOf("month"),
          );
          break;
        } // 上月

        default: {
          if (performSearchOrReset === "search") {
            this.filterType = 1;
            this.registraList = [];
          } else if (performSearchOrReset === "reset") {
            this.filterType = 2;
            this.registraList = [];
          }
          this.datePickerType = "month";
          this.isDatePickerVisible = true;
          break;
        }
      }
    },
    // * 通用设置日期范围方法 */
    setDateRange(startDate, endDate) {
      this.startQueryTime = startDate.format("YYYY-MM-DD");
      this.endQueryTime = endDate.format("YYYY-MM-DD");
    },
    handleDateChange(selectedDate) {
      console.log("父组件接收到的日期:", selectedDate);
      // 在这里处理日期变化
    },

    // 搜索
    async searchData() {
      console.log("看看执行几次");
      if (this.solitairenName == "") {
        this.showResetButton = false;
      } else {
        this.showResetButton = true;
      }
      if (this.templatePage == 1) {
        return false;
      }

      this.filterClockNameList = [];
      await clockNameListByName({
        name: this.solitairenName, //要搜索的姓名  目前不使用模糊查询
        activityId: this.activityId, //活动id
        activityType: this.activityDetail.activityType, //活动类型
        startQueryTime: this.startQueryTime,
        endQueryTime: this.endQueryTime,
        listGroupName: this.pickerName == "全部" ? "" : this.pickerName,
      }).then((res) => {
        this.filterClockNameList = res.data;
        this.filterClockNameList.map((res, index) => {
          if (res.clockName == "") {
            this.filterClockNameList.splice(index, 1);
          }
        });

        this.registerednum = this.getRegistered();
        this.filterArrShow = true;

        this.pageNum = 1;
        this._getSignListMore();
      });
    },
    //重置名单搜索状态
    resetSearch() {
      this.solitairenName = "";
      this.searchData();
      this.registraList = [];
      if (this.isButtonClicked) return;
      this.isButtonClicked = true;
      this.showResetButton = false;
      this.filterArrShow = false;
    },
    clearSearchName() {
      this.dktimeChangeIndex = 0;
      this.timeChangeIndex = 0;
      this.isSearch = false;
      this.solitairenName = "";
      this.filterArrShow = false;
    },
    handleSearch() {
      console.log("点击搜索按钮");
      this.isSearch = true;
    },

    // 滚动监听处理
    handleScroll() {
      // 检查是否滚动到页面底部附近
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 距离底部 100px 时触发加载
      if (scrollTop + windowHeight >= documentHeight - 100) {
        this.loadMore();
      }
    },
    // 下拉刷新
    loadMore() {
      if (!this.isPageLoaded || !this.allowLoadMore || !this.hasMore || this.loading) return;
      this.loading = true; // 开始加载
      this.pageNum += 1;
      this._getSignListMore();
      console.log("加载更多数据");
    },
    getSignListMore() {
      this.pageNum = 1;
      this._getSignListMore();
    },
    cancel() {
      // this.handlemodelChange(false)
      this.score = null;
      this.addcomment = "";
      this.scoreBoxShow = false;
      this.commentBoxShow = false;
      this.remarkBoxShow = false;
      this.isClick = true;
    },
    // 点评
    commentOpen(item) {
      this.setInfo = item;
      this.commentBoxShow = true;
      this.placeholderText1 = "";
      setTimeout(() => {
        this.placeholderText1 = "请输入评语";
      }, 350);
    },
    // 评分
    openScoreDialog(item) {
      this.scoreBoxShow = true; // 打开评分对话框
      this.setInfo = item; // 将当前项存储到一个变量中以便在对话框中使用
    },
    handleInputNumber(event) {
      const value = event.target.value;
      if (value < 0) {
        this.score = 0;
      } else if (value > 150) {
        this.score = 150;
      }
    },
    async changeScore(e) {
      this.score = e;
    },
    clickScope(e) {
      this.scoreType = e.index;
      console.log(this.scoreType, "this.scoreType");
      this.score = null;
    },
    addRemark(item) {
      this.orderId = item.id;
      this.setInfo = item;
      this.remarkBoxShow = true;
      this.placeholderText2 = "";
      setTimeout(() => {
        this.placeholderText2 = "请输入评论";
      }, 300);
    },
    seeMoreComments(id) {
      // 获取当前对象的评论状态，如果不存在则初始化
      const currentState = this.commentStates[id] || {
        showCount: 2,
        isLastPage: false,
        pageNum: 1,
        totalRow: 0,
      };
      // 更新显示的评论数量
      currentState.showCount += 2;

      // 更新该对象的评论状态
      this.commentStates = {
        ...this.commentStates,
        [id]: currentState,
      };

      // 加载当前对象的评论，使用当前对象的 pageNum
      this._getSignListComment(id, currentState.pageNum);
    },
    async confirmRate() {
      if (!this.isClick) {
        return false;
      }
      this.isClick = false;
      if (this.score == null) {
        this.isClick = true;
        this.$message({
          message: "请选择评分",
          icon: "none",
          duration: 2000,
        });
        return false;
      }
      const { data, status } = await updateScore({
        id: this.setInfo.id,
        activityId: this.activityId,
        score: this.score,
      });
      if (status == 1) {
        this.score = null;
        if (this.isButtonClicked) return;
        this.isButtonClicked = true;

        this.isClick = true;
        this.scoreBoxShow = false;
        this.getSignListMore();
      } else {
        this.isClick = true;
        this.scoreBoxShow = false;

        this.$message({
          message: data.msg,
          icon: "none",
          duration: 2000,
        });
      }
    },
    async confirmComment() {
      if (!this.isClick) {
        return false;
      }
      this.isClick = false;
      if (this.addcomment == null || this.addcomment == "") {
        this.isClick = true;
        this.$message({
          message: "请输入评语",
          icon: "none",
          duration: 2000,
        });
        return false;
      }
      const { data, status } = await updatecommentlanguage({
        id: this.setInfo.id,
        activityId: this.activityId,
        addcomment: this.addcomment,
      });
      if (status == 1) {
        this.addcomment = null;

        this.getSignListMore();
        setTimeout(() => {
          this.isClick = true;
        }, 3000);
        // await this.getData()
        if (this.isButtonClicked) return;
        this.isButtonClicked = true;
        this.commentBoxShow = false;
      } else {
        this.addcomment = null;

        this.commentBoxShow = false;
        this.$message({
          message: data.msg,
          icon: "none",
          duration: 2000,
        });
      }
    },

    async confirmRemark() {
      console.log(this.isClick, "放连点");
      if (!this.isClick) {
        return false;
      }
      this.isClick = false;
      if (this.comment == null || this.comment == "") {
        this.isClick = true;
        this.$message({
          message: "请输入评论",
          icon: "none",
          duration: 2000,
        });
        return false;
      }
      const { data, status } = await SignListComment({
        orderId: this.orderId,
        activityId: this.activityId,
        comment: this.comment,
        profilePhoto: this.activityDetail.profilePhoto,
        name: this.activityDetail.publisher,
        groupId: this.activityDetail.groupId,
      });
      if (status == 1) {
        this.comment = null;
        if (this.isButtonClicked) return;

        // this.getSignListMore()
        this.isClick = true;
        this.remarkBoxShow = false;
        this.commentStates = {
          ...this.commentStates,
          [this.orderId]: {
            ...this.commentStates[this.orderId],
            pageNum: 1,
          },
        };
        this._getSignListComment(this.orderId, 1);
      } else {
        this.isClick = true;
        this.remarkBoxShow = false;
        this.$message({
          message: data.msg,
          icon: "none",
          duration: 2000,
        });
      }
    },
    showPickerNameSetup() {
      this.pickerNameSelectShow = true;
    },
    selectGrouping(e) {
      console.log(e, "分组-选中分组");
      this.pickerName = e;
      this.pickerNameSelectShow = false;

      // 切换下面的数据
      // 筛选逻辑（示例：保留所有 listGroupName 存在的项）
      if (e != "全部") {
        this.filteredArr = this.clockNameList.filter((item) => {
          return item.listGroupName == this.pickerName; // 精确匹配
        });
      } else {
        this.filteredArr = JSON.parse(JSON.stringify(this.clockNameList));
        this.filterArrShow = false;
      }
      console.log(this.filteredArr, "分组-选中分组的数据");
      this.filterClockNameList = this.filteredArr;
      this.filterArrShow = true;
      this.searchData();
      this.registraList = [];
    },
    closeGroupingPicker() {
      this.pickerNameSelectShow = false;
    },
    // 自定义月份
    monthhandleChange(value) {
      console.log(value, "jjj");
      if (value === null) {
        this.startQueryTime = this.$dayjs()
          .startOf("month")
          .format("YYYY-MM-DD");
        this.endQueryTime = this.$dayjs().endOf("month").format("YYYY-MM-DD");
        value = this.$dayjs().format("YYYY-MM");
        console.log(this.startQueryTime, this.endQueryTime);
      } else {
        const specificDate = this.$dayjs()(value);
        // 获取这个月的第一天（月初）
        const startOfSpecificMonth = specificDate.startOf("month");
        this.startQueryTime = startOfSpecificMonth.format("YYYY-MM-DD");
        // 获取这个月的最后一天（月末）
        const endOfSpecificMonth = specificDate.endOf("month");
        this.endQueryTime = endOfSpecificMonth.format("YYYY-MM-DD");
      }
      if (this.filterType == 1) {
        const newItem = { index: 2, name: `${value}` };
        this.dktimePickerArr.splice(
          this.dktimePickerArr.length - 1,
          1,
          newItem,
        );
        this.timePickerArr.splice(this.timePickerArr.length - 1, 1, newItem);
        this.searchData();
        this.registraList = [];
        if (this.isButtonClicked) return;
        this.isButtonClicked = true;
      } else if (this.filterType == 2) {
        const newItem = { index: 2, name: `${value}` };
        this.timePickerArr.splice(this.timePickerArr.length - 1, 1, newItem);
        this.registraList = [];
        if (this.isButtonClicked) return;
        this.isButtonClicked = true;
      }
      this.monthShow = false;
    },
    // 自定义周
    // handleWeekChange(week) {
    //     console.log(week,'week')
    //     this.startQueryTime = week.startDate
    //     this.endQueryTime = week.endDate
    //     const [year, month, day] = week.startDate.split('-');
    //     const [y,m,d] =  week.endDate.split('-');
    //     this.defaultWeekDate = week.startDate
    //     var weekStartData= `${month.padStart(2, '0')}.${day.padStart(2, '0')}`
    //     var weekEndData= `${m.padStart(2, '0')}.${d.padStart(2, '0')}`
    //     if(this.filterType==1){
    //         this.searchData()
    //         this.registraList = [];
    //         if (this.isButtonClicked) return;
    //         this.isButtonClicked = true;
    //         this.mescroll.resetUpScroll();
    //         const newItem = { index: 2, name:`${weekStartData}-${weekEndData}`};
    //         this.dktimePickerArr.splice(this.dktimePickerArr.length - 1, 1, newItem);
    //         this.timePickerArr.splice(this.timePickerArr.length - 1, 1, newItem);
    //     }else if(this.filterType==2){
    //         const newItem = { index: 2, name:`${weekStartData}-${weekEndData}`};
    //         this.timePickerArr.splice(this.timePickerArr.length - 1, 1, newItem);
    //         this.registraList=[]
    //         if (this.isButtonClicked) return;
    //         this.isButtonClicked = true;
    //         this.mescroll.resetUpScroll();
    //     }
    // },
    onMonthChange(month) {
      this.selectedMonth = {
        year: month.year,
        month: month.month.replace("月", ""),
      };
    },
    async copynotregistered() {
      var notregistered = this.clockNameList.filter(
        (item) => item.clockNameStatus == 2,
      );
      var copyname = notregistered.map((user) => user.clockName).join(",");
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(copyname);
          this.$message({
            message: "复制成功",
            duration: 2000,
            type: "success",
          });
        } catch (err) {
          console.error("复制失败", err);
        }
      } else {
        // 备用方案：使用传统方法
        const textArea = document.createElement("textarea");
        textArea.value = copyname;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "复制成功",
            duration: 2000,
            type: "success",
          });
        } catch (err) {
          console.error("复制失败", err);
        }
        document.body.removeChild(textArea);
      }
    },
    async copyContent(textToCopy) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(textToCopy);
          this.$message({
            message: "复制成功",
            duration: 2000,
            type: "success",
          });
        } catch (err) {
          console.error("复制失败", err);
        }
      } else {
        // 备用方案：使用传统方法
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "复制成功",
            duration: 2000,
            type: "success",
          });
        } catch (err) {
          console.error("复制失败", err);
        }
        document.body.removeChild(textArea);
      }
    },
    // 渲染内容，将 URL 识别并标蓝
    renderContentWithUrl(text) {
      if (!text) return "";
      const urlPattern = /(https?:\/\/[^\s<]+)/gi;
      return text.replace(urlPattern, (url) => {
        return `<span style="color: #1877ff;">${url}</span>`;
      });
    },
    // 打开文件
    openWen(url, fileType, fileName) {
      // 自动将 http 替换为 https
      if (url.startsWith("http://")) {
        url = url.replace("http://", "https://");
      }
      const predivTypes = ["pdf", "jpg", "jpeg", "png", "gif", "bmp", "webp"];
      if (predivTypes.includes(fileType.toLowerCase())) {
        window.open(url, "_blank");
      } else {
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName || "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }

      if (this.activityDetail && this.activityDetail.name) {
        document.title = `${this.activityDetail.name} - 活动详情 - ${suffix}`;
      } else {
        document.title = `活动详情 - ${suffix}`;
      }
      console.log(document.title, "document.title");
    },
    async _getActivityInfo() {
      let obj = {};
      if (this.isTemplate == "template") {
        //通过模板进来
        obj = {
          templateIsShow: "99",
          templateId: this.activityId,
          selectType: this.selectType,
        };
      } else {
        if (this.activityId) {
          obj = {
            activityId: this.activityId,
            selectType: "see",
          };
        } else {
          obj = {
            activityKey: this.$route.query.alias,
            selectType: "see",
          };
        }
      }
      obj["is_template"] = this.is_template;
      const { data, status } = await activityDetail(obj);

      if (status == 1) {
        this.activityDetail = data.activityDetail;
        this.DataScreenUrl = data.screenUrl;
        console.log(this.DataScreenUrl, "this.DataScreenUrl");
        this.activityId = data.activityDetail.id;
        console.log(this.activityId, "this.activityId");
        this.clockListNumber = data.activityDetail.clockListNumber;
        this.clockSwitch = data.activityDetail.clockSwitch
          ? data.activityDetail.clockSwitch
          : 99;
        // 收费项列表
        this.chargeItemList = data.activityDetail.fmActivityChargeItemVOS || [];

        // 设置页面标题
        this.setPageTitle();
      }

      if (this.templatePage != 1) {
        this._getProjectManageAdmin();
        this.handleAddBrowseHistory();
      }
      // 指定参与地点开关
      this.is_destination = data.activityDetail.is_destination;

      this.is_draft = data.activityDetail.is_draft;
      if (data.modular) {
        data.modular.map((item) => {
          item.info = item.info.replace(/\n/g, "\\n");
          const info = JSON.parse(item.info);
          item.info = info;
          if (item.type == 6) {
            item.info.filesArr.forEach((itemSon) => {
              itemSon.playMusic = false;
            });
          }

          if (item.type == 4) {
            this.covers.push({
              id: 9001,
              latitude: item.info.latitude,
              longitude: item.info.longitude,
              iconPath: "/static/img/dingwei.png",
              bgColor: "",
              width: "20px",
              height: "30px",
            });
          }
        });
      }
      this.modular = data.modular ? data.modular : [];

      if (this.activityDetail.groupId) {
        this.activityDetail.copyStatus = 1;
      }
      if (data.active_state == 2) {
        this.activityDetail.is_it_over = 2;
      }
      if (data.active_state == 1) {
        this.activityDetail.is_it_over = 3;
      }
      this.active_state = data.active_state;
      data.activityDetail["activity_big_type"] =
        data.activityDetail.activityBigType;
      data.activityDetail["activity_type"] = data.activityDetail.activityType;
      this.isType = data.activityDetail.activityType;
      // 如果活动类型是 101，获取订单数量
      if (this.isType == "101") {
        this.getOrderCount();
      }
      this.signField = data.signField;
      this.baseUrls = this.activityDetail.coverImg;
      this.memberId = data.memberId;
      this.authInformation = data.authInformation;
      // 认证信息

      // 编辑 - 处理封面赋值
      this.vid = this.activityDetail.vid ? this.activityDetail.vid : "";
      this.playUrl = this.activityDetail.playUrl
        ? this.activityDetail.playUrl
        : "";
      this.isVideo = this.activityDetail.isVideo
        ? this.activityDetail.isVideo
        : 2;
      this.isCoverEnabled = this.activityDetail.isCoverEnabled
        ? this.activityDetail.isCoverEnabled
        : 1;
      this.subCoverImages = this.activityDetail.subCoverImages
        ? this.activityDetail.subCoverImages.split(",")
        : [];
      this.activityModeUrl = this.activityDetail.activityModeUrl
        ? this.activityDetail.activityModeUrl
        : "https://ossfastmake.mustke.com/12xtPictures/xt-1.png";

      // 整合activityModeUrl和subCoverImages到turnPictures数组
      this.turnPictures = [];
      // 如果activityModeUrl不为空字符串，则添加到数组开头
      if (this.activityModeUrl && this.activityModeUrl.trim() !== "") {
        this.turnPictures.push(this.activityModeUrl);
      }
      // 如果subCoverImages不为空数组，则添加到turnPictures中
      if (this.subCoverImages && this.subCoverImages.length > 0) {
        this.turnPictures = this.turnPictures.concat(this.subCoverImages);
      }

      if (this.isCoverEnabled == 2 && this.activityModeUrl) {
        // 删除 turnPictures 数组里的第一个
        this.turnPictures.splice(0, 1);
      }

      console.log(this.turnPictures, "turnPictures");

      if (this.activityDetail.contactType == 1) {
        this.contactTypeText = "手机号";
      } else if (this.activityDetail.contactType == 2) {
        this.contactTypeText = "微信号";
      } else {
        this.contactTypeText = "手机号和微信同号";
      }

      if (this.modular.length > 2) {
        this.isHidden = true;
        this.hiddenBtn = true;
        this.zhanKai = true;
      } else {
        this.isHidden = false;
        this.hiddenBtn = false;
      }
      if (data.mySignInfo) {
        this.mySignInfo = data.mySignInfo;
      } else {
        this.mySignInfo.id = "";
      }

      // 打卡信息
      if (data.clockInfo) {
        this.clockInfo = data.clockInfo;
        this.clockFrequencyType = data.clockInfo.clockFrequencyType;
        if (
          data.clockInfo.clockLocationInfo != "" &&
          data.clockInfo.clockLocationInfo != null
        ) {
          this.clockInfo.clockLocationInfo = JSON.parse(
            data.clockInfo.clockLocationInfo,
          );
          this.covers.push({
            id: 9001,
            latitude: this.clockInfo.clockLocationInfo.latitude,
            longitude: this.clockInfo.clockLocationInfo.longitude,
            iconPath: "/static/img/dingwei.png",
            bgColor: "",
            width: "20px",
            height: "30px",
          });
        }
        this.setTimePickerConfig(this.clockFrequencyType);
        if (
          data.clockInfo.clockLocationStatus &&
          data.clockInfo.clockLocationStatus == 1
        ) {
          // this.isGetLocation();
        }
      }

      // 走check接口
      if (data.activityDetail.is_destination == 1) {
        // this.isGetLocation();
      }

      if (data.project) {
        this.projectVos = data.project;
      }

      if (data.cardReplacementsNumber) {
        this.cardReplacementsNumber = data.cardReplacementsNumber; //剩余次数
      } else {
        this.cardReplacementsNumber = 0;
      }
      this.cardReplacementsNumberFlag = data.cardReplacementsNumberFlag;

      if (data.clockNameList) {
        this.clockNameList = data.clockNameList;
        this.clockNameList.map((res, index) => {
          if (res.clockName == "") {
            this.clockNameList.splice(index, 1);
          }
        });

        // 判断是不是分组
        if (
          data.clockNameList.length &&
          data.clockNameList[0].clockName != "" &&
          data.clockNameList[0].listGroupName != null
        ) {
          this.nameAddType = "2";
        } else {
          this.nameAddType = "1";
        }

        // 更新分组的下拉
        var subArr = ["全部"];
        this.clockNameList.forEach((item, subIndex) => {
          subArr.push(item.listGroupName);
        });
        const uniqueArr = [...new Set(subArr)];
        this.pickerNameSelectArr = [uniqueArr];

        this.isSearch = false;
        this.filterClockNameList = data.clockNameList;
        this.solitairenName = "";
        this.registerednum = this.getRegistered();

        this.cloneClocknameLength = this.clockNameList.length;
        // this.searchData()
      }

      if (this.templatePage == "1") {
        this.clockNameList =
          this.clockNameList.length > 0
            ? this.clockNameList
            : this.clockNameListTemp;
        this.cloneClocknameLength = this.clockNameList.length;
      }

      if (this.mySignInfo.id != "") {
        this.fmSignListId = data.mySignInfo.fm_sign_list_id
          ? data.mySignInfo.fm_sign_list_id
          : "";
      }

      this.sharefriendpic = `id=${this.activityId}&selectType=see${
        this.mySignInfo ? "&mySignInfo=" + this.mySignInfo.id : ""
      }`;

      //开启留言时获取留言数据
      if (this.activityDetail.commentStatus == 1) {
        this.commentList = [];
        this._getCommentList();
      }

      this.tosignClick = true;
    },
    //获取选手列表
    async _getSignListMore() {
      if (this.pageNum == 1) this.registraList = [];
      const result = await getSignListMore({
        pageNum: this.pageNum,
        pageSize:
          this.dataSchema === 1 ? this.listModePageSize : this.viewModePageSize,
        signShowType: 1,
        activityId: this.activityId,
        fmSignListId: this.fmSignListId != 0 ? this.fmSignListId : null,
        choose: this.isOtherPeople == 3 ? 1 : this.choose,
        sortType: this.sortType,
        name: this.name,
        signInfoStatus: this.signInfoStatus != 0 ? this.signInfoStatus : null,
        startQueryTime: this.startQueryTime,
        endQueryTime: this.endQueryTime,
        listGroupName: this.pickerName == "全部" ? "" : this.pickerName,
        dataSchema: this.dataSchema,
      });
      if (result.status == 1) {
        this.loadingFinished = false;
        this.loadingFlag = true;
        this.registraList = this.registraList.concat(result.data.pageInfo.list);

        // === 去重开始 ===
        const uniqueMap = new Map();
        this.registraList.forEach((item) => {
          if (!uniqueMap.has(item.id)) {
            uniqueMap.set(item.id, item);
          }
        });

        this.registraListTotal = result.data.pageInfo.total;

        this.registraPageNum = result.data.pageInfo.pageNum;
        this.registrapages = result.data.pageInfo.pages;
        this.hasMore = result.data.pageInfo.hasNextPage;
        // console.log(this.hasMore, "this.hasMore");

        if (result.data.pageInfo.pages == result.data.pageInfo.pageNum) {
          this.loadingFlag = false;
          this.loadingFinished = true;
        }
        if (this.registraList.length == 0) {
          this.nodataFinished = true;
          this.loadingFlag = false;
          this.loadingFinished = false;
        } else {
          this.loadingFlag = false;
          this.nodataFinished = false;
          this.loadingFinished = true;
        }

        this.registraList.forEach((item) => {
          try {
            item.sign_info = JSON.parse(item.sign_info);
          } catch (e) {
            console.error("解析错误:", e);
          }
          // 处理收费项信息
          item.charge_name = item.charge_item_name || "";
          item.unit_price = item.unit_price || "0.00";
        });
        // 头像模式按拼音排序
        if (this.dataSchema === 2) {
          this.registraList.sort((a, b) => {
            const nameA = (a.name || a.nickname || "").toLocaleString("zh-CN", {
              sensitivity: "accent",
            });
            const nameB = (b.name || b.nickname || "").toLocaleString("zh-CN", {
              sensitivity: "accent",
            });
            return nameA.localeCompare(nameB, "zh-Hans-CN", { numeric: true });
          });
        }
        this.registraList.map((itm) => {
          itm.sign_info.map((item) => {
            item.isPlay = true;
            if (item.type == 12) {
              this.covers.push({
                id: 9005,
                latitude: item.value.latitude,
                longitude: item.value.longitude,
                iconPath: "/static/img/dingwei.png",
                bgColor: "",
                width: "45px",
                height: "60px",
              });
            }
            if (item.type == "31") {
              // console.log(item.value, "item.value31");
              if (item.value == undefined) {
                item["value"] = "";
                item.startTime = "";
                item.endTime = "";
              } else if (!item.value.includes("undefined")) {
                var arr = item.value.split("~");
                if (arr.length > 0) {
                  item.startTime = arr[0];
                  item.endTime = arr[1];
                } else {
                  item.startTime = "";
                  item.endTime = "";
                }
              } else if (item.value.includes("undefined")) {
                item["value"] = "";
                item.startTime = "";
                item.endTime = "";
              }
            }
          });
        });
        this.cloneregistralength = Object.freeze(result.data.pageInfo.list);
        this.loadingFlag = false;
        this.isButtonClicked = false;
        this.allowLoadMore = true; // 允许加载更多
        this.loading = false; // 加载完成

        this.isSearch = false;
      } else {
        this.isButtonClicked = false;
        this.allowLoadMore = true; // 即使请求失败也允许重新加载
        this.loading = false; // 加载完成
        this.mescroll.endErr();
      }
      this.registraList.forEach((item) => {
        const id = item.id;
        const currentState = this.commentStates[id] || {
          showCount: 2,
          isLastPage: false,
          pageNum: 1,
          totalRow: 0,
        };
        //     this.commentStates = {
        //     ...this.commentStates,
        //     [id]: item.id
        // };

        this._getSignListComment(id, currentState.pageNum);
      });
      // 自动获取所有视频字段的视频地址
      this.autoLoadVideos();
    },
    async _getSignListComment(id, num) {
      // console.log(num, "123");
      num = num || 1;
      try {
        const pageNum = this.commentStates[id]
          ? this.commentStates[id].pageNum
          : num;
        // console.log(pageNum, "pageNum");
        const res = await getSignListComment({
          activityId: this.activityId,
          pageNum: pageNum,
          pageSize: 2,
          orderId: id,
        });
        if (this.commentStates[id] && this.commentStates[id].pageNum === 1) {
          this.pllist = this.pllist.filter((comment) => comment.orderId !== id);
        }
        const currentComments = this.pllist.filter(
          (comment) => comment.orderId === id,
        );
        const newComments = res.data.list;
        const updatedComments = currentComments.concat(newComments);

        this.pllist = this.pllist
          .filter((comment) => comment.orderId !== id)
          .concat(updatedComments);

        // === 去重开始 ===
        const uniqueMap = new Map();
        this.pllist.forEach((item) => {
          if (!uniqueMap.has(item.id)) {
            uniqueMap.set(item.id, item);
          }
        });
        this.pllist = Array.from(uniqueMap.values());
        // === 去重结束 ===

        this.totalRow = res.data.total;
        this.pages = res.data.pages;
        this.plpageNum = res.data.pageNum;
        // remarkNum = res.data.remarkNum;
        const isLastPage = res.data.isLastPage;
        const totalRow = res.data.total;
        // // 更新该对象的评论状态
        this.commentStates = {
          ...this.commentStates,
          [id]: {
            ...this.commentStates[id],
            pageNum: pageNum + 1, // 加载下一页
            isLastPage,
            totalRow,
            // remarkNum
          },
        };

        // console.log(res, "res", this.commentList);
      } catch (error) {
        console.error("获取评论列表失败:", error);
      }
    },
    setTimePickerConfig(frequencyType) {
      let timePickerArr, dktimePickerArr, startQueryTime, endQueryTime;

      switch (frequencyType) {
        case 1: {
          const PickerArr = [
            { name: "本月", index: 0 },
            { name: "上月", index: 1 },
            { name: "自定义月份", index: 2 },
          ];
          dktimePickerArr = JSON.parse(JSON.stringify(PickerArr));
          timePickerArr = PickerArr;
          startQueryTime = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          // console.log(startQueryTime, "startQueryTime");
          endQueryTime = this.$dayjs().endOf("month").format("YYYY-MM-DD");
          break;
        }
        case 2:
        case 6: {
          const PickerArr1 = [
            { name: "本周", index: 0 },
            { name: "上周", index: 1 },
            { name: "自定义周", index: 2 },
          ];
          dktimePickerArr = JSON.parse(JSON.stringify(PickerArr1));
          timePickerArr = PickerArr1;

          const startOfWeek = this.$dayjs().startOf("week").add(1, "day");
          startQueryTime = startOfWeek.format("YYYY-MM-DD");
          const endOfWeek = this.$dayjs().endOf("week").add(1, "day");
          endQueryTime = endOfWeek.format("YYYY-MM-DD");
          break;
        }
        case 3:
        case 4:
        case 5:
        case 7: {
          const PickerArr2 = [
            { name: "今天", index: 0 },
            { name: "昨天", index: 1 },
            { name: "自定义选择日期", index: 2 },
          ];
          dktimePickerArr = JSON.parse(JSON.stringify(PickerArr2));
          timePickerArr = PickerArr2;
          break;
        }
        default:
          console.error("Unknown clock frequency type:", frequencyType);
      }

      // 设置对象的属性
      this.dktimePickerArr = dktimePickerArr;
      this.timePickerArr = timePickerArr;
      this.startQueryTime = startQueryTime;
      this.endQueryTime = endQueryTime;
    },
    getRegistered() {
      var registeredlist = this.filterClockNameList.filter(
        (item) => item.clockNameStatus == 1 && item.name != null,
      );
      // console.log(registeredlist, "registeredlist", this.clockNameList);
      return registeredlist.length;
    },
    async _getProjectManageAdmin() {
      const result = await getProjectManageAdmin({
        activityId: this.activityId,
      });
      // console.log(result, "---", "invite=", this.invite);
      this.isOtherPeople = result.data;
      // if (this.isOtherPeople == 3) {
      //   this.choose = 1
      // }

      if (this.invite == 1 && this.isOtherPeople == 3) {
        this.$refs.memberPopShow.open();
      }
      // 签到状态显示隐藏
      if (
        this.checkInStatusSwitch == 1 &&
        (this.isOtherPeople == 1 || this.isOtherPeople == 2)
      ) {
        this.isShowSignStatus = 1;
      }
      if (this.checkInStatusSwitch == 2) {
        this.isShowSignStatus = 1;
      }
      this.firstDontGo = false;
      this.allowLoadMore = false;
      this.pageNum = 1;
      this._getSignListMore();
    },

    //展示分享弹窗
    shareClick(row) {
      // console.log(row, "row");

      // 设置活动链接
      if (row.activity_big_type == 2) {
        this.faceUrl =
          "/pages-mine/previewTemplate/previewTemplate?alias=" +
          row.activityKey +
          "&selectType=see&isType=" +
          row.activity_type;
      } else if (row.activity_big_type == 1 && row.activity_type != 108) {
        this.faceUrl =
          "/pages-mine/solataireGroupDetails/solataireGroupDetails?alias=" +
          row.activityKey +
          "&selectType=see&isType=" +
          row.activity_type;
      } else if (row.activity_big_type == 3) {
        this.faceUrl =
          "/pages-mine/poster/poster?alias=" +
          row.activityKey +
          "&selectType=see";
      } else if (row.activity_type == 108) {
        this.faceUrl =
          "/pages-mine/solitaireDetails/solitaireDetails?alias=" +
          row.activityKey +
          "&selectType=see&isType=" +
          row.activity_type;
      }

      if (row.is_folder) {
        this.shareTitle = "分享" + "    " + "    " + "    " + row.folderName;
      } else {
        this.shareTitle = "分享" + "    " + "    " + "    " + row.name;
      }

      // 获取二维码
      this.fetchActivityCode(row, false, true);
      this.dialogVisible = true;
    },

    handleSupplementCard() {
      // 去补卡
      this.$message.info("去补卡功能开发中...");
    },

    // 复制功能
    copyClick(text) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success("复制成功");
          })
          .catch(() => {
            this.$message.error("复制失败");
          });
      } else {
        // 兼容旧浏览器
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.$message.success("复制成功");
        } catch (err) {
          this.$message.error("复制失败");
        }
        document.body.removeChild(textArea);
      }
    },
    // 点击处理
    clickHandler(event) {
      this.isAcive = event.target.innerText;
    },
    // 处理地图位置跳转
    handleGoto(locationInfo) {
      if (
        !locationInfo ||
        (!locationInfo.latitude && !locationInfo.longitude)
      ) {
        this.$message.warning("位置信息不完整");
        return;
      }

      // 构建百度地图URL
      const lat = locationInfo.latitude;
      const lng = locationInfo.longitude;
      const name = locationInfo.name || locationInfo.address || "目标位置";

      // 使用百度地图API打开地图
      const baiduMapUrl = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${encodeURIComponent(
        name,
      )}&content=${encodeURIComponent(name)}&output=html&src=webapp`;

      // 在新窗口打开地图
      window.open(baiduMapUrl, "_blank");
    },
    // 以下方法是 ActivityPlayerItem 组件需要的事件处理包装器
    handlePlayerAvatarClick(item) {
      // 点击头像打开抽屉，组件内部已处理
      console.log("点击头像:", item);
    },
    handlePlayerClose(item) {
      console.log("关闭抽屉:", item);
    },
    handleOpenFile({ url, lastName, name }) {
      // 打开文件
      window.open(url, "_blank");
    },
    handleFormatFileSize({ size, fileType }) {
      // 格式化文件大小
      if (size / 1024 <= 1) {
        return this.setB(size, fileType);
      } else if (size / 1048576 <= 1) {
        return this.setKb(size, fileType);
      } else {
        return this.setMb(size, fileType);
      }
    },
    handlePreviewImage({ images, index }) {
      // 预览图片
      const imageUrls = Array.isArray(images)
        ? images.map((img) => (typeof img === "string" ? img : img.url))
        : [images];
      this.$preview(imageUrls, index);
    },
    handleGotoMap(value) {
      this.handleGoto(value);
    },
    handleThumbsUp(item) {
      this.thumbsUp(item, item.isDz, item.id);
    },
    handleAddRemark(item) {
      this.addRemark(item);
    },
    handleVerifyClick(item) {
      this.handleVerify(item);
    },
    handleBatchDrawing(item) {
      this.batchdrawing(item);
    },
    handleCommentOpen(item) {
      this.commentOpen(item);
    },
    handleOpenScoreDialog(item) {
      this.openScoreDialog(item);
    },
    handleEditPlayer(item) {
      this.editPlayer(item);
    },
    handleDelSign(item) {
      this.delSign(item);
    },
    handleCopyField(item) {
      this.copyFiled(item.sign_index, item.sign_info);
    },
    handleEditAllowView({ item, type }) {
      this.editAllowView(item, type);
    },
    handleDelComment({ comment, item }) {
      this.delComment(comment, item);
    },
    handleSeeMoreComments(id) {
      this.seeMoreComments(id);
    },
  },
};
</script>

<template>
  <Layout>
    <div class="detailRow">
      <div class="outBox">
        <div class="activity-detail-container">
          <div style="background: #fff; padding: 20px 20px 0 20px">
            <!-- 封面 -->
            <div
              class="index-fm-block"
              v-if="
                activityDetail.activityMode == 1 &&
                (playCoverImage || activityModeUrl)
              "
            >
              <div class="fm-pics-block" v-if="isVideo == 2">
                <el-carousel indicator-position="outside" :autoplay="false">
                  <el-carousel-item
                    v-for="(item, index) in turnPictures"
                    :key="index"
                  >
                    <div class="pic-out-box">
                      <img :src="item" alt="" />
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <template v-if="isVideo == 1">
                <div class="video-block">
                  <video
                    :src="playUrl"
                    :style="{ height: '400px' }"
                    controls
                    class="swiper-video"
                  >
                    Your browser does not support the video element.
                  </video>
                </div>
              </template>
            </div>

            <!-- 用户信息和标题 -->
            <div class="flex-depart-center">
              <div class="creator">
                <img
                  src="https://ossfastmake.mustke.com//12jielong/lsyJL/anonymoushead.png"
                  v-if="templatePage == 1"
                />
                <img
                  style="width: 41px; height: 41px"
                  :src="
                    activityDetail.isanonymous == 1
                      ? activityDetail.profilePhoto
                      : imageUrl2 + '/12jielong/lsyJL/anonymoushead.png'
                  "
                  v-else
                />

                <div style="display: flex; flex-direction: column">
                  <div class="footText" v-if="activityDetail.isanonymous == 1">
                    {{
                      activityDetail.publisher ? activityDetail.publisher : ""
                    }}
                  </div>
                  <div class="footText" v-if="activityDetail.isanonymous == 0">
                    匿名
                  </div>
                  <div
                    class="footTextTwo"
                    style="display: flex; align-items: center"
                  >
                    <div v-if="authInformation">
                      <img
                        src="https://ossfastmake.mustke.com/12jielong/lsyJL/peoplecertified.svg"
                        style="width: 53px; height: 28px; margin-right: 8px"
                        v-if="
                          authInformation.authStatus == 3 &&
                          authInformation.authType == 1
                        "
                      />

                      <img
                        src="https://ossfastmake.mustke.com/12jielong/lsyJL/getcertifiednew.png"
                        class="certificationMark"
                        style="width: 53px; height: 28px; margin-right: 8px"
                        v-if="
                          authInformation.authStatus == 3 &&
                          authInformation.authType == 2
                        "
                      />

                      <img
                        src="https://ossfastmake.mustke.com/12jielong/lsyJL/InstitutionalCertification.svg"
                        class="certificationMark"
                        style="width: 53px; height: 28px; margin-right: 8px"
                        v-if="
                          authInformation.authStatus == 3 &&
                          authInformation.authType == 3
                        "
                      />
                    </div>

                    <span> 发布时间:{{ activityDetail.addTime }}</span>
                  </div>
                </div>
              </div>

              <div class="flex-depart-center">
                <div
                  class="lxt"
                  v-if="activityDetail.phoneSwitch == 2"
                  @click="connectFn"
                >
                  联系TA
                </div>
              </div>
            </div>

            <div class="Biao2" v-if="activityDetail.name">
              {{ activityDetail.name }}
            </div>
            <!-- 内容 -->
            <div style="position: relative">
              <div class="Detailcontent" v-if="activityDetail.content">
                <div
                  class="con_Nei"
                  v-html="activityDetail.content"
                  :class="{
                    'is-small': activityDetail.fontSize === 2,
                    'is-medium': activityDetail.fontSize === 1,
                    'is-large': activityDetail.fontSize === 3,
                  }"
                ></div>
                <!-- <span class="fenge" v-if="templatePage != 1"></span> -->
              </div>

              <div class="fenge"></div>
              <div v-for="(item, index) in modular" :key="index">
                <!-- 内容 -->
                <div
                  class="newContentNew"
                  v-if="item.type == 1 && item.info.value"
                >
                  <div
                    class="newValue"
                    v-if="item.isCloneTf == 1 && item.info.title != ''"
                  >
                    <div class="left-bar-block"></div>
                    <div
                      class="Biao1"
                      :class="{
                        'is-small': activityDetail.fontSize === 2,
                        'is-medium': activityDetail.fontSize === 1,
                        'is-large': activityDetail.fontSize === 3,
                      }"
                    >
                      {{ item.info.title }}
                    </div>
                  </div>
                  <div
                    class="con_Nei"
                    :class="{
                      'is-small': activityDetail.fontSize === 2,
                      'is-medium': activityDetail.fontSize === 1,
                      'is-large': activityDetail.fontSize === 3,
                    }"
                    style="white-space: pre-wrap"
                  >
                    {{ item.info.value }}
                  </div>
                  <span class="fenge"></span>
                </div>
                <!-- 小图片 -->
                <div
                  v-if="item.type == 3 && item.info.imgarr.length > 0"
                  class="newContentNew"
                >
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <!-- 图片 -->
                  <div class="content5">
                    <div
                      v-for="(imgItem, imgIndex) in item.info.imgarr"
                      :key="imgIndex"
                      class="smallimg"
                      :style="{
                        background: `url(${
                          imageUrl2 + imgItem
                        }) no-repeat center`,
                        backgroundSize: 'cover',
                        boxSizing: 'border-box',
                      }"
                      @click="OpenImage(index, imgIndex, 1)"
                    ></div>
                  </div>
                  <span class="fenge"></span>
                </div>
                <!-- 大图片 -->
                <div
                  v-if="item.type == 9 && item.info.imgarr.length > 0"
                  class="newContentNew"
                >
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <!-- 图片 -->
                  <div class="imgBIgNew">
                    <img
                      v-for="(imgItem, imgIndex) in item.info.imgarr"
                      :key="imgIndex"
                      :src="imageUrl2 + imgItem"
                      @click="OpenImage(index, imgIndex, 1)"
                      style="
                        max-width: 100%;
                        display: block;
                        margin-bottom: 10px;
                      "
                    />
                  </div>
                  <span class="fenge"></span>
                </div>
                <!-- 地图 -->
                <div
                  class="newContentNew"
                  v-if="item.type == 4 && item.info.address"
                >
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <!-- 地图回显 -->
                  <div class="huimapMap">
                    <div class="mapMap">
                      <div
                        class="page-section page-section-gap"
                        @click="handleGoto(item.info)"
                        style="position: relative"
                      >
                        <div
                          style="
                            position: absolute;
                            z-index: 1;
                            opacity: 0;
                            left: 0;
                            top: 0;
                            width: 100%;
                            height: 130px;
                          "
                        ></div>
                      </div>
                    </div>
                    <div class="page-map">
                      <div style="font-weight: bold; font-size: 14px">
                        {{ item.info.name }}
                      </div>
                      <span style="font-size: 12px; color: #949eaf">{{
                        item.info.address
                      }}</span>
                    </div>
                  </div>
                  <span class="fenge"></span>
                </div>
                <!-- 文件 -->
                <div class="newContentNew" v-if="item.type == 5">
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <div
                    v-for="(fileItem, fileIndex) in item.info.filesArr"
                    :key="fileIndex"
                    @click="
                      openWen(
                        imageUrl2 + fileItem.fileUrl,
                        fileItem.lastName,
                        fileItem.name,
                      )
                    "
                  >
                    <div class="con4">
                      <div style="display: flex; align-items: center">
                        <div class="con4Img">
                          <img
                            v-if="fileItem.lastName == 'doc'"
                            :src="imageUrl2 + '/static/announcement/word.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'docx'"
                            :src="imageUrl2 + '/static/announcement/word.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'pdf'"
                            :src="imageUrl2 + '/static/announcement/PDF.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'ppt'"
                            :src="imageUrl2 + '/static/announcement/PPT.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'xls'"
                            :src="imageUrl2 + '/static/index/excel.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'xlsx'"
                            :src="imageUrl2 + '/static/index/excel.png'"
                            class="Img3"
                          />
                          <img
                            v-else-if="fileItem.lastName == 'zip'"
                            src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/zip.svg"
                            class="Img3"
                          />
                        </div>
                        <div>{{ fileItem.name }}</div>
                      </div>

                      <div class="con4_1">
                        <span v-if="fileItem.size / 1024 <= 1">{{
                          setB(fileItem.size, fileItem.lastName)
                        }}</span>
                        <span
                          v-else-if="
                            fileItem.size / 1024 >= 1 &&
                            fileItem.size / 1048576 <= 1
                          "
                          >{{ setKb(fileItem.size, fileItem.lastName) }}</span
                        >
                        <span v-else-if="fileItem.size / 1048576 >= 1">{{
                          setMb(fileItem.size, fileItem.lastName)
                        }}</span>
                      </div>
                    </div>
                    <span class="fenge" style="margin-bottom: 30px"></span>
                  </div>
                </div>
                <!-- 音频 -->
                <div class="newContentNew" v-if="item.type == 6">
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <div
                    v-for="(fileItem, fileIndex) in item.info.filesArr"
                    :key="fileIndex"
                  >
                    <audio :src="imageUrl2 + fileItem.fileUrl" controls>
                      Your browser does not support the audio element.
                    </audio>
                    <span class="fenge" style="margin-bottom: 30px"></span>
                  </div>
                </div>
                <!-- 视频 -->
                <div
                  class="newContentNew"
                  v-if="item.type == 7 && item.info.fileUrl"
                >
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <video
                    :src="imageUrl2 + item.info.fileUrl"
                    controls
                    style="
                      max-width: 100%;
                      width: 807px;
                      height: 454px;
                      display: block;
                      margin-bottom: 10px;
                    "
                  >
                    Your browser does not support the video element.
                  </video>
                  <span class="fenge"></span>
                </div>
                <!-- 视频号 -->
                <div
                  v-if="item.type == 11"
                  class="newContentNew"
                  @click="toWebdiv('sph')"
                >
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <image :src="imageUrl2 + '/static/newOne/zise.png'" />
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <div class="new-m-content">
                    <div class="show-one-line">
                      {{ item.info.videoNumberTitle }}
                    </div>
                    <div class="btns-style">播放视频</div>
                  </div>
                  <span class="fenge"></span>
                </div>
                <!-- 公众号 -->
                <div
                  v-if="item.type == 10"
                  class="newContentNew"
                  @click="toWebdiv('gzh')"
                >
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <div class="new-m-content">
                    <div class="show-one-line">
                      {{ item.info.officialAccountTitle }}
                    </div>
                  </div>
                  <span class="fenge"></span>
                </div>
                <!-- 小程序 -->
                <div
                  v-if="item.type == 12"
                  class="newContentNew"
                  @click="toWebdiv('xcx')"
                >
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <div class="new-m-content">
                    <div class="show-one-line">{{ item.info.appTitle }}</div>
                    <div class="btns-style">打开</div>
                  </div>
                  <span class="fenge"></span>
                </div>
                <!-- 一键复制区 -->
                <div v-if="item.type == 13" class="newContentNew">
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <div class="new-m-content">
                    <div
                      class="copybox"
                      v-html="
                        renderContentWithUrl(item.info.copy_region_conten)
                      "
                    ></div>
                    <div
                      class="copyStyle"
                      @click="copyContent(item.info.copy_region_conten)"
                    >
                      复制
                    </div>
                  </div>
                  <span class="fenge"></span>
                </div>
                <!-- 关联接龙 -->
                <div v-if="item.type == 14" class="newContentNew">
                  <div
                    class="newValue"
                    v-if="
                      item.isCloneTf == 1 &&
                      item.info.title != '' &&
                      item.info.value != ''
                    "
                  >
                    <div class="left-bar-block"></div>
                    <div class="Biao1">{{ item.info.value }}</div>
                  </div>
                  <div
                    v-for="(fileItem, fileIndex) in item.info
                      .associationActivityId"
                    :key="fileIndex"
                  >
                    <div class="con5 con5_flex" @click="todetail(fileItem)">
                      {{ fileItem.name }}
                    </div>
                  </div>
                  <span class="fenge"></span>
                </div>
              </div>
              <div class="lll">
                <span v-if="templatePage != 1">
                  浏览量:{{ activityDetail.browseNum }}
                </span>
                <span v-if="templatePage == 1"> 浏览量:99999+</span>
              </div>
              <div
                class="jlrules"
                v-if="isType == '109' || isType == '110' || isType == '104'"
              >
                <el-row class="rules-time" v-if="templatePage != 1">
                  <el-col :span="24" style="display: flex; align-items: center">
                    <div class="origin"></div>
                    <span class="text1">开始时间：</span>
                    <span>{{
                      activityDetail.beginTime ? activityDetail.beginTime : ""
                    }}</span>
                  </el-col>
                </el-row>
                <el-row class="rules-time" v-if="templatePage != 1">
                  <el-col :span="24" style="display: flex; align-items: center">
                    <div class="origin"></div>
                    <span class="text1">结束时间：</span>
                    <span>{{
                      activityDetail.endTime
                        ? new Date(activityDetail.endTime).getFullYear() ===
                          2099
                          ? "永久有效"
                          : activityDetail.endTime
                        : ""
                    }}</span>
                  </el-col>
                </el-row>
                <el-row class="rules-time" v-if="templatePage == 1">
                  <el-col :span="24" style="display: flex; align-items: center">
                    <div class="origin"></div>
                    <span class="text1">打卡日期：</span>
                  </el-col>
                </el-row>
                <el-row class="rules-time" v-if="templatePage == 1">
                  <el-col :span="24" style="display: flex; align-items: center">
                    <div class="origin"></div>
                    <span>保存即开始 ～ 结束时间</span>
                  </el-col>
                </el-row>
                <el-row class="rules-time" style="align-items: baseline">
                  <el-col :span="24" style="display: flex; align-items: center">
                    <div class="origin"></div>
                    <span class="text1">打卡要求：</span>
                    该项活动要求 {{ clockInfo.clockFrequencyName }},
                    <template v-if="clockFrequencyType == 1">
                      在{{ clockInfo.dayOfDate }}号
                      {{
                        clockInfo.timeOfDay != null
                          ? clockInfo.timeOfDay
                          : "00:00"
                      }}之前打卡
                    </template>
                    <template v-if="clockFrequencyType == 2">
                      在周{{ weekChineseNumbers[clockInfo.dayOfDate] }}
                      {{
                        clockInfo.timeOfDay != null
                          ? clockInfo.timeOfDay
                          : "00:00"
                      }}之前打卡
                    </template>
                    <template
                      v-if="
                        clockFrequencyType == 3 ||
                        clockFrequencyType == 4 ||
                        clockFrequencyType == 5
                      "
                    ></template>
                    <template v-if="clockFrequencyType == 6">
                      <span v-if="clockInfo.multiPeriodSwitch == 2">
                        在{{ formattedDays }},
                        <span
                          v-for="(item, index) in clockInfo.clockInTimeSlot"
                          :key="index"
                        >
                          {{ item.startTime }} ～ {{ item.endTime }}
                        </span>
                        打卡
                      </span>
                    </template>
                    <template v-if="clockFrequencyType == 7">
                      <span>在{{ clockInfo.customDate }}打卡</span>
                    </template>
                  </el-col>
                </el-row>
                <el-row class="rules-time">
                  <el-col :span="24">
                    <span>该项活动</span>
                    <span v-if="activityDetail.interdict_people_num == 0">
                      <span class="text2">不限制</span>参与人数,
                    </span>
                    <span v-if="activityDetail.interdict_people_num != 0">
                      限制参与人数<span class="text2">{{
                        activityDetail.interdict_people_num
                      }}</span
                      >人,
                    </span>
                    打卡后
                    <span v-if="activityDetail.updateSignInfo == 3">
                      在<span class="text2">活动终止前</span>允许修改打卡信息。
                    </span>
                    <span v-if="activityDetail.updateSignInfo == 1">
                      <span class="text2">不可修改</span>。
                    </span>
                    <span v-if="activityDetail.updateSignInfo == 2">
                      在<span class="text2"
                        >{{ activityDetail.registrationtime }} ~
                        {{ activityDetail.endregistrationtime }}</span
                      >允许修改打卡信息。
                    </span>
                    <span v-if="activityDetail.updateSignInfo == 4">
                      <span class="text2">允许修改打卡信息</span>
                    </span>
                  </el-col>
                </el-row>
                <el-row
                  class="rules-time"
                  v-if="
                    clockInfo.multiPeriodSwitch == 1 &&
                    (clockFrequencyType == 3 ||
                      clockFrequencyType == 4 ||
                      clockFrequencyType == 5 ||
                      clockFrequencyType == 6 ||
                      clockFrequencyType == 7)
                  "
                >
                  <el-col :span="24" style="display: flex; align-items: center">
                    <div class="origin"></div>
                    <span class="text1">打卡时间段：</span>
                    <div v-if="clockInfo.clockInTimeSlot.length > 0">
                      <span
                        v-for="(item, index) in clockInfo.clockInTimeSlot"
                        :key="index"
                      >
                        {{ item.startTime }} ～ {{ item.endTime }}
                      </span>
                    </div>
                  </el-col>
                </el-row>

                <el-row
                  class="rules-time"
                  v-if="clockFrequencyType == 1 || clockFrequencyType == 2"
                >
                  <el-col :span="24" style="display: flex; align-items: center">
                    <div class="origin"></div>
                    <span class="text1">截止打卡时间：</span>
                    <span>
                      {{ clockInfo.clockFrequencyName }}
                      <template v-if="clockFrequencyType == 1"
                        >{{ clockInfo.dayOfDate }}号</template
                      >
                      <template v-if="clockFrequencyType == 2"
                        >周{{
                          weekChineseNumbers[clockInfo.dayOfDate]
                        }}</template
                      >
                      {{
                        clockInfo.timeOfDay != null
                          ? clockInfo.timeOfDay
                          : "00:00"
                      }}
                    </span>
                  </el-col>
                </el-row>

                <el-row
                  class="rules-time"
                  v-if="clockInfo.clockLocationStatus == 1"
                  style="flex-direction: column; align-items: flex-start"
                >
                  <el-col :span="24" style="display: flex; align-items: center">
                    <div class="origin"></div>
                    <span class="text1">打卡地点：</span>
                  </el-col>
                  <el-col :span="24">
                    {{ clockInfo.clockLocationInfo.address }}（打卡范围：{{
                      clockInfo.clockRange
                    }}米以内）
                  </el-col>
                  <el-col
                    :span="24"
                    v-if="
                      (isType == '109' || isType == '110' || isType == '104') &&
                      clockInfo.clockLocationInfo != ''
                    "
                  >
                    <el-map
                      :latitude="clockInfo.clockLocationInfo.latitude"
                      :longitude="clockInfo.clockLocationInfo.longitude"
                      :markers="covers"
                      @click="handleGoto(clockInfo.clockLocationInfo)"
                      style="width: 660px; height: 260px"
                    >
                    </el-map>
                    <span>{{ clockInfo.clockLocationInfo.name }}</span>
                  </el-col>
                </el-row>
                <el-row class="rules-time">
                  <el-col :span="24" style="display: flex; align-items: center">
                    <div class="origin"></div>
                    <span class="text1">补卡时间：</span>
                    <span>活动结束前</span>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>

          <!-- 接龙完成情况及名单 -->
          <template v-if="clockSwitch > 1">
            <div
              class="jlName"
              v-if="
                cloneClocknameLength > 0 &&
                (isType == '109' ||
                  isType == '110' ||
                  isType == '106' ||
                  isType == '107' ||
                  isType == '105')
              "
            >
              <div
                class="sort"
                v-if="
                  !isSearch &&
                  (isType == '109' || isType == '110' || isType == '104') &&
                  cloneClocknameLength > 0 &&
                  clockFrequencyType != 8
                "
              >
                <div
                  class="select-list-box"
                  v-if="isType == '109' || isType == '110' || isType == '104'"
                >
                  <span
                    v-for="(item, index) in dktimePickerArr"
                    :key="item.index"
                    @click="
                      timeAndDKtimeChangeHandler(
                        index,
                        item.name,
                        'dktime',
                        'search',
                      )
                    "
                    :class="{ activeText: index == dktimeChangeIndex }"
                    >{{ item.name }}</span
                  >
                  <!--<CustomCalendar :isVisible="calendarShow" @change="handleDateChange" /> -->
                  <DatePicker
                    v-if="isDatePickerVisible"
                    :visible.sync="isDatePickerVisible"
                    title="选择日期"
                    :defaultDate="new Date()"
                    :minDate="
                      datePickerType === 'date' ? datePickerMinDate : null
                    "
                    :maxDate="
                      datePickerType === 'date' ? datePickerMaxDate : null
                    "
                    :type="datePickerType"
                    @confirm="handleDateConfirm"
                    @close="handleDateClose"
                  />
                </div>
              </div>
              <div class="jlName_top" v-if="!isSearch && templatePage != 1">
                <div
                  style="
                    color: #2b2f36;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                  "
                >
                  {{
                    isType == "109" || isType == "110" || isType == "104"
                      ? "打卡完成情况"
                      : "接龙完成情况"
                  }}
                  <template v-if="filterArrShow == false">
                    ：{{ registerednum }}/{{ clockNameList.length }}
                  </template>
                  <template v-if="filterArrShow == true">
                    ：{{ registerednum }}/{{ filterClockNameList.length }}
                  </template>

                  <image
                    src="../../static/img/reset.svg"
                    mode="widthFix"
                    style="width: 30px; height: 30px; margin-left: 8px"
                  ></image>
                </div>
                <div class="" style="display: flex; align-items: center">
                  <img
                    src="@/assets/images/search.png"
                    mode="widthFix"
                    @click="handleSearch()"
                    style="width: 30px; height: 30px; margin-right: 8px"
                  />
                  <div class="copynamelist" @click="copynotregistered()">
                    {{
                      isType == "109" || isType == "110" || isType == "104"
                        ? "复制未打卡名单"
                        : "复制未接龙名单"
                    }}
                  </div>
                  <!-- <div class="copynamelist" @click="searchData">
                                    重置
                                </div> -->
                </div>
              </div>
              <div class="jlName_top" v-else-if="templatePage == 1">
                <div style="color: #2b2f36; font-size: 30px">
                  {{
                    isType == "109" || isType == "110" || isType == "104"
                      ? "打卡完成情况"
                      : "接龙完成情况"
                  }}
                  <template v-if="filterArrShow == false">
                    ：{{ registerednum }}/{{ clockNameList.length }}
                  </template>
                  <template v-if="filterArrShow == true">
                    ：{{ registerednum }}/{{ filterClockNameList.length }}
                  </template>
                </div>
                <div class="" style="display: flex">
                  <image
                    src="../../static/img/search.svg"
                    mode="widthFix"
                    style="width: 20px; height: 20px; margin-right: 8px"
                  >
                  </image>
                  <div>搜索</div>
                  <div class="copynamelist" style="background-color: #9e9e9e">
                    {{
                      isType == "109" || isType == "110" || isType == "104"
                        ? "复制未打卡名单"
                        : "复制未接龙名单"
                    }}
                  </div>
                </div>
              </div>
              <div
                class="t-search"
                v-else
                @tap.stop="handleSearchAreaTap"
                style="
                  display: flex;
                  margin: 15px auto;
                  justify-content: space-between;
                  z-index: 999;
                "
              >
                <el-input
                  placeholder="请输入"
                  v-model="solitairenName"
                  @clear="clearSearchName"
                  clearable
                  style="width: 90%; z-index: 999"
                  @keyup.enter.native="searchData"
                ></el-input>
                <el-button
                  type="primary"
                  style="z-index: 999"
                  @click="searchData"
                  >搜索</el-button
                >
                <!-- <div class="scroll-yy divHui" v-if="isSearch"  catchtap="cancelSearch"></div>	 -->
              </div>

              <!--有分组-->
              <div
                class="flex-depart-center fz-select-box"
                @click="showPickerNameSetup"
                v-if="nameAddType == '2'"
              >
                <el-select
                  v-model="selectedPickerName"
                  placeholder="请选择分组"
                  @change="selectGrouping"
                >
                  <el-option
                    v-for="(item, index) in pickerNameSelectArr[0]"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="listName" v-if="templatePage != 1">
                <!-- clockNameList -->
                <template v-if="filterArrShow == false">
                  <div
                    class="span"
                    :class="{
                      'signed-item':
                        item.clockNameStatus == 1 && item.name != null,
                    }"
                    v-for="(item, index) in sortedClockNameList"
                    @click="toSign(activityDetail)"
                    :style="{
                      backgroundColor:
                        item.clockNameStatus == 1 && item.name != null
                          ? '#EBF3FF'
                          : '#F2F2F2',
                      color:
                        item.clockNameStatus == 1 && item.name != null
                          ? '#1877FF'
                          : '#626974',
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                    :key="index"
                  >
                    <div v-if="activityDetail.clockNameNumberSwitch == 1">
                      {{ index + 1 }}
                    </div>
                    <span>{{ item.clockName }}</span>
                    <i
                      v-if="item.clockNameStatus == 1 && item.name != null"
                      class="el-icon-check signed-icon"
                    ></i>
                  </div>
                  <div
                    class="spanDivEmpty"
                    :style="{
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                  ></div>
                  <div
                    class="spanDivEmpty"
                    :style="{
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                  ></div>
                  <div
                    class="spanDivEmpty"
                    :style="{
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                  ></div>
                  <div
                    class="spanDivEmpty"
                    :style="{
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                  ></div>
                  <div
                    class="spanDivEmpty"
                    :style="{
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                  ></div>
                  <div
                    class="spanDivEmpty"
                    :style="{
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                  ></div>
                  <div
                    class="spanDivEmpty"
                    :style="{
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                  ></div>
                  <div
                    class="spanDivEmpty"
                    :style="{
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                  ></div>
                </template>

                <!--搜索结果-->
                <template v-if="filterArrShow == true">
                  <div
                    class="span"
                    :class="{
                      'signed-item':
                        item.clockNameStatus == 1 && item.name != null,
                    }"
                    v-for="(item, index) in sortedFilterClockNameList"
                    @click="toSign(activityDetail)"
                    :style="{
                      backgroundColor:
                        item.clockNameStatus == 1 && item.name != null
                          ? '#EBF3FF'
                          : '#F2F2F2',
                      color:
                        item.clockNameStatus == 1 && item.name != null
                          ? '#1877FF'
                          : '#626974',
                      width: `calc((100% - ${
                        8 * clockListNumber
                      }px) / ${clockListNumber})`,
                    }"
                    :key="item.id"
                  >
                    <div>{{ index + 1 }}</div>
                    <span>{{ item.clockName }}</span>
                    <i
                      v-if="item.clockNameStatus == 1 && item.name != null"
                      class="el-icon-check signed-icon"
                    ></i>
                  </div>
                </template>
              </div>
              <div class="listName" v-if="templatePage == 1">
                <!-- clockNameList -->
                <div
                  class="span"
                  v-for="(item, index) in sortedClockNameList"
                  :style="{
                    backgroundColor:
                      item.clockNameStatus == 1 ? '#EBF3FF' : '#F2F2F2',
                    color: item.clockNameStatus == 1 ? '#1877FF' : '#626974',
                    width: `calc((100% - ${
                      8 * clockListNumber
                    }px) / ${clockListNumber})`,
                  }"
                  :key="index"
                >
                  <div v-if="activityDetail.clockNameNumberSwitch == 1">
                    {{ index + 1 }}
                  </div>
                  <span>{{ item.clockName }}</span>
                </div>
                <div
                  class="spanDivEmpty"
                  :style="{
                    width: `calc((100% - ${
                      8 * clockListNumber
                    }px) / ${clockListNumber})`,
                  }"
                ></div>
                <div
                  class="spanDivEmpty"
                  :style="{
                    width: `calc((100% - ${
                      8 * clockListNumber
                    }px) / ${clockListNumber})`,
                  }"
                ></div>
                <div
                  class="spanDivEmpty"
                  :style="{
                    width: `calc((100% - ${
                      8 * clockListNumber
                    }px) / ${clockListNumber})`,
                  }"
                ></div>
                <div
                  class="spanDivEmpty"
                  :style="{
                    width: `calc((100% - ${
                      8 * clockListNumber
                    }px) / ${clockListNumber})`,
                  }"
                ></div>
                <div
                  class="spanDivEmpty"
                  :style="{
                    width: `calc((100% - ${
                      8 * clockListNumber
                    }px) / ${clockListNumber})`,
                  }"
                ></div>
                <div
                  class="spanDivEmpty"
                  :style="{
                    width: `calc((100% - ${
                      8 * clockListNumber
                    }px) / ${clockListNumber})`,
                  }"
                ></div>
                <div
                  class="spanDivEmpty"
                  :style="{
                    width: `calc((100% - ${
                      8 * clockListNumber
                    }px) / ${clockListNumber})`,
                  }"
                ></div>
                <div
                  class="spanDivEmpty"
                  :style="{
                    width: `calc((100% - ${
                      8 * clockListNumber
                    }px) / ${clockListNumber})`,
                  }"
                ></div>
              </div>
            </div>
          </template>

          <div
            v-if="
              activityDetail.signInfoStatus == 1 ||
              isOtherPeople == 2 ||
              isOtherPeople == 1
            "
            class="player_content player_content2"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="20"
          >
            <div class="all_div16" style="background-color: white">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding-top: 20px;
                  padding-left: 20px;
                  padding-right: 20px;
                "
              >
                <!-- 左侧：参与人数和排行榜 -->
                <div style="display: flex; align-items: center">
                  <div class="participant-count" v-if="registraListTotal > 0">
                    参与列表
                    <span class="count-num"> ({{ registraListTotal }})</span>
                  </div>
                  <div
                    v-if="
                      activityDetail.showRanking == 2 &&
                      (isType == 104 || isType == 109)
                    "
                  >
                    <el-button
                      type="primary"
                      icon="el-icon-trophy"
                      @click="toRankPage"
                      >排行榜</el-button
                    >
                  </div>
                </div>
                <!-- 右侧：订单管理 -->
                <div
                  v-if="isType == '101' && isOtherPeople == 1"
                  class="order-manage-link"
                  @click="handleOrderManagement"
                >
                  订单管理
                  <i class="el-icon-arrow-right"></i>
                  <el-badge
                    :value="orderUnreadSum"
                    :max="99"
                    class="order-badge"
                    v-if="orderUnreadSum > 0"
                  ></el-badge>
                </div>
                <!-- 右侧：视图模式切换标签 -->
                <div class="view-mode-switch" v-if="isType != '101'">
                  <span
                    :class="{ active: dataSchema === 1 }"
                    @click="switchViewMode(1)"
                  >
                    <i class="el-icon-s-operation"></i> 列表
                  </span>
                  <span
                    :class="{ active: dataSchema === 2 }"
                    @click="switchViewMode(2)"
                  >
                    <i class="el-icon-user"></i> 头像
                  </span>
                </div>
              </div>
              <!-- 日期选择器（放到第二行） -->
              <div
                class="select-list-box"
                v-if="isType == '109' || isType == '110' || isType == '104'"
                style="padding: 10px 20px"
              >
                <span
                  v-for="(item, index) in timePickerArr"
                  :key="item.index"
                  @click="
                    timeAndDKtimeChangeHandler(
                      index,
                      item.name,
                      'time',
                      'reset',
                    )
                  "
                  :class="{ activeText: index == timeChangeIndex }"
                >
                  {{ item.name }}</span
                >
                <!--<CustomCalendar :isVisible="calendarShow" @change="handleDateChange" /> -->
                <DatePicker
                  v-if="isDatePickerVisible"
                  :visible.sync="isDatePickerVisible"
                  title="选择日期"
                  :defaultDate="new Date()"
                  :minDate="
                    datePickerType === 'date' ? datePickerMinDate : null
                  "
                  :maxDate="
                    datePickerType === 'date' ? datePickerMaxDate : null
                  "
                  :type="datePickerType"
                  @confirm="handleDateConfirm"
                  @close="handleDateClose"
                />
              </div>
              <!-- 头像模式 -->
              <div v-if="dataSchema === 2" class="avatar-mode-container">
                <div class="avatar-mode-tip">头像已按照拼音排序</div>
                <div
                  class="avatar-item"
                  v-for="(item, index) in registraList"
                  :key="index"
                  @click="openPlayerDrawer(item)"
                >
                  <div class="avatar-box">
                    <img
                      v-if="
                        activityDetail.anonymousparticipation == 0 ||
                        memberId == item.create_user_id ||
                        isOtherPeople == 2
                      "
                      :src="
                        item.profile_photo
                          ? item.profile_photo
                          : imageUrl2 + '/12jielong/lsyJL/anonymoushead.png'
                      "
                    />
                    <img
                      v-else
                      :src="imageUrl2 + '/12jielong/lsyJL/anonymoushead.png'"
                    />
                  </div>
                  <div class="avatar-name">
                    <span
                      v-if="
                        activityDetail.anonymousparticipation == 0 ||
                        memberId == item.create_user_id ||
                        isOtherPeople == 2
                      "
                    >
                      {{ item.name ? item.name : item.nickname }}
                    </span>
                    <span v-else>匿名</span>
                  </div>
                </div>
                <div class="avatar-item-empty"></div>
                <div class="avatar-item-empty"></div>
                <div class="avatar-item-empty"></div>
                <div class="avatar-item-empty"></div>
                <!-- 加载更多 -->
                <div
                  class="load-more-btn"
                  v-if="hasMore && registraList.length > 0"
                  @click="loadMore"
                >
                  <span v-if="loading">加载中...</span>
                  <template v-else>
                    <span>加载更多</span>
                    <img :src="imageUrl2 + '/12jielong/lsyJL/Order-Details-SeeMore.gif'" class="load-more-icon" />
                  </template>
                </div>
                <div class="no-more-data" v-if="!hasMore && registraList.length > 0">
                  没有更多数据了
                </div>
              </div>
              <!-- 列表模式 -->
              <template v-if="dataSchema === 1">
                <div
                  class="titleT"
                  v-for="(item, index) in registraList"
                  :key="index"
                >
                  <div class="titleCon">
                    <div class="titleTop">
                      <div class="tx">
                        <!-- 头像 -->
                        <div
                          class="header"
                          @click.stop="openPlayerDrawer(item)"
                        >
                          <img
                            v-if="
                              activityDetail.anonymousparticipation == 0 ||
                              memberId == item.create_user_id ||
                              isOtherPeople == 2
                            "
                            :src="
                              item.profile_photo
                                ? item.profile_photo
                                : imageUrl2 +
                                  '/12jielong/lsyJL/anonymoushead.png'
                            "
                          />
                          <img
                            v-else
                            :src="
                              imageUrl2 + '/12jielong/lsyJL/anonymoushead.png'
                            "
                          />
                        </div>
                        <!-- 微信昵称 -->
                        <div class="content_con">
                          <div
                            class="Biao"
                            v-if="
                              activityDetail.anonymousparticipation == 0 ||
                              memberId == item.create_user_id ||
                              isOtherPeople == 2
                            "
                          >
                            {{ item.name ? item.name : item.nickname }}
                            <img
                              class="no-see"
                              v-if="item.allow_diving == 2"
                              src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-nosee.svg"
                            />
                          </div>
                          <div v-else class="niming">
                            匿名
                            <span
                              v-if="item.user_id == memberId"
                              style="color: #1877ff"
                              >(我)</span
                            >
                            <img
                              class="no-see"
                              v-if="item.allow_diving == 2"
                              src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-nosee.svg"
                            />
                          </div>
                          <div class="time">
                            <span v-if="item.registration_id"
                              >ID: {{ item.registration_id }}
                            </span>
                            接龙时间 {{ item.add_time }}
                          </div>
                        </div>
                      </div>

                      <div
                        class=""
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                        "
                        v-if="item.score"
                      >
                        <div
                          style="
                            font-style: italic;
                            font-weight: bold;
                            color: #f73b42;
                            font-size: 19px;
                            padding-right: 28px;
                          "
                        >
                          {{ item.score }}
                        </div>
                      </div>

                      <div
                        class=""
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                        "
                      >
                        <div class="xuhao">#{{ item.sign_index }}</div>
                      </div>
                    </div>
                    <div
                      class="comment_cont"
                      v-if="item.addcomment != undefined && item.addcomment"
                    >
                      {{ item.comment_name }}点评：{{ item.addcomment }}
                    </div>

                    <div
                      class="content"
                      style="
                        margin-top: 10px !important;
                        padding: 0px !important;
                      "
                      v-if="
                        activityDetail.anonymousparticipation == 0 ||
                        memberId == item.create_user_id
                      "
                    >
                      <!-- 内容 -->
                      <div class="bmfooter" hover-stop-propagation="true">
                        <!-- 付费信息 -->
                        <div
                          class="footer_text"
                          v-if="
                            (item.charge_name || item.charge_item_name) &&
                            item.unit_price !== undefined &&
                            item.unit_price !== null &&
                            item.unit_price !== ''
                          "
                        >
                          <div class="mar15-0">
                            <span
                              class="playerContentTitle"
                              style="font-weight: 600"
                              >付费项:</span
                            >
                            <span
                              style="
                                color: #323b5f;
                                font-size: 14px;
                                font-weight: 600;
                              "
                              >{{
                                item.charge_name || item.charge_item_name
                              }}</span
                            >
                          </div>
                          <div
                            class="mar15-0"
                            v-if="
                              isOtherPeople == 1 ||
                              isOtherPeople == 2 ||
                              memberId == item.create_user_id
                            "
                          >
                            <span
                              class="playerContentTitle"
                              style="font-weight: 600"
                              >金额:</span
                            >
                            <span
                              style="
                                color: #323b5f;
                                font-size: 14px;
                                font-weight: 600;
                              "
                              >¥{{ item.unit_price }}</span
                            >
                          </div>
                        </div>
                        <div
                          class="footer_text"
                          v-for="(fieldItem, fieldIndex) in item.sign_info"
                          :key="fieldIndex"
                        >
                          <!--    姓名/性别/手机号/数量/身份证/省市区/时间    -->
                          <div
                            class="mar15-0"
                            v-if="
                              fieldItem.type == 1 ||
                              fieldItem.type == 2 ||
                              fieldItem.type == 11 ||
                              fieldItem.type == 13 ||
                              fieldItem.type == 3 ||
                              fieldItem.type == 10 ||
                              fieldItem.type == 8 ||
                              fieldItem.type == 4 ||
                              fieldItem.type == 15 ||
                              fieldItem.type == 19 ||
                              fieldItem.type == 21 ||
                              fieldItem.type == 22 ||
                              fieldItem.type == 23 ||
                              fieldItem.type == 24 ||
                              fieldItem.type == 25 ||
                              fieldItem.type == 26 ||
                              fieldItem.type == 27 ||
                              fieldItem.type == 28 ||
                              fieldItem.type == 31
                            "
                          >
                            <div
                              v-if="fieldItem.isOpen == 1 || isOtherPeople != 3"
                            >
                              <span
                                style="color: #666666; margin-right: 20px"
                                class="playerContentTitle"
                                >{{ fieldItem.fieldName }}:</span
                              >
                              <span style="color: #323b5f; font-size: 14px">{{
                                fieldItem.type == 1 &&
                                fieldIndex == 0 &&
                                item.list_group_name
                                  ? item.list_group_name +
                                    "-" +
                                    (fieldItem.value || "无")
                                  : fieldItem.value
                                  ? fieldItem.value
                                  : "无"
                              }}</span>
                            </div>
                            <div
                              v-if="
                                fieldItem.areaSelectType == 3 &&
                                fieldItem.provinceCityDistrictAddress != null
                              "
                            >
                              <span style="color: #666666"></span
                              >{{ fieldItem.provinceCityDistrictAddress }}
                            </div>
                          </div>

                          <div v-if="fieldItem.type == 32" class="mar15-0">
                            <div
                              v-if="fieldItem.isOpen == 1 || isOtherPeople != 3"
                            >
                              <span
                                style="color: #666666; margin-right: 20px"
                                class="playerContentTitle"
                                >{{ fieldItem.fieldName }}:</span
                              >
                              <span
                                v-if="fieldItem.value.length == 0"
                                style="color: #323b5f; font-size: 14px"
                                >无</span
                              >
                            </div>
                            <div
                              v-if="fieldItem.value != null"
                              class="file-sign-box"
                              style="margin-top: 7px"
                            >
                              <div
                                class="file-sign-item"
                                style="box-sizing: border-box"
                                v-for="(fileItem, fileIndex) in fieldItem.value"
                                :key="fileIndex"
                              >
                                <div
                                  class="con4 con4_flex"
                                  @click="
                                    openWen(
                                      imageUrl2 + fileItem.fileUrl,
                                      fileItem.lastName,
                                      fileItem.name,
                                    )
                                  "
                                >
                                  <div
                                    class=""
                                    style="align-items: center !important"
                                  >
                                    <div style="display: flex">
                                      <div class="con4Img">
                                        <img
                                          v-if="fileItem.lastName == 'doc'"
                                          :src="
                                            imageUrl2 +
                                            '/static/announcement/word.png'
                                          "
                                          class="Img3"
                                        />
                                        <img
                                          v-else-if="
                                            fileItem.lastName == 'docx'
                                          "
                                          :src="
                                            imageUrl2 +
                                            '/static/announcement/word.png'
                                          "
                                          class="Img3"
                                        />
                                        <img
                                          v-else-if="fileItem.lastName == 'pdf'"
                                          :src="
                                            imageUrl2 +
                                            '/static/announcement/PDF.png'
                                          "
                                          class="Img3"
                                        />
                                        <img
                                          v-else-if="fileItem.lastName == 'ppt'"
                                          :src="
                                            imageUrl2 +
                                            '/static/announcement/PPT.png'
                                          "
                                          class="Img3"
                                        />
                                        <img
                                          v-else-if="fileItem.lastName == 'xls'"
                                          :src="
                                            imageUrl2 +
                                            '/static/index/excel.png'
                                          "
                                          class="Img3"
                                        />
                                        <img
                                          v-else-if="
                                            fileItem.lastName == 'xlsx'
                                          "
                                          :src="
                                            imageUrl2 +
                                            '/static/index/excel.png'
                                          "
                                          class="Img3"
                                        />
                                        <img
                                          v-else-if="fileItem.lastName == 'zip'"
                                          src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/zip.svg"
                                          class="Img3"
                                        />
                                      </div>
                                      <div>{{ fileItem.name }}</div>
                                    </div>

                                    <div class="con4_1">
                                      <span v-if="fileItem.size / 1024 <= 1">{{
                                        setB(fileItem.size, fileItem.lastName)
                                      }}</span>
                                      <span
                                        v-else-if="
                                          fileItem.size / 1024 >= 1 &&
                                          fileItem.size / 1048576 <= 1
                                        "
                                        >{{
                                          setKb(
                                            fileItem.size,
                                            fileItem.lastName,
                                          )
                                        }}</span
                                      >
                                      <span
                                        v-else-if="fileItem.size / 1048576 >= 1"
                                        >{{
                                          setMb(
                                            fileItem.size,
                                            fileItem.lastName,
                                          )
                                        }}</span
                                      >
                                    </div>
                                  </div>
                                </div>
                                <!--                                                        <u-line margin="20px" length="93%"></u-line>-->
                              </div>
                            </div>
                          </div>

                          <!-- 图片/位置/视频/录音/14？ -->
                          <div
                            class="newContent mar15-0"
                            style="margin-bottom: 8px"
                            v-if="
                              (fieldItem.type == 5 ||
                                fieldItem.type == 12 ||
                                fieldItem.type == 6 ||
                                fieldItem.type == 7 ||
                                fieldItem.type == 14) &&
                              (fieldItem.isOpen == 1 || isOtherPeople != 3) &&
                              (fieldItem.value == '' || !fieldItem.value)
                            "
                          >
                            <span
                              style="color: #666666; margin-right: 20px"
                              class="playerContentTitle"
                              >{{ fieldItem.fieldName }}:</span
                            >
                            <span style="color: #323b5f; font-size: 14px"
                              >无</span
                            >
                          </div>
                          <!-- 多行文本 -->
                          <div
                            class="newContent mar15-0"
                            v-else-if="fieldItem.type == 9"
                          >
                            <div
                              class="nameMa"
                              v-if="fieldItem.isOpen == 1 || isOtherPeople != 3"
                            >
                              <span
                                style="color: #666666"
                                class="playerContentTitle"
                                >{{ fieldItem.fieldName }}:</span
                              >
                              <span> {{ fieldItem.value ? "" : "无" }}</span>
                              <div
                                v-if="fieldItem.value"
                                style="
                                  color: #323b5f;
                                  white-space: pre-wrap;
                                  word-break: break-all;
                                  word-wrap: break-word;
                                  font-size: 14px;
                                "
                              >
                                {{ fieldItem.value }}
                              </div>
                            </div>
                          </div>
                          <!-- 健康码 行程码 -->
                          <div
                            class="newContent mar15-0"
                            v-else-if="
                              fieldItem.type == 14 && fieldItem.value != ''
                            "
                          >
                            <div
                              class="nameMa"
                              v-if="fieldItem.isOpen == 1 || isOtherPeople != 3"
                            >
                              <span
                                style="color: #666666"
                                class="playerContentTitle"
                                >{{ fieldItem.fieldName }}</span
                              >
                              <div class="imgMa">
                                <img
                                  :src="imageUrl2 + fieldItem.value"
                                  v-if="fieldItem.value"
                                  @click.stop="
                                    OpenImage(imageUrl2 + fieldItem.value)
                                  "
                                />
                                <span
                                  style="color: #323b5f; font-size: 14px"
                                  v-if="fieldItem.value == ''"
                                  >无</span
                                >
                              </div>
                            </div>
                          </div>
                          <!-- 录音 -->
                          <div
                            class="newContent mar15-0"
                            v-else-if="
                              (fieldItem.type == 7 &&
                                fieldItem.isOpen == 1 &&
                                fieldItem.value != '') ||
                              (fieldItem.type == 7 &&
                                isOtherPeople != 3 &&
                                fieldItem.value != '')
                            "
                          >
                            <span
                              style="
                                color: #666666;
                                margin-bottom: 8px;
                                display: inline-block;
                              "
                              class="playerContentTitle"
                              >{{ fieldItem.fieldName }}</span
                            >
                            <div class="greenBtn1">
                              <audio controls>
                                <source :src="fieldItem.value.url" />
                              </audio>
                              <!-- <span>{{seconde(fieldItem.value.time)}}</span> -->
                              <!-- <span>{{
                              fieldItem.value.name ? fieldItem.value.name : "无"
                            }}</span> -->
                            </div>
                          </div>
                          <!-- 视频 -->
                          <div
                            class="newContent mar15-0"
                            catchtap="parentTap"
                            v-else-if="
                              (fieldItem.type == 6 &&
                                fieldItem.isOpen == 1 &&
                                fieldItem.value != '') ||
                              (fieldItem.type == 6 &&
                                isOtherPeople != 3 &&
                                fieldItem.value != '')
                            "
                          >
                            <span
                              style="
                                color: #666666;
                                margin-bottom: 8px;
                                display: inline-block;
                              "
                              class="playerContentTitle"
                              >{{ fieldItem.fieldName }}</span
                            >
                            <video
                              :src="fieldItem.videoUrl"
                              controls
                              v-if="fieldItem.videoUrl"
                              style="
                                max-width: 100%;
                                width: 807px;
                                height: 454px;
                                display: block;
                                margin-bottom: 10px;
                              "
                            >
                              Your browser does not support the video element.
                            </video>
                            <!-- <span style="color: #323b5f; font-size: 14px">{{
                            fieldItem.value ? fieldItem.value : "无"
                          }}</span> -->
                          </div>
                          <!-- 图片 -->
                          <div
                            class="newContent mar15-0"
                            v-else-if="
                              ((fieldItem.type == 5 || fieldItem.type == 35) &&
                                fieldItem.isOpen == 1 &&
                                fieldItem.value != '') ||
                              ((fieldItem.type == 5 || fieldItem.type == 35) &&
                                isOtherPeople != 3 &&
                                fieldItem.value != '')
                            "
                          >
                            <span
                              style="color: #666666"
                              class="playerContentTitle"
                              >{{ fieldItem.fieldName }}</span
                            >
                            <!-- 图片 -->
                            <div class="content5-new">
                              <div
                                class="image-wrapper-new"
                                v-for="(imgItem, imgIndex) in fieldItem.value"
                                :key="imgIndex"
                              >
                                <img
                                  class="con5-img"
                                  :src="getFullImageUrl(imgItem)"
                                  mode="aspectFill"
                                  @click.stop="
                                    predivImageFn(fieldItem.value, imgIndex)
                                  "
                                  v-if="fieldItem.value"
                                />
                                ·
                                <span
                                  style="color: #323b5f; font-size: 14px"
                                  v-if="fieldItem.value.length == 0"
                                  >无</span
                                >
                                <!-- 添加遮罩层 -->
                                <div
                                  class="image-overlay"
                                  v-if="item.showEditIcons"
                                  @click.stop="
                                    startAnnotation(
                                      fieldItem.value,
                                      imgIndex,
                                      item.id,
                                      fieldItem.id,
                                    )
                                  "
                                >
                                  <img
                                    :src="
                                      imageUrl2 + '/12jielong/lsyJL/pitu.png'
                                    "
                                    class="edit-icon"
                                  />
                                </div>
                              </div>
                              <div class="image-wrapper-new-empty"></div>
                              <div class="image-wrapper-new-empty"></div>
                            </div>
                          </div>
                          <!-- 水印 -->
                          <div
                            class="newContent mar15-0"
                            v-else-if="
                              (fieldItem.type == 20 &&
                                fieldItem.isOpen == 1 &&
                                fieldItem.watermarkImageUrl != '') ||
                              (fieldItem.type == 20 &&
                                isOtherPeople != 3 &&
                                fieldItem.watermarkImageUrl != '')
                            "
                          >
                            <span
                              style="color: #666666"
                              class="playerContentTitle"
                              >{{ fieldItem.fieldName }}</span
                            >
                            <!-- 图片 -->
                            <div class="content5">
                              <img
                                :src="fieldItem.watermarkImageUrl"
                                @click.stop="
                                  predivImageFn(fieldItem.watermarkImageUrl, 0)
                                "
                                v-if="fieldItem.watermarkImageUrl"
                              />
                              <span
                                style="color: #323b5f; font-size: 14px"
                                v-if="fieldItem.watermarkImageUrl == ''"
                                >无</span
                              >
                            </div>
                          </div>
                          <!-- 手写签名 -->
                          <div
                            class="newContent mar15-0"
                            v-else-if="
                              (fieldItem.type == 29 && fieldItem.isOpen == 1) ||
                              (fieldItem.type == 29 && isOtherPeople != 3)
                            "
                          >
                            <span
                              style="
                                color: #666666;
                                margin-right: 20px;
                                display: inline-block;
                              "
                              :style="{
                                marginBottom: fieldItem.value ? '7px' : '0',
                              }"
                              class="playerContentTitle"
                              >{{ fieldItem.fieldName }}:
                            </span>
                            <span
                              style="color: #323b5f; font-size: 14px"
                              v-if="fieldItem.value == ''"
                              >无</span
                            >
                            <!-- 图片 -->
                            <div
                              class="content5"
                              style="background-color: #fff"
                            >
                              <img
                                :src="getFullImageUrl(fieldItem.value)"
                                @click.stop="
                                  predivImageFn(
                                    getFullImageUrl(fieldItem.value),
                                    0,
                                  )
                                "
                                v-if="fieldItem.value"
                              />
                            </div>
                          </div>
                          <!-- 地图 -->
                          <div
                            class="newContent mar15-0"
                            v-else-if="
                              (fieldItem.type == 12 &&
                                fieldItem.isOpen == 1 &&
                                fieldItem.value != '') ||
                              (fieldItem.type == 12 &&
                                isOtherPeople != 3 &&
                                fieldItem.value != '')
                            "
                          >
                            <div>
                              <span
                                style="color: #666666; margin-right: 20px"
                                class="playerContentTitle"
                                >{{ fieldItem.fieldName }}:</span
                              >
                              <span style="color: #323b5f; font-size: 14px">{{
                                fieldItem.value.address
                                  ? fieldItem.value.address
                                  : "无"
                              }}</span>
                            </div>

                            <!-- 地图回显 -->
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                flex-direction: column;
                                margin-top: 8px;
                              "
                            >
                              <div
                                class="page-map"
                                @click.stop="handleGoto(fieldItem.value)"
                              >
                                <image
                                  class="map-posi"
                                  src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-position3.svg"
                                >
                                </image>
                                {{
                                  fieldItem.value.name
                                    ? fieldItem.value.name
                                    : "无"
                                }}
                              </div>
                            </div>
                          </div>
                          <!-- 文件签字 -->
                          <div
                            class="newContent mar15-0"
                            v-else-if="
                              (fieldItem.type == 36 && fieldItem.isOpen == 1) ||
                              (fieldItem.type == 36 && isOtherPeople != 3)
                            "
                          >
                            <span
                              style="color: #666666"
                              class="playerContentTitle"
                              >{{ fieldItem.fieldName }}</span
                            >
                            <!-- 图片 -->
                            <div class="content5-new">
                              <div
                                class="image-wrapper-new"
                                v-for="(
                                  imgItem, imgIndex
                                ) in fieldItem.localvalue"
                                :key="imgIndex"
                              >
                                <img
                                  class="con5-img"
                                  :src="getFullImageUrl(imgItem)"
                                  mode="aspectFill"
                                  @click.stop="seeBigImg(imgItem)"
                                  v-if="fieldItem.localvalue"
                                />
                              </div>
                              <span
                                style="color: #323b5f; font-size: 14px"
                                v-if="!fieldItem.localvalue"
                                >无</span
                              >
                              <div class="image-wrapper-new-empty"></div>
                              <div class="image-wrapper-new-empty"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="line"
                                        v-if="activityDetail.anonymousparticipation==0 ||memberId==item.create_user_id||isOtherPeople==2 || item.user_id == memberId">
                                    </div> -->
                    <div
                      class="d-flex"
                      style="
                        display: flex;
                        max-width: 850px;
                        min-height: 60px;
                        justify-content: flex-start;
                        width: 100%;
                        box-shadow: 0 1px 4px rgba(244, 244, 244, 0.5);
                        flex-wrap: wrap;
                      "
                      v-if="
                        isType != 101 &&
                        isType != '101' &&
                        (activityDetail.anonymousparticipation == 0 ||
                          memberId == item.create_user_id ||
                          isOtherPeople == 2 ||
                          item.user_id == memberId)
                      "
                    >
                      <!-- 点赞 -->
                      <div
                        class="thumbs_box"
                        @click.stop="thumbsUp(item, item.isDz, item.id)"
                        v-if="activityDetail.thumbs_up == 1"
                      >
                        <img
                          :src="
                            imageUrl2 + '/12jielong/lsyJL/already_liked.svg'
                          "
                          v-if="item.isDz == 'true'"
                        />
                        <img
                          :src="
                            imageUrl2 + '/12jielong/lsyJL/thumbs_up_hollow.svg'
                          "
                          v-if="item.isDz == 'false'"
                        />
                        <span
                          :style="{
                            color: item.isDz == 'false' ? '#3D4563' : '#1877ff',
                          }"
                        >
                          {{ item.thumbs_up_number }}</span
                        >
                      </div>
                      <div
                        class="thumbs_box"
                        @click="addRemark(item)"
                        v-if="activityDetail.isMessage == 1"
                      >
                        <img
                          :src="imageUrl2 + '/12jielong/lsyJL/pinglun.png'"
                        />
                        <span style="color: #626262">{{
                          commentStates[item.id]?.totalRow
                        }}</span>
                      </div>
                      <div
                        class="thumbs_box"
                        @click="handleVerify(activityDetail)"
                        v-if="
                          activityDetail.verificationSwitch == 2 &&
                          isOtherPeople == 1
                        "
                      >
                        <img
                          style="height: 13px; width: 12px"
                          src="@/assets/images/pitu.png"
                        />
                        <span style="color: #626262">核销</span>
                      </div>
                      <div
                        class="thumbs_box"
                        @click="batchdrawing(item)"
                        v-if="
                          item.sign_info.some((f) => [5].includes(f.type)) &&
                          (isOtherPeople == 1 || isOtherPeople == 2)
                        "
                      >
                        <img
                          style="height: 13px; width: 12px"
                          src="@/assets/images/pitu.png"
                        />
                        <span style="color: #626262">批图</span>
                      </div>
                      <div
                        class="thumbs_box"
                        @click="commentOpen(item)"
                        v-if="
                          (item.create_user_id == memberId &&
                            activityDetail.is_comment == 1) ||
                          isOtherPeople == 2
                        "
                      >
                        <img
                          style="height: 13px; width: 12px"
                          src="@/assets/images/dianping.png"
                        />
                        <span style="color: #626262">点评</span>
                      </div>
                      <div
                        class="thumbs_box"
                        @click="openScoreDialog(item)"
                        v-if="
                          (item.create_user_id == memberId &&
                            activityDetail.is_score == 1) ||
                          isOtherPeople == 2
                        "
                      >
                        <img
                          style="height: 13px; width: 12px"
                          src="@/assets/images/score.png"
                        />
                        <span style="color: #626262">评分</span>
                      </div>
                      <div
                        class="thumbs_box"
                        @click="editPlayer(item)"
                        v-if="
                          item.user_id == memberId ||
                          item.create_user_id == memberId ||
                          isOtherPeople == 2
                        "
                      >
                        <img
                          style="height: 13px; width: 12px"
                          src="@/assets/images/edit.png"
                        />
                        <span style="color: #626262">修改</span>
                      </div>
                      <div
                        class="thumbs_box"
                        @click="delSign(item)"
                        v-if="
                          item.user_id == memberId ||
                          item.create_user_id == memberId ||
                          isOtherPeople == 2
                        "
                      >
                        <img
                          style="height: 13px; width: 12px"
                          src="@/assets/images/del.png"
                        />
                        <span style="color: #626262">删除</span>
                      </div>
                      <div
                        class="thumbs_box"
                        @click="copyFiled(item.sign_index, item.sign_info)"
                        v-if="isOtherPeople == 1 || isOtherPeople == 2"
                      >
                        <img
                          style="height: 13px; width: 12px"
                          src="https://ossfastmake.mustke.com/12jielong/lsyJL/copy.svg"
                        />
                        <span style="color: #626262">复制</span>
                      </div>
                      <div
                        class="thumbs_box"
                        @click="editAllowView(item, 1)"
                        v-if="
                          (item.create_user_id == memberId ||
                            isOtherPeople == 2) &&
                          item.allow_viewing == 2
                        "
                      >
                        <span style="color: #626262">允许他人查看</span>
                      </div>
                      <div
                        class="thumbs_box"
                        @click="editAllowView(item, 2)"
                        v-if="
                          (item.create_user_id == memberId ||
                            isOtherPeople == 2) &&
                          item.allow_viewing != 2
                        "
                      >
                        <span style="color: #626262">不允许他人查看</span>
                      </div>
                    </div>

                    <div
                      class="pllist"
                      style="position: relative"
                      v-if="
                        pllist.filter((c) => c.orderId === item.id).length > 0
                      "
                    >
                      <!-- 根据 showCommentCount 显示相应数量的评论 -->
                      <div
                        v-for="(comment, commentIndex) in pllist.filter(
                          (c) => c.orderId === item.id,
                        )"
                        :key="commentIndex"
                        style="
                          display: flex;
                          margin-bottom: 8px;
                          align-items: center;
                          position: relative;
                        "
                      >
                        <div class="comment-wrapper">
                          <div class="plName">
                            <span class="nickname">{{ comment.name }}:</span>
                            <span class="comment-text">{{
                              comment.comment
                            }}</span>
                          </div>
                          <div
                            class="del"
                            style="
                              position: absolute;
                              right: 0;
                              top: 50%;
                              transform: translateY(-50%);
                            "
                            @click="delComment(comment, item)"
                            v-if="
                              comment.userId == memberId ||
                              setInfo.create_user_id == memberId ||
                              isOtherPeople == 2
                            "
                          >
                            <i class="el-icon-delete"></i>
                          </div>
                        </div>
                        <!--											<img :src="comment.profilePhoto" class="pltx">-->
                        <!--											<div class="plName">{{ comment.name }}:</div>-->
                        <!--											<div class="plContent">{{ comment.comment }}</div>-->

                        <!--											<div class="del"-->
                        <!--												style="position: absolute; right: 0;top: 10px;cursor: pointer"-->
                        <!--												@click="delComment(comment,item)"-->
                        <!--												v-if="comment.userId == memberId||(setInfo.create_user_id==memberId)||isOtherPeople==2">-->
                        <!--												<i class="el-icon-delete"></i>-->
                        <!--											</div>-->
                      </div>
                      <!-- 当还有更多评论未显示时，显示"查看更多"按钮 -->
                      <div
                        v-if="
                          pllist.filter((c) => c.orderId === item.id).length <
                            commentStates[item.id]?.totalRow &&
                          commentStates[item.id] &&
                          !commentStates[item.id].isLastPage
                        "
                        class="more-box2"
                        @click="seeMoreComments(item.id)"
                      >
                        点击查看更多评论
                      </div>
                    </div>

                    <!-- <div class="comment" v-if="item.addcomment">
                                        <div class="comment_title">
                                            评语：
                                        </div>
                                        <div class="comment_cont">
                                            {{item.addcomment}}
                                        </div>
                                    </div> -->
                  </div>
                </div>
              </template>
              <!-- 暂无数据 -->
              <div class="nodata-box" v-if="!registraList.length">
                <img
                  src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg"
                  alt=""
                />
                <span>暂无数据</span>
              </div>
            </div>
          </div>
          <div
            class="noShowSignInfo"
            v-if="activityDetail.signInfoStatus == 2 && isOtherPeople == 3"
          >
            参与信息不展示
          </div>

          <!-- 底部按钮-->
          <div v-if="templatePage != 1">
            <div
              class="btn_box"
              @click="toSign(activityDetail)"
              v-if="
                (isType == 109 || isType == 110) &&
                activityDetail.clockDisplay == 1 &&
                activityDetail.clockTimeStatus == 1 &&
                clockInfo.clockLocationStatus == 2 &&
                activityDetail.is_it_over == 1
              "
            >
              {{ activityDetail.confirmWord }}
            </div>
            <div
              @click="toSign(activityDetail)"
              class="btn_box_dis"
              v-else-if="
                (isType == 109 || isType == 110 || isType == 104) &&
                activityDetail.is_it_over != 1
              "
            >
              <span>
                {{ activityDetail.is_it_over == 2 ? "已结束" : "活动未开始" }}
              </span>
            </div>

            <div
              @click="toSign(activityDetail)"
              class="btn_box_dis"
              v-else-if="
                (isType == 109 || isType == 110 || isType == 104) &&
                activityDetail.clockDisplay != 1 &&
                !mySignInfo.id
              "
            >
              <span> 今天不能打卡 </span>
            </div>

            <div
              @click="toSign(activityDetail)"
              class="btn_box_dis"
              v-else-if="
                (isType == 109 || isType == 110 || isType == 104) &&
                (activityDetail.clockTimeStatus == 2 ||
                  activityDetail.clockTimeStatus == 3)
              "
            >
              <span> 不在打卡时间段 </span>
            </div>
            <div
              @click="toSign(activityDetail)"
              class="btn_box_dis"
              v-else-if="
                (isType == 109 || isType == 110 || isType == 104) &&
                clockLocationStatus == false &&
                clockInfo.clockLocationStatus == 1
              "
            >
              <span> 不在打卡范围内 </span>
            </div>
            <div
              @click="toSign(activityDetail)"
              class="btn_box"
              v-else-if="
                (isType == 109 || isType == 110 || isType == 104) &&
                activityDetail.signStatus == 1 &&
                mySignInfo.id &&
                activityDetail.is_it_over == 1
              "
            >
              <span>
                {{
                  activityDetail.updateSignInfo != 1
                    ? "我的参与"
                    : "查看报名信息"
                }}
              </span>
            </div>

            <div
              @click="toSign(activityDetail)"
              class="btn_box"
              v-else-if="
                (isType == 109 || isType == 110) &&
                activityDetail.signStatus == 2 &&
                mySignInfo.id &&
                activityDetail.is_it_over == 1
              "
            >
              <span> 已确认信息 </span>
            </div>
            <div
              @click="toSign(activityDetail)"
              class="btn_box"
              v-else-if="
                isType != 109 &&
                isType != 110 &&
                isType != 104 &&
                !mySignInfo.id &&
                activityDetail.is_it_over == 1
              "
            >
              <span>
                {{ activityDetail.confirmWord }}
              </span>
            </div>
            <div
              @click="toSign(activityDetail)"
              class="btn_box_dis"
              v-else-if="activityDetail.is_it_over != 1"
            >
              <span>
                {{ activityDetail.is_it_over == 2 ? "已结束" : "活动未开始" }}
              </span>
            </div>
            <div
              @click="toSign(activityDetail)"
              class="btn_box"
              v-else-if="
                activityDetail.signStatus == 1 &&
                mySignInfo.id &&
                activityDetail.is_it_over == 1
              "
            >
              <span>
                {{
                  activityDetail.updateSignInfo != 1
                    ? "我的参与"
                    : "查看报名信息"
                }}
              </span>
            </div>
            <div
              @click="toSign(activityDetail)"
              class="btn_box"
              v-else-if="
                activityDetail.signStatus == 2 &&
                mySignInfo.id &&
                activityDetail.is_it_over == 1
              "
            >
              <span> 已确认信息 </span>
            </div>
          </div>
          <!--                    <div v-if="templatePage ==1">-->
          <!--                        <div class="empty-btn-style" @click="toBuild">创建空白接龙</div>-->
          <!--                        <div class="no-empty-btn-style" @click="useThisTemplate">使用该模板</div>-->
          <!--                    </div>-->
        </div>
        <div class="view-box">
          <div class="view-box-item">
            <div
              class="share-box"
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              "
              @click.stop="shareClick(activityDetail)"
            >
              <el-button
                icon="el-icon-share"
                type="text"
                size="medium"
              ></el-button>
              <span style="color: #323b5a; font-size: 12px">分享</span>
            </div>
          </div>
          <div class="view-box-item">
            <el-dropdown
              v-if="isOtherPeople == 1 || isOtherPeople == 2"
              trigger="click"
              @mousedown.stop
              @click.stop
            >
              <div
                class="share-box"
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                "
              >
                <el-button
                  icon="el-icon-setting"
                  type="text"
                  size="medium"
                ></el-button>
                <span style="color: #323b5a; font-size: 12px">管理</span>
              </div>
              <el-dropdown-menu
                slot="dropdown"
                @mousedown.stop
                @click.stop
                class="management-dropdown"
              >
                <!-- 打卡签到 -->
                <template
                  v-if="
                    activityDetail.activity_type == 109 ||
                    activityDetail.activity_type == 110 ||
                    activityDetail.activity_type == 104
                  "
                >
                  <el-dropdown-item
                    icon="el-icon-edit"
                    @click.native="dropdownSet(activityDetail)"
                    >编辑修改</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-user-solid"
                    @click.native="setAdmin(activityDetail)"
                    >设置管理员</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-link"
                    @click.native="exportData(activityDetail)"
                    >导出数据</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-data-analysis"
                    @click.native="toPageStatistics(activityDetail)"
                    >数据统计</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-s-claim"
                    @click.native="goSupplementCard(activityDetail)"
                    >去补卡</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-document-copy"
                    @click.native="dropdownCopy(activityDetail)"
                    >复制项目</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      activityDetail.active_state == 1 ||
                      activityDetail.active_state == 2 ||
                      activityDetail.active_state == 3
                    "
                    icon="el-icon-time"
                    @click.native="dropdownEnd(activityDetail)"
                  >
                    {{
                      activityDetail.active_state == 1
                        ? "立即开始"
                        : activityDetail.active_state == 2
                        ? "重启活动"
                        : "提前结束"
                    }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    icon="iconfont icon-anniutubiao-qingkongshuju"
                    @click.native="dropdownResetData(activityDetail)"
                    >清空数据</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="iconfont icon-saoma"
                    @click.native="handleSignCode(activityDetail)"
                    v-if="activityDetail.signInSwitch == 2"
                    >签到码</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-data-line"
                    @click.native="handleSignDataScreen(activityDetail)"
                    v-if="activityDetail.signInSwitch == 2"
                    >签到大屏</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-service"
                    @click.native="openCustomerServiceDialog"
                    >联系客服</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-delete"
                    @click.native="dropdownDel(activityDetail)"
                    >删除项目</el-dropdown-item
                  >
                </template>

                <!-- 通知公告、通用接龙 -->
                <template v-else>
                  <el-dropdown-item
                    icon="el-icon-edit"
                    @click.native="dropdownSet(activityDetail)"
                    >编辑修改</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-user-solid"
                    @click.native="setAdmin(activityDetail)"
                    >设置管理员</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-link"
                    @click.native="exportData(activityDetail)"
                    >导出数据</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-data-analysis"
                    @click.native="toPageStatistics(activityDetail)"
                    >数据统计</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-document-copy"
                    @click.native="dropdownCopy(activityDetail)"
                    >复制项目</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      activityDetail.active_state == 1 ||
                      activityDetail.active_state == 2 ||
                      activityDetail.active_state == 3
                    "
                    icon="el-icon-time"
                    @click.native="dropdownEnd(activityDetail)"
                  >
                    {{
                      activityDetail.active_state == 1
                        ? "立即开始"
                        : activityDetail.active_state == 2
                        ? "重启活动"
                        : "提前结束"
                    }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    icon="iconfont icon-dingdanhexiao"
                    @click.native="handleVerify(activityDetail)"
                    v-if="
                      activityDetail.verificationSwitch == 2 || isType == 101
                    "
                    >核销</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-notebook-2"
                    @click.native="handleOrderManagement(activityDetail)"
                    v-if="activityDetail.activityType == 101"
                    >订单管理</el-dropdown-item
                  >

                  <el-dropdown-item
                    icon="iconfont icon-saoma"
                    @click.native="handleSignCode(activityDetail)"
                    v-if="activityDetail.signInSwitch == 2"
                    >签到码</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-data-line"
                    @click.native="handleSignDataScreen(activityDetail)"
                    v-if="activityDetail.signInSwitch == 2"
                    >签到大屏</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="iconfont icon-anniutubiao-qingkongshuju"
                    @click.native="dropdownResetData(activityDetail)"
                    >清空数据</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-service"
                    @click.native="openCustomerServiceDialog"
                    >联系客服</el-dropdown-item
                  >
                  <el-dropdown-item
                    icon="el-icon-delete"
                    @click.native="dropdownDel(activityDetail)"
                    >删除项目</el-dropdown-item
                  >
                </template>
              </el-dropdown-menu>
            </el-dropdown>
            <div
              class="share-box"
              v-else
              @click.stop="dropdownCopy(activityDetail)"
            >
              <el-button
                icon="el-icon-document-copy"
                type="text"
                size="small"
              ></el-button>
              <span style="color: #323b5a">复制</span>
            </div>
          </div>
        </div>
      </div>

      <!-- <el-date-picker v-model="weekPicker" type="week" format="yyyy 第 WW 周" placeholder="选择周">
            </el-date-picker>
            <el-date-picker v-model="monthShow" type="month" placeholder="选择月">
            </el-date-picker>-->

      <el-dialog
        :title="shareTitle"
        :visible.sync="dialogVisible"
        width="500px"
        center
        :show-close="false"
        custom-class="dialogClass"
      >
        <span slot="title" class="dialog-title">
          <span class="dialog-title-text">{{ shareTitle }}</span>
          <img
            class="custom-close"
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            @click="dialogVisible = false"
            alt="关闭"
            title="关闭"
          />
        </span>
        <div style="text-align: center; background-color: #f8f8f8">
          <div class="radioBack">
            <el-radio-group v-model="shareChange" fill="#1877FF">
              <el-radio-button
                border="false"
                label="下载接龙二维码"
              ></el-radio-button>
              <el-radio-button
                border="false"
                label="嵌入公众号/文章"
              ></el-radio-button>
            </el-radio-group>
          </div>
          <div v-show="shareChange == '下载接龙二维码'">
            <!-- Canvas 预览区域 - 直接显示带 Logo 的二维码 -->
            <div style="margin: 20px 0">
              <canvas
                ref="logoCanvas"
                width="300"
                height="300"
                style="width: 300px; height: 300px; border-radius: 10px"
              ></canvas>
            </div>

            <!-- 控制按钮 -->
            <div class="logo-input-row" style="justify-content: center">
              <el-button
                :class="[
                  'logo-circle-btn',
                  'default-btn',
                  { active: isDefaultMode },
                ]"
                @click="setLogoText(defaultLogoText)"
                >默认</el-button
              >
              <el-button
                v-for="(btn, index) in logoButtons"
                :key="index"
                :class="['logo-circle-btn', { active: logoText === btn.text }]"
                @click="setLogoText(btn.text)"
              >
                <span class="btn-text">{{ formatButtonText(btn.text) }}</span>
              </el-button>
              <el-button
                :class="[
                  'logo-circle-btn',
                  'custom-input-btn',
                  { active: showCustomInput },
                ]"
                @click="enableCustomInput()"
                >自定义3-4 字</el-button
              >
            </div>

            <!-- 自定义文字输入 -->
            <div
              class="logo-input-row"
              v-if="showCustomInput"
              style="justify-content: center; margin-top: 10px"
            >
              <el-input
                v-model="logoText"
                maxlength="4"
                placeholder="输入 3-4 个字"
                class="logo-text-input"
                @input="handleLogoTextChange"
                style="width: 200px"
              ></el-input>
            </div>

            <!-- 颜色选择 -->
            <div
              class="logo-color-row"
              style="justify-content: center; margin-top: 15px"
            >
              <div
                v-for="(color, index) in logoColors"
                :key="index"
                class="color-dot"
                :class="{ active: selectedColorIndex === index }"
                :style="{ backgroundColor: color }"
                @click="selectColor(index)"
              >
                <span v-if="selectedColorIndex === index">✓</span>
              </div>
            </div>

            <!-- 协议勾选 -->
            <div
              class="logo-agreement-row"
              style="margin-top: 15px"
              v-if="!isDefaultMode"
            >
              <el-checkbox v-model="agreementChecked"
                >我已确认二维码中心logo为我自行修改</el-checkbox
              >
            </div>

            <el-button
              class="theme-btn-color"
              @click="downloadCanvasImage()"
              round
              style="margin-top: 20px"
              :disabled="!canDownload"
              >下载接龙二维码</el-button
            >
            <p
              style="text-align: left; margin-left: 20px; font-weight: 600"
              v-if="JumpUrl"
            >
              活动链接
            </p>
            <div
              style="
                background-color: #f8f8f8;
                margin: 10px;
                height: 83px;
                margin-left: 20px;
                margin-right: 20px;
                border-radius: 10px;
                border: 1px solid #e8e8e8;
              "
              v-if="JumpUrl"
            >
              <p
                style="
                  padding: 5px;
                  font-size: 16px;
                  text-align: left;
                  margin-left: 5px;
                "
              >
                {{ JumpUrl }}
              </p>

              <button
                class="theme-btn-color"
                style="
                  cursor: pointer;

                  font-size: 12px;
                  width: 50px;
                  height: 28px;
                  border-radius: 15px;
                  margin-top: -10px;
                  margin-left: 300px;
                  border: none;
                "
                @click="copyClick(JumpUrl)"
                v-if="JumpUrl"
              >
                复制
              </button>
            </div>
          </div>
          <div v-show="shareChange != '下载接龙二维码'" class="wzClass">
            <div
              style="
                height: 85px;
                background-color: white;
                border-radius: 5px;
                margin: 10px;
                padding: 10px;
                margin-left: 10px;
                /* margin-top: 20px; */
              "
            >
              <div style="display: flex">
                <span
                  style="
                    color: #474747;
                    font-weight: 300;
                    width: 83px;
                    text-align: left;
                  "
                  >小程序ID:</span
                >
                <span
                  style="
                    color: #010100;
                    font-weight: 400;
                    width: 200px;
                    text-align: left;
                  "
                  >{{ appid }}</span
                >
              </div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-left: 0px;
                  margin-top: 15px;
                "
              >
                <div>
                  <span style="color: red; line-height: 28px; text-align: left"
                    >*</span
                  >
                  <span
                    style="
                      color: #1877ff;
                      font-size: 12px;
                      font-weight: 400;
                      line-height: 28px;

                      text-align: left;
                    "
                    >关联小程序时使用</span
                  >
                </div>

                <el-button
                  class="theme-btn-color-gzh"
                  size="mini"
                  round
                  @click="copyClick(appid)"
                >
                  复制
                </el-button>
              </div>
            </div>

            <div
              style="
                min-height: 100px;
                background-color: white;
                border-radius: 5px;
                margin: 10px;
                padding: 10px;
                margin-left: 10px;
              "
            >
              <div style="display: flex">
                <span
                  style="
                    color: #474747;
                    font-weight: 300;
                    width: 83px;
                    text-align: left;
                  "
                  >页面路径:</span
                >

                <span
                  style="
                    color: #010100;
                    font-weight: 400;
                    width: 200px;
                    text-align: left;
                  "
                  >{{ faceUrl }}</span
                >
              </div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-left: 0px;
                  margin-top: 15px;
                "
              >
                <div>
                  <span style="color: red; line-height: 28px; text-align: left"
                    >*</span
                  >
                  <span
                    style="
                      color: #1877ff;
                      font-size: 12px;
                      font-weight: 400;
                      line-height: 28px;
                      text-align: left;
                    "
                    >嵌入菜单，文章，回复时使用</span
                  >
                </div>
                <el-button
                  class="theme-btn-color-gzh"
                  size="mini"
                  round
                  @click="copyClick(faceUrl)"
                >
                  复制
                </el-button>
              </div>
            </div>
            <div
              style="
                background-color: white;
                border-radius: 5px;
                margin: 10px;
                padding: 10px;
                margin-left: 10px;
              "
            >
              <div
                style="
                  text-align: center;
                  font-size: 20px;
                  font-weight: 500;
                  margin-top: 30px;
                "
              >
                使用教程
              </div>

              <div
                style="
                  margin-top: 10px;
                  margin-bottom: 10px;
                  text-align: center;
                "
              >
                <button
                  style="cursor: pointer; border-radius: 8px 0 0 8px"
                  :class="isAcive == '嵌入到公众号' ? 'acStyle' : 'defStyle'"
                  @click="clickHandler"
                >
                  嵌入到公众号
                </button>

                <button
                  style="cursor: pointer; border-radius: 0 8px 8px 0"
                  :class="isAcive == '嵌入到文章' ? 'acStyle' : 'defStyle'"
                  @click="clickHandler"
                >
                  嵌入到文章
                </button>

                <!-- kEu47kwFr2oOr9rO/modularImg/1707035652084.jpg -->
              </div>

              <div v-show="isAcive == '嵌入到公众号'">
                <el-image :src="require('@/assets/images/qrgzh.jpg')">
                </el-image>
              </div>

              <div v-show="isAcive == '嵌入到文章'">
                <el-image
                  :src="
                    imageUrl + 'kEu47kwFr2oOr9rO/modularImg/1707035652084.jpg'
                  "
                >
                </el-image>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        custom-class="dialogCustoClass"
        :visible.sync="commentBoxShow"
        width="30%"
        :show-close="false"
      >
        <div class="scoreBox">
          <div class="title">请输入评语</div>
          <div class="line"></div>
          <div class="score_content">
            <div class="scoreinputmodel">
              <el-input
                type="text"
                v-model="addcomment"
                maxlength="30"
                :placeholder="placeholderText1"
              ></el-input>
            </div>
          </div>
          <div class="score_bottom">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="confirmComment">确定</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        custom-class="dialogCustoClass"
        :visible.sync="scoreBoxShow"
        width="30%"
        :show-close="false"
      >
        <div class="scoreBox">
          <div
            class="top"
            style="display: flex; justify-content: space-between"
          >
            <el-tabs v-model="activeTab" @tab-click="clickScope">
              <el-tab-pane
                v-for="(tab, index) in scoreTypelist"
                :key="index"
                :label="tab.name"
              ></el-tab-pane>
            </el-tabs>
            <i
              class="el-icon-close"
              @click="cancel"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </div>
          <div class="score_content">
            <div
              v-if="scoreType == 0"
              style="display: flex; width: 100%; justify-content: space-around"
            >
              <div
                v-for="item in ABCScore"
                :key="item"
                class="scoremodel"
                :style="{
                  background:
                    item == score ? '#1877FF' : 'rgba(24,119,255,0.28)',
                }"
                @click="changeScore(item)"
              >
                {{ item }}
              </div>
            </div>
            <div class="scoreinputmodel" v-if="scoreType == 1">
              <el-input
                type="number"
                v-model="score"
                placeholder="分数"
                @input="handleInputNumber"
              ></el-input>
            </div>
            <div
              v-if="scoreType == 2"
              style="display: flex; width: 100%; justify-content: space-around"
            >
              <div
                v-for="item in excellentScore"
                :key="item"
                class="scoremodel"
                :style="{
                  background:
                    item == score ? '#1877FF' : 'rgba(24,119,255,0.28)',
                }"
                @click="changeScore(item)"
              >
                {{ item }}
              </div>
            </div>

            <div class="scoreinputmodel" v-if="scoreType == 3">
              <el-input
                type="text"
                v-model="score"
                placeholder="分数"
              ></el-input>
            </div>
          </div>
          <div class="score_bottom">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="confirmRate">确认打分</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        custom-class="dialogCustoClass"
        :visible.sync="remarkBoxShow"
        width="30%"
        :show-close="false"
      >
        <span slot="title" class="dialog-title">
          <span class="dialog-title-text">请输入评论</span>
          <img
            class="custom-close"
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            @click="cancel"
            alt="关闭"
            title="关闭"
          />
        </span>
        <div class="scoreBox">
          <div class="line"></div>
          <div class="score_content">
            <div class="scoreinputmodel" style="width: 100%">
              <el-input
                type="text"
                style="width: 100%"
                v-model="comment"
                :placeholder="placeholderText2"
              ></el-input>
            </div>
          </div>
          <div class="score_bottom">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="confirmRemark">确定</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        custom-class="dialogClass dialogAdmin"
        :visible.sync="manageDialogVisible"
        width="455px"
        center
        :show-close="false"
      >
        <span slot="title" class="dialog-title">
          <span class="dialog-title-text">{{ manageTip }}</span>
          <img
            class="custom-close"
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            @click="manageDialogVisible = false"
            alt="关闭"
            title="关闭"
          />
        </span>
        <div
          style="
            text-align: center;
            background-color: #f6f7fa;
            padding-top: 0px;
            padding-bottom: 30px;
          "
        >
          <div>
            <el-image :src="codeUrl" class="code-image"></el-image>
          </div>
          <div>{{ manageTip }}</div>
          <el-button
            @click="downLoadCodePic(codeUrl)"
            type="primary"
            round
            style="margin-top: 40px"
            >下载接龙二维码
          </el-button>
        </div>
      </el-dialog>

      <!-- 客服二维码弹窗 -->
      <el-dialog
        :visible.sync="customerServiceDialogVisible"
        width="360px"
        :show-close="false"
        custom-class="customer-service-dialog"
      >
        <div slot="title" class="cs-dialog-header">
          <span>联系客服</span>
          <i class="el-icon-close" @click="closeCustomerServiceDialog"></i>
        </div>
        <div class="cs-dialog-content">
          <img :src="customerServiceQrcodeSrc" alt="客服二维码" />
          <p>扫码联系客服微信获取帮助</p>
        </div>
      </el-dialog>

      <el-dialog
        :visible.sync="connectBoxShow"
        width="400px"
        :show-close="false"
        custom-class="connectBoxDialog"
      >
        <template slot="title">
          <CustomDialogHeader
            title="联系创建者"
            @close="connectBoxShow = false"
          />
        </template>
        <div class="scoreBox" style="margin: 0px -20px">
          <div class="score_content">
            <div class="uf-box">
              <span>{{ contactTypeText }}</span
              >： <span class="up-text">{{ activityDetail.userPhone }}</span>
            </div>

            <!-- <div
              class="handle-up flex-depart-center-center"
              v-if="activityDetail.contactType == 3"
              @click="copyClick(activityDetail.userPhone)"
            >
              复制号码加微信
            </div>
            <div
              class="handle-up flex-depart-center-center"
              v-if="activityDetail.contactType == 2"
              @click="copyClick(activityDetail.userPhone)"
            >
              复制微信号
            </div>
            <div
              class="hanble-up-cancel flex-depart-center-center"
              @click="connectBoxShow = false"
            >
              取消
            </div> -->
          </div>
        </div>
        <div
          class="btn-tools"
          style="display: flex; gap: 20px; margin: 15px 0 -20px"
        >
          <div
            class="hanble-up-cancel flex-depart-center-center"
            @click="connectBoxShow = false"
          >
            取消
          </div>
          <div
            class="handle-up flex-depart-center-center"
            @click="copyClick(activityDetail.userPhone)"
          >
            复制
          </div>
        </div>
      </el-dialog>

      <el-dialog
        title="签到数据大屏"
        :visible.sync="signDataScreenBoxShow"
        width="455px"
        center
        :show-close="false"
        custom-class="dialogClass"
      >
        <span slot="title" class="dialog-title">
          <span class="dialog-title-text">签到数据大屏</span>
          <img
            class="custom-close"
            src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
            @click="signDataScreenBoxShow = false"
            alt="关闭"
            title="关闭"
          />
        </span>
        <div style="text-align: center; background-color: #f8f8f8">
          <div
            style="
              height: 85px;
              background-color: white;
              border-radius: 5px;
              margin-bottom: 10px;
              margin-top: -10px;
              padding: 10px;
              /* margin-top: 20px; */
            "
          >
            <div style="display: flex">
              <span
                style="color: #2b2f36; font-weight: 400; text-align: left"
                >{{ DataScreenUrl }}</span
              >
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-left: 0px;
                margin-top: 15px;
              "
            >
              <div>
                <span
                  style="
                    color: #2b2f36;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 28px;

                    text-align: left;
                  "
                  >访问秘钥:</span
                >
                <span style="color: #1877ff; font-size: 16px"> {{ key }}</span>
              </div>

              <el-button
                class="theme-btn-color-sjdp"
                size="mini"
                round
                @click="copyClick(DataScreenUrl)"
              >
                复制地址
              </el-button>
            </div>
          </div>
          <template v-if="browserList.length">
            <div
              class="browser-info"
              v-for="(item, index) in browserList"
              :key="index"
            >
              <div class="info-left">
                <div class="info-title">当前使用</div>
                <div class="info-content">{{ item.browserName }}</div>
                <div class="info-content">IP：{{ item.ip }}</div>
              </div>
              <el-button type="text" class="offline-btn" @click="offline(index)"
                >下线</el-button
              >
            </div>
          </template>

          <div>
            <!-- <img style="width:100%" src="https://ossfastmake.mustke.com/12jielong/lsyJL/largeDataSrcen.png" v-if="copyrightConfig.AppID == 'wx1e899bddb256a5ca'"/>
              <img style="width:100%" src="https://ossfastmake.mustke.com/12jielong/lsyJL/largeDataSrcenbmgj.png" v-else/> -->

            <img
              style="width: 100%"
              src="https://ossfastmake.mustke.com/12jielong/lsyJL/dataScreen-xiaoguo.png"
              mode="widthFix"
              v-if="copyrightConfig.AppID == 'wx1e899bddb256a5ca'"
            />
            <img
              style="width: 100%"
              src="https://ossfastmake.mustke.com/12jielong/lsyJL/largeDataSrcenbmgj.png"
              mode="widthFix"
              v-else
            />
          </div>
        </div>
      </el-dialog>

      <div
        v-if="isSearch"
        @click="cancelSearch"
        class="mask-layer"
        style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0);
          z-index: 99;
        "
      ></div>
      <div
        class="previewImgBox"
        v-if="photoShow == true"
        @click="photoShow = false"
      >
        <i class="closePImg el-icon-circle-close"></i>
        <img class="inner-p-img" :src="photoUrl" alt="" />
      </div>

      <!-- 参与者详情抽屉弹窗 -->
      <el-drawer
        :visible.sync="playerDrawerOpen"
        direction="rtl"
        size="450px"
        :withHeader="false"
        class="player-detail-drawer"
      >
        <div class="drawer-out-box" v-if="playerDrawerData">
          <ActivityPlayerItem
            :key="playerDrawerData.id || 'player'"
            :item="playerDrawerData"
            :imageUrl2="imageUrl2"
            :anonymousHeadUrl="anonymousHeadUrl"
            :memberId="memberId"
            :isType="isType"
            :anonymousParticipation="activityDetail.anonymousparticipation || 0"
            :showAvatar="
              activityDetail.anonymousparticipation == 0 ||
              memberId == playerDrawerData.create_user_id ||
              isOtherPeople == 2
            "
            :showContent="true"
            :showContentActionButtons="true"
            :showThumbsUp="activityDetail.thumbs_up == 1"
            :showComment="activityDetail.isMessage == 1"
            :showVerify="
              activityDetail.verificationSwitch == 2 && isOtherPeople == 1
            "
            :showBatchDrawing="
              playerDrawerData.sign_info &&
              playerDrawerData.sign_info.some((f) => [5].includes(f.type)) &&
              (isOtherPeople == 1 || isOtherPeople == 2)
            "
            :showCommentOpen="
              (playerDrawerData.create_user_id == memberId &&
                activityDetail.is_comment == 1) ||
              isOtherPeople == 2
            "
            :showScore="
              (playerDrawerData.create_user_id == memberId &&
                activityDetail.is_score == 1) ||
              isOtherPeople == 2
            "
            :showEdit="
              playerDrawerData.user_id == memberId ||
              playerDrawerData.create_user_id == memberId ||
              isOtherPeople == 2
            "
            :showDelete="
              playerDrawerData.user_id == memberId ||
              playerDrawerData.create_user_id == memberId ||
              isOtherPeople == 2
            "
            :showCopy="isOtherPeople == 1 || isOtherPeople == 2"
            :showAllowView="
              playerDrawerData.create_user_id == memberId || isOtherPeople == 2
            "
            :comments="pllist.filter((c) => c.orderId === playerDrawerData.id)"
            :commentCount="commentStates[playerDrawerData.id]?.totalRow || 0"
            :hasMoreComments="
              pllist.filter((c) => c.orderId === playerDrawerData.id).length <
              (commentStates[playerDrawerData.id]?.totalRow || 0)
            "
            @thumbs-up="(item) => thumbsUp(item, item.isDz, item.id)"
            @add-remark="addRemark"
            @verify="() => handleVerify(activityDetail)"
            @batch-drawing="batchdrawing"
            @comment-open="commentOpen"
            @open-score="openScoreDialog"
            @edit-player="editPlayer"
            @del-sign="delSign"
            @copy-field="(item) => copyFiled(item.sign_index, item.sign_info)"
            @edit-allow-view="handleEditAllowView"
            @del-comment="handleDelComment"
            @see-more-comments="seeMoreComments"
            @preview-image="handlePreviewImage"
          ></ActivityPlayerItem>
        </div>
      </el-drawer>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
// ::v-deep .el-dialog__header {
//   padding: 10px 20px; // 移除内边距
// }
::v-deep .el-dialog__header {
  padding: 10px 20px;
  // border-bottom: 1px solid #e7e7e7; /* 添加分割线 */
  background-color: #fff;
}

// dialog 下的分割线
// ::v-deep .el-dialog__header {
//   border-bottom: 1px solid #e7e7e7; /* 添加分割线 */
//   padding-bottom: 15px; /* 可选：调整间距 */
// }

.detailRow {
  display: flex;
  flex-wrap: wrap;
  margin-right: -12px;
  margin-left: -12px;
  background: #f7f9ff;
}

.activeText {
  background: #1877ff;
  border: 1px solid #1877ff !important;
  color: white;
}

.select-list-box span {
  display: inline-block;
  padding: 0 17px;
  height: 31px;
  /*background: #1877ff;*/
  border-radius: 26px;
  border: 1px solid #d8d8d8;
  font-size: 12px;
  line-height: 31px;
  text-align: center;
  margin: 5px;
  cursor: pointer;
}

// 视图模式切换标签
.view-mode-switch {
  display: flex;
  border: 1px solid #d8d8d8;
  border-radius: 20px;
  overflow: hidden;

  span {
    padding: 0 15px;
    height: 31px;
    line-height: 31px;
    font-size: 12px;
    cursor: pointer;
    background: #fff;
    color: #666;
    transition: all 0.3s;
    position: relative;

    i {
      margin-right: 4px;
    }

    &.active {
      background: #1877ff;
      color: #fff;
    }

    &:hover:not(.active) {
      background: #f0f0f0;
    }
  }
}

// 订单管理链接
.order-manage-link {
  position: relative;
  font-size: 14px;
  color: #1877ff;
  cursor: pointer;
  padding-right: 20px;
  display: flex;
  align-items: center;
  gap: 4px;

  i {
    font-size: 12px;
  }

  .order-badge {
    position: absolute;
    top: -8px;
    right: 0;
  }
}

// 参与人数
.participant-count {
  font-size: 16px;
  color: #323b5a;
  font-weight: bold;
  margin-right: 15px;

  .count-num {
    font-size: 14px;
    color: #1877ff;
    font-weight: normal;
  }
}

.activity-detail-container {
  margin: 0 auto;
  border-radius: 8px;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}

.user-info-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
}

.user-meta {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-size: 16px;
  font-weight: bold;
  color: #222;
}

.publish-time {
  font-size: 13px;
  color: #888;
  margin-top: 2px;
}

.creator {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  img {
    width: 41px;
    height: 41px;
    border-radius: 50%;
    margin-right: 14px;
  }

  .footText {
    font-size: 14px;
    font-weight: 600;
    color: #636a84;
    max-width: 225px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .footTextTwo {
    font-size: 12px;
    color: #a3a7ad;
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    align-items: center;

    .certificationMark {
      width: 16px;
      height: 16px;
      margin-left: 5px;
      vertical-align: middle;
    }
  }
}

.Biao2 {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  color: #323b5a;
  margin-bottom: 5px;
}

.Detailcontent {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  text-align: left;
  color: #4c4a56;
  line-height: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  text-indent: 2rem;
}

.fenge {
  width: 100%;
  height: 1px;
  background: #dedede;
  margin: 9px 0 8px;
}

.lll {
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  text-align: left;
  color: #a2a2a2;
  line-height: 17px;
}

.main-title {
  font-size: 14px;
  font-weight: bold;
  color: #222;
  margin-bottom: 10px;
}

.main-content {
  font-size: 15px;
  color: #444;
  line-height: 1.8;
  margin-bottom: 8px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.newContentNew {
  width: 100%;
  background-color: #ffffff;
  padding: 0px 0 15px;
  margin-bottom: 5px;
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .newValue {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: justify-between;
    margin-bottom: 18px;
    font-size: 15px;
    font-weight: bold;
    .left-bar-block {
      width: 4px;
      min-height: 20px;
      background: #1877ff;
      border-radius: 2px;
      margin-right: 5px;
    }

    img {
      width: 4px;
      height: 20px;
      margin-right: 4.5px;
    }
  }

  .imgBIgNew {
    width: 100%;

    img {
      width: 100%;
      border-radius: 8px;
      overflow: hidden;
      //   height: 167.5px;
    }
  }

  .content5 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .smallimg {
      width: 188px;
      height: 188px;
      margin: 0 3px 6.5px 3px;
      border-radius: 3px;
    }

    img {
      width: 188px;
      height: 188px;
      margin: 0 7px 6.5px 7px;
      border-radius: 3px;
      background: #ddd;
      object-fit: contain;
    }
  }

  // 地图
  .mapTitle {
    width: 100%;
    height: 2rem;
    text-align: center;
  }

  .xuhao {
    font-size: 12px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: Regular;
    text-align: right;
    color: #666666;
  }

  .huimapMap {
    display: flex;
    flex-direction: column;
    background-color: #fafafa;
    border-radius: 4px;

    .page-map {
      padding-left: 13px;
      box-sizing: border-box;
    }
  }

  .mapMap {
    height: 8.5rem;
    position: relative;
  }

  // 文件
  .con4 {
    width: 100%;
    height: 50px;
    background-color: #f8f8f8;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;
    //border: 1px solid #bbb;

    .con4Img {
      width: 27px;
      height: 29.5px;
      margin-right: 18px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .con4_1 {
      display: flex;
      flex-direction: column;

      div {
        font-size: 15px;
        font-weight: bold;
        color: #333333;
      }

      span {
        font-size: 14px;
        color: #a3a7ad;
      }
    }
  }

  .audio-play {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #f8f8f8;
    align-items: flex-start;
    border-radius: 8px;
    padding: 10px;
    box-sizing: border-box;

    .playIcon {
      margin-right: 10px;
    }

    .playtext {
      font-size: 14px;
      font-weight: bold;
    }
  }

  .con5 {
    width: 100%;
    height: 51px;
    background: #f8f8f8;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: Medium;
    text-align: left;
    color: #333333;
    line-height: 51px;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 7.5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.completion-status {
  border: 1px solid #e0e0e0;
  padding: 10px;
  margin-top: 20px;
  background-color: #fbfbfb;
  margin-top: 10px;
}

.status-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.notify-button {
  background-color: #1877ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
}

.participant-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.participant {
  background-color: #f4f7fe;
  padding: 5px 10px;
  border-radius: 4px;
  color: #333;
}

.section-title {
  font-size: 15px;
  font-weight: bold;
  color: #1877ff;
  margin: 18px 0 10px 0;
}

.big-image-box {
  width: 100%;
  margin-bottom: 18px;
}

.big-image {
  width: 100%;
  max-width: 834px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
}

.small-image-list {
  display: flex;
  gap: 16px;
  margin-bottom: 18px;
}

.small-image {
  width: 130px;
  height: 130px;
  border-radius: 8px;
  object-fit: cover;
  background: #f6f6f6;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.map-box {
  margin-top: 10px;
  width: 100%;
  background: #fafbfc;
  border-radius: 8px;
  padding: 16px;
}

.map-img {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
}

.map-desc {
  font-size: 13px;
  color: #666;
  margin-top: 8px;
  line-height: 1.6;
}

.b-marT-10 {
  margin-top: 10px;
}

.b-marT-20 {
  margin-top: 20px;
}

.view-box-item .el-button {
  padding: 1px 0;
}

.view-box-item {
  margin: 6px 0;
}

.all_view16 {
  width: 100%;
  // background-color: #F8F8F8;
  // padding: 20px 0;
  box-sizing: border-box;
  margin: 20px auto;

  .titleT {
    width: 100%;

    // padding:0 20px;
    .titleCon {
      box-sizing: border-box;
      background-color: #fff;
      // width: 710px;
      // height: 197px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      // margin-bottom: 20px;
      padding: 28px;
      box-sizing: border-box;
      border-radius: 10px;
      padding-bottom: 20px;
      border-bottom: 1px solid #e4e4e4;

      .titleTop {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // padding-bottom: 27px;
        // border-bottom: 1px solid #E4E4E4;
        margin-bottom: 25px;

        .tx {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .header {
            // width: 15%;
            margin-right: 10px;

            img {
              width: 80px;
              height: 80px;
              border: 1px solid #ccc;
              border-radius: 50%;
            }
          }

          .content_con {
            .Biao {
              width: 400px;
              font-weight: bold;
              font-size: 15px;
              margin-bottom: 4px;
              color: #323b5a;
              display: flex;
            }

            .time {
              font-size: 12px;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: Regular;
              text-align: left;
              color: #666666;
              margin-top: 6px;
            }

            // 左侧收费项信息样式
            .charge-item-section-left {
              margin-top: 10px;
              padding: 8px 12px;
              background: #f5f7fa;
              border-radius: 4px;
              text-align: left;
              width: 100%;

              .charge-item-row {
                display: flex;
                align-items: center;
                padding: 3px 0;
                font-size: 13px;
                font-weight: 600;

                .charge-item-label {
                  color: #323b5f;
                  font-weight: 600;
                  margin-right: 5px;
                }

                .charge-item-name {
                  color: #323b5f;
                  font-weight: 600;
                }

                .charge-item-price {
                  color: #f73b42;
                  font-weight: 600;
                }
              }
            }
          }
        }
      }

      .content {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-top: 20px;

        .bmfooter {
          width: 100%;
          font-size: 26px;
          color: #626974;
          box-sizing: border-box;
        }

        .footer_text {
          .playerContentTitle {
            font-size: 12px;
          }

          .mar15-0 {
            margin: 8px 0;
          }

          span {
            word-break: break-all;
          }

          .newContent {
            width: 100%;

            .nameMa {
              width: 100%;

              // display: flex;
              // flex-direction: column;
              .imgMa {
                width: 316px;
                height: 316px;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            .greenBtn {
              width: 100%;
              height: 77px;
              background-color: #03ce66;
              border-radius: 38.5px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              padding: 20px 29px;
              box-sizing: border-box;

              img {
                width: 32px;
                height: 40px;
                margin-right: 29px;
              }

              span {
                font-size: 30px;
                color: #ffffff;
              }
            }

            .content5 {
              // width: 668px;
              // height: 402px;
              display: flex;
              flex-wrap: wrap;

              // margin-bottom: 60px;
              img {
                width: 100%;
                height: 190.5px;
                margin: 0 14px 13px 14px;
                border-radius: 6px;
                background: #ddd;
                object-fit: contain;
              }
            }

            .mapMap {
              width: 653px;
              // height: 246px;
            }

            .page-map {
              width: 620px;
              height: 52px;
              line-height: 52px;
              background: #e8f2ff;
              border-radius: 3px;
              font-size: 26rpx;
              color: #1877ff;
              align-items: center;
              padding: 0 30px;

              .map-posi {
                width: 28px;
                height: 28px;
                position: relative;
                top: 4px;
              }
            }
          }
        }
      }

      .delSpan {
        font-size: 24px;
        color: #0291ff;

        image {
          position: absolute;
          right: 20px;
          width: 60px;
          height: 30px;
        }
      }
    }

    .pllist {
      width: 100%;
      min-height: 50px;
      background: #eef2f7;
      border-radius: 10px;
      padding: 8px;

      .pltx {
        width: 45px;
        height: 45px;
        background: #d8d8d8;
        border: 3px solid #ffffff;
        border-radius: 50%;
      }
      .comment-wrapper {
        position: relative;
        width: 100%;
      }
      .plName {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: bold;
        text-align: left;
        color: #666666;
        margin: 0 8px;
        width: 90%;
      }
      .nickname {
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: bold;
        color: #666666;
      }

      .comment-text {
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #666666;
      }

      .plContent {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: Semibold;
        text-align: left;
        color: #666666;
        width: 600px;
        word-wrap: break-word;
        padding-right: 30px;
        flex: 1;
        min-width: 0;
      }
    }
  }
}

/* flex布局 */
.flex-depart-left {
  display: flex;
  align-items: center;
}

.flex-depart-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-depart-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-depart-center-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex-depart-top {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.flex-depart-left-warp {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.new-m-content {
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #f8f8f8;

  .copybox {
    width: 100%;
    word-break: break-all;
    font-size: 14px;
    font-weight: bold;
    color: #54545d;
    white-space: pre-wrap;
  }
}

.new-m-content .copyStyle {
  width: 86px !important;
  height: 30px;
  background: #ffffff;
  border: 2px solid rgba(24, 119, 255, 0.17);
  border-radius: 18px;
  font-size: 16px;
  color: #1877ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  align-self: center;
}

/*大图排序*/
.flex-depart-column-top-left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.outBox {
  width: 850px;
  margin: 0 auto;
  background-color: #ffffff;
  position: relative;
}

.bigTitle {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: white;
  font-weight: bold;
  background-color: #1877ff;
}

.block-title {
  font-size: 14px;
  font-weight: Bold;
  text-align: left;
  color: #191919;
}

.blockBox {
  padding: 15px;
  background-color: white;
  margin-bottom: 10px;
}

.handle-box .h-item {
  margin-right: 30px;
  cursor: pointer;
}

.handle-box .h-item img {
  width: 20px;
  height: 20px;
  margin-right: 1px;
}

.handle-box .h-item span {
  font-size: 12px;
  color: #767d98;
}

.addBtnStyle {
  width: 395px;
  height: 43px;
  background: #ffffff;
  border: 1px dashed #4a73f7;
  border-radius: 23px;
  font-size: 16px;
  color: #1877ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  i {
    margin-right: 10px;
  }
}

.f-block {
  background: #fafafa;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 10px;
  margin-top: 10px;
}

.f-block:last-child {
  /*margin-bottom: 0;*/
}

.tl-item .f-ipt {
  width: 780px;
}

.f-handle img {
  width: 20px;
  height: 20px;
  margin-left: 5px;
  cursor: pointer;
}

.checkedState .el-checkbox {
  margin-bottom: 0;
}

.ch-copy {
  margin-left: 50px;
  font-size: 13px;
  color: #409eff;
  align-items: center;
  cursor: pointer;

  i {
    /*width: 17px;*/
    /*height: 17px;*/
    margin-right: 4px;
  }
}

.selectBox-item {
  padding-left: 20px;
}

.selectBox-item .el-input {
  width: 700px;
  margin-right: 10px;
}

.selectBox-item i {
  font-size: 18px;
}

.addOptStyle {
  color: #1877ff;
  cursor: pointer;
  padding-left: 20px;
}

.settingBox {
  padding: 10px 15px;
  background-color: white;
}

.sTitle {
  font-size: 14px;
  font-weight: Bold;
  text-align: left;
  color: #191919;
  display: inline-flex;
  align-items: center;

  label {
    font-size: 12px;
    color: grey;
    font-weight: normal;
  }

  b {
    width: 4px;
    height: 14px;
    background: #1877ff;
    border-radius: 2px;
    margin-right: 5px;
  }
}

.settingBox .el-date-editor .el-range-separator {
  width: 15%;
}

.setText {
  color: #1877ff;
  cursor: pointer;
  text-decoration: underline;
}

.settingBox .el-radio {
  margin-bottom: 0;
}

.block-for-box {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  margin-top: 10px;
}

.big-img img {
  max-width: 600px;
  height: auto;
}

.b-handle img {
  width: 20px;
  height: 20px;
  margin: 5px;
  cursor: pointer;
}

.addSmallBtn {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f7;
  color: #1877ff;
  border-radius: 4px;
  position: relative;
}

.updateFileBtn {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.rangeTimes i {
  margin-left: 5px;
  font-size: 25px;
  cursor: pointer;
  color: #f56c6c;
}

.add-rangeTimes {
  color: #1877ff;
  cursor: pointer;
}

.map {
  width: 100%;
  height: 400px;
}

.deadline {
  width: 80px;
  margin-left: 5px;
}

.jlName {
  width: 100%;
  background: #ffffff;
  margin: 0 auto;
  border-radius: 5px;
  background-color: #fff;
  padding: 6px 15px;
  box-sizing: border-box;
  padding: 17.5px 16px;

  .jlName_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
    margin-bottom: 10px;
  }

  .copynamelist {
    width: 121px;
    height: 26px;
    background: #1877ff;
    border-radius: 15px;
    font-size: 14px;
    color: #fff;
    line-height: 26px;
    text-align: center;
    cursor: pointer;
  }

  .listName {
    width: 100%;
    display: inline-block;

    .span {
      height: 50px;
      width: 70px;
      margin: 4px;
      background-color: #f2f2f2;
      border-radius: 4px;
      text-align: center;
      font-size: 12px;
      color: #626974;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      float: left;
      position: relative;
    }

    // 已报名样式 - 蓝色边框
    .signed-item {
      border: 1px solid #1877ff;
    }

    // 勾选标记
    .signed-icon {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      color: #fff;
      font-weight: bold;
      background-color: #1877ff;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    span {
      width: 90%;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }

    .spanDivEmpty {
      height: 0px;
      width: 10%;
      margin: 4px;
    }
  }
}

.smallImgbox {
  width: 150px;
  height: 150px;
  background-color: #f7f7f7;
  margin: 5px;
  position: relative;
}

.handle2 {
  width: 150px;
  height: 150px;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;

  img {
    width: 20px;
    height: auto;
    cursor: pointer;
    margin-top: 70px;
    margin-left: 33px;
  }
}

.seeBigImgHover:hover {
  .handle2 {
    display: block;
  }
}

.imgBg {
  width: 150px;
  height: 150px;
  /*background: url("https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg") no-repeat center;*/
  background-size: cover;
}

.upl-smallImg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  background-color: #f7f7f7;
  color: #1877ff;
  cursor: pointer;
  margin: 5px;
  position: relative;

  i {
    font-size: 26px;
  }
}

.filesStyle {
  height: 45px;

  .tubiao {
    margin-right: 2px;
  }

  .del {
    margin-left: 10px;
    position: relative;
    top: 1px;
    cursor: pointer;
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
}

.predivImgBox {
  width: 100%;
  height: 100%;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .inner-p-img {
    height: 600px;
    width: auto;
  }

  .closePImg {
    font-size: 40px;
    cursor: pointer;
    position: fixed;
    top: 40px;
    right: 40px;
    color: white;
  }
}

.drawerOutBox {
  padding: 0 20px;
}

.af-title {
  font-weight: bold;
}

.ty-b-item {
  position: relative;
  width: 195px;
  height: 80px;
  border: 1px solid #b2c4fb;
  background-color: #f4f7fe;
  border-radius: 5px;
  box-sizing: border-box;
  padding-top: 18px;
  padding-left: 10px;
  cursor: pointer;
}

.ty-b-item div {
  font-weight: bold;
  color: #1877ff;
}

.addFBtn {
  color: #1877ff;
  font-size: 22px;
  position: absolute;
  right: 10px;
  top: 18px;
}

.cy-box {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
}

.cy-item {
  width: 128px;
  height: 45px;
  box-sizing: border-box;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f4f7fe;
  border-radius: 5px;
  margin-bottom: 5px;
  cursor: pointer;

  .addFBtn2 {
    color: #1877ff;
    font-size: 22px;
  }
}

.seniorStyle {
  background-color: #ecf4ff !important;
  cursor: pointer;
}

.cus-dates {
  margin-bottom: 0 !important;
  margin-left: 5px;
}

.player_content {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 100px;

  .all_div16 {
    width: 100%;
    box-sizing: border-box;

    // 列表模式样式
    &.list-mode .titleT {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 15px 20px;
      border-bottom: 1px solid #f0f0f0;

      .titleCon {
        flex: 1;
        padding: 0;
        background: transparent;
        align-items: flex-start;

        .titleTop {
          margin-bottom: 0;

          .tx {
            .header img {
              width: 40px;
              height: 40px;
            }

            .content_con {
              .Biao {
                font-size: 14px;
              }

              .time {
                font-size: 12px;
              }
            }
          }
        }
      }
    }

    // 头像模式样式（默认）
    .titleT {
      width: 100%;

      .titleCon {
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        // margin-bottom: 20px;
        padding: 28px;
        box-sizing: border-box;
        border-radius: 5px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e4e4e4;

        .titleTop {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // padding-bottom: 27px;
          // border-bottom: 1px solid #E4E4E4;
          margin-bottom: 12px;

          .tx {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .header {
              // width: 15%;
              margin-right: 8px;

              img {
                width: 47px;
                height: 47px;
                border: 1px solid #ccc;
                border-radius: 50%;
              }
            }

            .content_con {
              .Biao {
                width: 400px;
                font-weight: bold;
                font-size: 15px;
                color: #323b5a;
                display: flex;
              }

              .time {
                font-size: 12px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: Regular;
                text-align: left;
                color: #666666;
              }
            }
          }
        }

        .content {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .bmfooter {
            width: 100%;
            font-size: 14px;
            color: #626974;
            box-sizing: border-box;
          }

          .footer_text {
            view {
              /*margin: 8px 0;*/
            }

            .mar15-0 {
              margin: 8px 0;
            }

            span {
              word-break: break-all;
            }

            .newContent {
              width: 100%;

              .nameMa {
                width: 100%;

                // display: flex;
                // flex-direction: column;
                .imgMa {
                  width: 316px;
                  height: 316px;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }

              .greenBtn {
                width: 100%;
                height: 77px;
                background-color: #03ce66;
                border-radius: 38.5px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 20px 29px;
                box-sizing: border-box;

                img {
                  width: 32px;
                  height: 40px;
                  margin-right: 29px;
                }

                span {
                  font-size: 30px;
                  color: #ffffff;
                }
              }

              .content5 {
                // width: 668px;
                // height: 402px;
                display: flex;
                flex-wrap: wrap;

                // margin-bottom: 60px;
                img {
                  width: 190.5px;
                  height: 190.5px;
                  margin: 0 14px 13px 0;
                  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                  // border-radius: 6px;
                  // border: 1px solid #bbb;
                }
              }

              .mapMap {
                width: 653px;
                // height: 246px;
              }

              .page-map {
                width: 100%;
                height: 33px;
                line-height: 33px;
                background: #e8f2ff;
                border-radius: 2px;
                font-size: 14px;
                color: #1877ff;
                align-items: center;
                padding: 0 15px;

                .map-posi {
                  width: 20px;
                  height: 20px;
                  position: relative;
                  top: 2px;
                }
              }
            }
          }
        }

        .delSpan {
          font-size: 24px;
          color: #0291ff;

          image {
            position: absolute;
            right: 20px;
            width: 60px;
            height: 30px;
          }
        }
      }

      .pllist {
        width: 100%;
        min-height: 50px;
        background: #eef2f7;
        border-radius: 10px;
        padding: 8px;

        .comment-wrapper {
          position: relative;
          width: 100%;
        }
        .plName {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: bold;
          text-align: left;
          color: #666666;
          margin: 0 8px;
          width: 90%;
        }

        .nickname {
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: bold;
          color: #666666;
        }

        .comment-text {
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #666666;
        }

        .plContent {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: Semibold;
          text-align: left;
          color: #666666;
          width: 600px;
          word-wrap: break-word;
          padding-right: 30px;
          flex: 1;
          min-width: 0;
        }

        .plName {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: bold;
          text-align: left;
          color: #666666;
          margin: 0 8px;
        }

        .plContent {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: Semibold;
          text-align: left;
          color: #666666;
          width: 600px;
          word-wrap: break-word;
        }
      }
    }
  }
}

.comment_cont {
  width: 100%;
  /*min-height: 63px;*/
  background: #e8f2ff;
  border-radius: 2px;
  padding: 7.44px;
  font-size: 14px;
  text-align: left;
  color: #1877ff;
  line-height: 20px;
  padding-left: 8px;
  word-wrap: break-word; //自动换行
  word-break: break-all; //自动换行（兼容字母）
  overflow: hidden; //超出隐藏
  text-overflow: ellipsis; //溢出显示省略号
  display: -webkit-box;
  /*-webkit-line-clamp: 3;   //显示3行*/
  -webkit-box-orient: vertical;
}

.content5-new {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
}

.image-wrapper-new {
  width: calc(100% / 4 - 10px);
  height: 189px;
  position: relative;
  margin: 8px 0;
  border-radius: 8px;
  overflow: hidden;

  .con5-img {
    width: 100%;
    height: 100%;
  }
}

.image-wrapper-new-empty {
  width: calc(100% / 4 - 10px);
  height: 0;
  margin: 8px 0;
}

.image-wrapper-new-100 {
  width: 100%;
  position: relative;
  margin: 8px 0;

  .con5-img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
  }
}

// 文件
.con4 {
  width: 100%;
  height: 50px;
  background-color: #f8f8f8;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
  justify-content: space-between;
  margin-bottom: 10px;
  cursor: pointer;
  border: 1px solid #bbb;

  .con4Img {
    width: 13px;
    height: 15px;
    margin-right: 18px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .con4_1 {
    display: flex;

    div {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }

    span {
      font-size: 14px;
      color: #a3a7ad;
    }
  }
}

.thumbs_box {
  margin-top: 10px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 33px;
  cursor: pointer;

  img {
    width: 13px;
    height: 12px;
    margin-right: 5px;
  }

  text {
    font-size: 16px;
    font-weight: Regular;
    text-align: left;
    color: #1877ff;
  }
  &:last-child {
    margin-right: 0;
  }
}

.scoreBox {
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .line {
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
  }

  .score_content {
    margin-bottom: 20px;
  }

  .score_bottom {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}

.scoreBox {
  .top {
    margin-bottom: 20px;
  }

  .score_content {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
  }

  .scoremodel {
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    color: #fff;
  }

  .scoreinputmodel {
    width: 100%;
  }

  .score_bottom {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}

.jlrules {
  width: 100%;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .con_Liu {
    border-bottom: 1px solid #efefef;
    margin-bottom: 34px;

    h1 {
      font-size: 32px;
      color: #323b5a;
      font-weight: bold;
      padding: 30px 0;
      box-sizing: border-box;
    }
  }

  .rules-time {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Semibold;
    text-align: left;
    color: #9b9fac;
    line-height: 20px;
    display: flex;
    align-items: center;

    .origin {
      width: 6px;
      height: 6px;
      background: #639fff;
      border-radius: 50%;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .text1 {
      // font-weight: bold;
      margin-right: 10px;
    }

    .text2 {
      color: #1877ff;
      // text-decoration: underline;
    }
  }
}

.btn_box {
  width: 416px;
  height: 50px;
  background: #1877ff;
  border-radius: 25px;
  margin: 20px auto;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translate(-32%);
  cursor: pointer;
}

.btn_box_dis {
  width: 416px;
  height: 50px;
  background: #b0b0b0;
  border-radius: 25px;
  margin: 20px auto;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translate(-32%);
  cursor: pointer;
}

.nodata-box {
  height: 375px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 87px;
    height: 96px;
    margin-bottom: 10px;
  }

  span {
    font-size: 15px;
    color: #a7adc6;
  }
}

.index-fm-block {
  width: 600px;
  margin: 0 auto;
  margin-bottom: 20px;
  .fm-poster {
    width: 100%;
    height: auto;
  }
}

.video-block {
  height: 400px;
  position: relative;
}

.swiper-video {
  width: 100%;
}

.video-poster {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;
}

.bofang {
  width: 60px;
  height: 60px;
  position: absolute;
  left: 10px;
  bottom: 10px;
  z-index: 10;
}

// 头像模式样式
.avatar-mode-container {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  background: #fff;
  border-radius: 8px;

  .avatar-mode-tip {
    width: 100%;
    font-size: 12px;
    color: #999;
    margin-bottom: 15px;
  }

  .avatar-item {
    width: calc(100% / 7 - 15px);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 8px;
    cursor: pointer;

    .avatar-box {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #e0e0e0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .avatar-name {
      font-size: 12px;
      color: #333;
      margin-top: 8px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }

  .avatar-item-empty {
    width: calc(100% / 7 - 15px);
    height: 0;
    margin: 8px;
  }

  .load-more-btn {
    width: 100%;
    text-align: center;
    padding: 15px 0;
    color: #1877ff;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #409eff;
    }

    .load-more-icon {
      width: 14px;
      height: 14px;
      margin-left: 5px;
    }
  }

  .no-more-data {
    width: 100%;
    text-align: center;
    padding: 15px 0;
    color: #999;
    font-size: 14px;
  }
}

.fm-flex .fm-pics-block {
  width: 400px;
  height: auto;
}

/* 参与者详情抽屉样式 */
.player-detail-drawer {
  .drawer-out-box {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .drawer-nav-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: #fff;

    span {
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }

    .close-btn {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }

  .underline {
    height: 1px;
    background: #f0f0f0;
    margin: 0 15px;
  }

  .drawer-content {
    flex: 1;
    overflow-y: auto;
    padding: 15px;
    background: #f8f8f8;

    .footer_text {
      background: #fff;
      padding: 15px;
      margin-bottom: 10px;
      border-radius: 8px;

      .mar15-0 {
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .playerContentTitle {
        font-size: 14px;
        color: #666;
      }
    }

    .newContent {
      background: #fff;
      padding: 15px;
      margin-bottom: 10px;
      border-radius: 8px;

      .nameMa {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .content5-new {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .image-wrapper-new {
          position: relative;
          width: 100px;
          height: 100px;

          .con5-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
            cursor: pointer;
          }
        }
      }

      .page-map {
        display: flex;
        align-items: center;
        padding: 10px 15px;
        background: #f5f5f5;
        border-radius: 4px;
        cursor: pointer;

        .map-posi {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }

      .greenBtn1 {
        audio {
          width: 100%;
        }
      }
    }

    .file-sign-box {
      .file-sign-item {
        .con4 con4_flex {
          display: flex;
          align-items: center;
          padding: 10px;
          background: #f5f5f5;
          border-radius: 4px;
          cursor: pointer;
          margin-bottom: 8px;

          .con4Img {
            width: 40px;
            height: 40px;
            margin-right: 10px;

            .Img3 {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .con4_1 {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
  }
}

// Logo 自定义相关样式
.logo-input-row {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 15px;
}
.logo-circle-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #1877ff;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
}
.btn-text {
  display: block;
  line-height: 1.2;
  word-break: break-all;
  white-space: pre-line;
}
.logo-circle-btn.active {
  background: #0d5ddb;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(24, 119, 255, 0.4);
}
.logo-circle-btn:hover:not(.active) {
  background: #409eff;
}
.default-btn {
  background: #fff;
  color: #1877ff;
  border: 1px solid #1877ff;
}
.default-btn.active {
  background: #1877ff;
  color: #fff;
  border-color: #1877ff;
}
.default-btn:hover:not(.active) {
  background: #e6f0ff;
}
.custom-input-btn {
  width: auto;
  padding: 0 12px;
  border-radius: 18px;
  min-width: auto;
  font-size: 11px;
}
.logo-text-btn:hover:not(.active) {
  border-color: #1877ff;
  color: #1877ff;
}
.logo-text-input {
  width: 200px;
}
.logo-text-input :deep(.el-input__inner) {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
}
.logo-color-row {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}
.color-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  color: #fff;
  font-size: 16px;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.color-dot.active {
  transform: scale(1.15);
}
.color-dot.active span {
  display: block;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}
.color-dot span {
  display: none;
}
.logo-agreement-row {
  margin-top: 15px;
  text-align: center;
}
.logo-agreement-row :deep(.el-checkbox__label) {
  font-size: 12px;
  color: #666;
}
.logo-agreement-row :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: #1877ff;
  border-color: #1877ff;
}
</style>

<style>
.dialogClass {
  border-radius: 9px;
  background: #f8f8f8;
  overflow: hidden;
}
.dialogAdmin .el-dialog__header {
  border-bottom: 1px solid #e7e7e7;
  /* padding-bottom: 15px; */
  background-color: #fff;
}

.dialogCustoClass {
  padding: 0;
}

.code-image {
  margin-top: 40px;
  width: 200px;
  height: 200px;
}

.con_Nei {
  width: 100%;
  font-size: 15px;
  color: #4b5668;
  box-sizing: border-box;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 45rpx;
  &.is-small {
    font-size: 14px;
  }
  &.is-medium {
    font-size: 15px;
  }
  &.is-large {
    font-size: 16px;
  }
}

.view-box {
  width: 50px;
  height: 120px;
  background: #ffffff;
  border: 1px solid #dedede;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  margin-left: 550px;
}

.view-box-item {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-box-item .el-button {
  width: 100%;
  height: auto;
  padding: 6px 4px;
  font-size: 20px;
  line-height: 1.2;
  border: none;
  background: transparent;
  color: #1877ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.view-box-item .el-button:hover {
  color: #409eff;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.view-box-item .el-button i {
  font-size: 20px;
  margin-bottom: 3px;
}

/* 管理下拉菜单样式 */
::v-deep .management-dropdown {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e4e7ed;
  padding: 6px 0;
  min-width: 140px;
  background: #ffffff;
}

::v-deep .management-dropdown .el-dropdown-menu__item {
  padding: 10px 16px;
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  display: flex;
  align-items: center;
}

::v-deep .management-dropdown .el-dropdown-menu__item i {
  margin-right: 8px;
  font-size: 14px;
  color: #1877ff;
}

::v-deep .management-dropdown .el-dropdown-menu__item:hover {
  background-color: #f5f7fa;
  color: #1877ff;
}

::v-deep .management-dropdown .el-dropdown-menu__item.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

::v-deep .management-dropdown .el-dropdown-menu__item.is-disabled i {
  color: #c0c4cc;
}

::v-deep .management-dropdown .el-dropdown-menu__item.is-disabled:hover {
  background-color: transparent;
  color: #c0c4cc;
}

::v-deep .el-dropdown-link {
  color: #1877ff;
  font-size: 14px;
  border: none;
  background: transparent;
  padding: 0;
}

::v-deep .el-dropdown-link:hover {
  color: #409eff;
}

::v-deep .el-dropdown-link:focus {
  outline: none;
}
</style>

<style lang="scss" scoped>
.dialog-title {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
}
.dialog-title-text {
  font-weight: bold;
  display: inline-block;
  font-size: 20px;
  color: black;
  max-width: calc(100% - 60px);
  word-break: break-all;
  vertical-align: middle;
}
.custom-close {
  width: 22px;
  height: 22px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
// 分享弹窗样式
.radioBack .el-radio-group {
  border-radius: 40px;

  overflow: hidden;

  border: 1px solid #1877ff;
}

.radioBack .el-radio-button {
  // width: 120px;
  margin: 0;
}

.radioBack .el-radio-button__inner {
  color: #1877ff;

  border: #1877ff;

  font-size: 12px;
}

::v-deep .el-radio-button__inner {
  color: rgb(64, 158, 255);
}

.code-image {
  width: 200px;
  height: 200px;
  margin: 20px auto;
}

.wzClass {
  overflow: auto;
  height: 439px;
  justify-content: center;
  padding-left: 27px;
  margin-top: 10px;
}

.acStyle {
  background-color: #1877ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
}

.defStyle {
  background-color: #f5f7fa;
  color: #606266;
  border: 1px solid #dcdfe6;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
}

.fm-pics-block {
  //width: 800px;
  height: 300px;
}

.pic-out-box {
  //width: 800px;
  //height: 300px;
  text-align: center;
  img {
    height: 300px;
    width: auto;
  }
}

.noShowSignInfo {
  height: 296px;
  background: #ffffff;
  padding: 30px;
  box-sizing: border-box;
  font-size: 24px;
  color: #666666;
  text-align: center;
  line-height: 296px;
  font-weight: bold;
}
.mt-style {
  display: inline-block;
  background-color: #409eff;
  padding: 10px 30px;
  color: white;
  font-size: 18px;
  font-weight: bold;
  box-sizing: border-box;
  max-width: 250px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  border-radius: 30px;
  position: relative;
  top: -43px;
}

.lxt {
  width: 70px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #1877ff;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1877ff;
  font-size: 13px;
  cursor: pointer;
}

.uf-box {
  box-sizing: border-box;
  padding: 10px 20px;
  font-weight: bold;
  text-align: center;
  margin-top: -20px;
}
.connectBoxDialog {
  .score_content {
    margin-bottom: 0 !important;
  }
}
.up-text {
  word-break: break-all;
  color: #1877ff;
}

.handle-up {
  width: 90%;
  height: 40px;
  border-radius: 5px;
  background-color: #1877ff;
  color: white;
  font-size: 14px;
  font-weight: bold;
  margin: 0 auto 10px;
  border: 1px solid #1877ff;
  cursor: pointer;
}

.hanble-up-cancel {
  width: 90%;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #1877ff;
  color: #1877ff;
  font-size: 14px;
  font-weight: bold;
  margin: 0 auto;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.dialogClass {
  border-radius: 9px;
  background: #f8f8f8;
  overflow: hidden;
}

.dialogClassShare {
  border-radius: 9px;
  background: #fff;
}

.theme-btn-color {
  background: #1877ff;
  color: #fff;
}

.theme-btn-color-gzh {
  background: rgba(24, 119, 255, 0.2);
  color: #1877ff;
}
.theme-btn-color-sjdp {
  background: #1877ff;
  color: #fff;
}

/* 客服弹窗样式 */
::v-deep .customer-service-dialog {
  .cs-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #323b5a;
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 15px;
  }
  .cs-dialog-header .el-icon-close {
    cursor: pointer;
    color: #a0a3b1;
    font-size: 18px;
  }
  .cs-dialog-content {
    text-align: center;
    padding: 10px 0 20px;
  }
  .cs-dialog-content img {
    width: 200px;
    height: 200px;
    object-fit: contain;
    margin-bottom: 10px;
  }
  .cs-dialog-content p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
}
.browser-info {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 8px;
  margin: 10px auto;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  .info-left {
    flex: 1;
    text-align: left;
  }

  .info-title {
    font-size: 16px;
    font-weight: bold;
    color: #010100;
    margin-bottom: 10px;
  }

  .info-content {
    font-size: 14px;
    color: #474747;
    line-height: 1.8;
  }

  .offline-btn {
    color: #5255f7;
    font-weight: bold;
    flex-shrink: 0;
  }
}
.previewImgBox {
  width: 100%;
  height: 100%;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .inner-p-img {
    height: 600px;
    width: auto;
  }

  .closePImg {
    font-size: 40px;
    cursor: pointer;
    position: fixed;
    top: 40px;
    right: 40px;
    color: white;
  }
}
</style>
